class AccountQueryRequestDto {
  /** 账号集合 */
  accountColl = [];

  /** 状态：1启用 or 0停用 */
  status = undefined;
}

class AccountResponseDto {
  /** 支付宝公钥 */
  alipayKey = "";

  /** 账号，登录名 */
  appId = "";

  /** 账号，登录名 */
  appKey = "";

  /** 应用名称 */
  appName = "";

  /** 密码 secret/应用私钥 */
  appSecret = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 1:是 */
  deleted = undefined;

  /** 备注 */
  description = "";

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = false;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class AmazonDateRangeRulesRequestDto {
  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 系统定义分组(分sheet使用) */
  dateRangeTypeName = "";

  /** 删除标识 */
  deleted = undefined;

  /** 亚马逊日期范围报告描述 */
  description = "";

  /** 是否启用 0 否 1 是 */
  enabled = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 系统定义分组(TB使用) */
  tbDateRangeType = "";

  /** 亚马逊日期范围报告type */
  type = "";

  /** 修改人 */
  updateBy = "";

  /** 更新人名称 */
  updateByName = "";

  /** 修改时间 */
  updateTime = "";
}

class AmazonDateRangeRulesResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 系统定义分组(分sheet使用) */
  dateRangeTypeName = "";

  /** 删除标识 */
  deleted = undefined;

  /** 亚马逊日期范围报告描述 */
  description = "";

  /** 是否启用 0 否 1 是 */
  enabled = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 系统定义分组(TB使用) */
  tbDateRangeType = "";

  /** 亚马逊日期范围报告type */
  type = "";

  /** 修改人 */
  updateBy = "";

  /** 更新人名称 */
  updateByName = "";

  /** 修改时间 */
  updateTime = "";
}

class AppAccountRequestDto {
  /** pageInfo */
  pageInfo = new EbsPageInfo();

  /** pqueryInfo */
  pqueryInfo = new PQueryInfo();
}

class AppAccountRequestParamsDto {
  /** 账号(API Key) */
  appKey = "";

  /** 应用名称 */
  appName = "";

  /** API 密钥 */
  appSecret = "";

  /** 应用状态（如jd,taobao） */
  appType = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 创建时间开始时间 */
  createTimeGe = "";

  /** 创建时间结束时间 */
  createTimeLe = "";

  /** 删除标识 0:否 1:是 */
  deleted = undefined;

  /** 备注 */
  description = "";

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class AppAccountResponseDto {
  /** 账号(API Key) */
  appKey = "";

  /** 应用名称 */
  appName = "";

  /** API 密钥 */
  appSecret = "";

  /** 应用状态（如jd,taobao） */
  appType = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 1:是 */
  deleted = undefined;

  /** 备注 */
  description = "";

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class AppAccountResponseRpcDto {
  /** 授权令牌 */
  accessToken = "";

  /** 应用账号表id */
  accountId = undefined;

  /** 账号(API Key) */
  appKey = "";

  /** 应用名称 */
  appName = "";

  /** API 密钥 */
  appSecret = "";

  /** 应用类型（如jd,taobao） */
  appType = "";

  /** 备注 */
  description = "";

  /** 刷新令牌 */
  refreshToken = "";

  /** 关联表id */
  relevanceId = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;
}

class ApprovalBeforeRequestDto {
  /** 业务Key，例如盘点单号 */
  businessKey = "";

  /** 页大小 */
  pageNumber = undefined;

  /** 页号 */
  pageSize = undefined;

  /** 流程定义key,盘点：InventoryApproval */
  processKey = "";
}

class ApprovalRequestDto {
  /** 审批状态：待提交：-1，已驳回：0；已通过<流程结束传>：1；审批中<只要流程没结束都是传该状态>：2；已撤回：3 ；已挂起：4；已删除：5；流程终止：-2 */
  approvalStatus = undefined;

  /** 审批意见 */
  approvalSug = "";

  /** 审批流程号 */
  businessKey = "";

  /** 表单数据 */
  formData = undefined;

  /** 本次操作 */
  operateTaskDto = new CurrentTaskDto();

  /** 流程实例id */
  processInstanceId = "";

  /** 流程定义key */
  processKey = "";

  /** 是否需要开启审批流 */
  startApproval = false;

  /** 驳回目标节点 */
  taskDto = new TaskDto();
}

class AssigneeDto {
  /** 操作人内部编号 */
  userCode = "";

  /** 操作人名称 */
  userName = "";
}

class AssociatedFilesDto {
  /** 附件名称 */
  fileName = "";

  /** 附件地址 */
  fileUrl = "";
}

class AssociatedFilesRequestDto {
  /** 文件类型 */
  fileCategory = "";

  /** 附件名称 */
  fileName = "";

  /** 附件地址 */
  fileUrl = "";

  /** 来源标识 */
  sourceId = "";
}

class AssociatedFilesResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 文件类型 */
  fileCategory = "";

  /** 文件名称 */
  fileName = "";

  /** 文件地址 */
  fileUrl = "";

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 来源标识 */
  sourceId = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AuthorizationRecordRequestDto {
  /** 是否审批 0 否 1 是 */
  approvalFlag = undefined;

  /** 授权附件，附件（多个），非必填 */
  authorizationAttachments = "";

  /** 授权金额币种 */
  authorizationCurrency = "";

  /** 授权说明 */
  authorizationDescription = "";

  /** 授权结束时间 */
  authorizationEndTime = "";

  /** 授权最大金额 */
  authorizationMaxAmount = undefined;

  /** 授权节点 */
  authorizationNode = "";

  /** 授权流程 */
  authorizationProcess = "";

  /** 授权开始时间 */
  authorizationStartTime = "";

  /** 授权代理人 */
  authorizedAgent = "";

  /** 授权人 */
  authorizer = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 启用状态 0 否 1 是 */
  enableStatus = undefined;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class AuthorizationRecordRequestParamsDto {
  /** 授权附件，附件（多个），非必填 */
  authorizationAttachments = "";

  /** 授权金额币种 */
  authorizationCurrency = "";

  /** 授权说明 */
  authorizationDescription = "";

  /** 授权结束时间 */
  authorizationEndTime = "";

  /** 授权最大金额 */
  authorizationMaxAmount = undefined;

  /** 授权最大金额 */
  authorizationMinAmount = undefined;

  /** 授权节点 */
  authorizationNode = "";

  /** 授权流程 */
  authorizationProcess = "";

  /** 授权开始时间 */
  authorizationStartTime = "";

  /** 授权代理人 */
  authorizedAgent = "";

  /** 授权人 */
  authorizer = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 启用状态 0 否 1 是 */
  enableStatus = "";

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class AuthorizationRecordRequestParamsRpcDto {
  /** 申请金额 */
  amount = undefined;

  /** 授权节点 */
  authorizationNode = "";

  /** 授权流程 */
  authorizationProcess = "";

  /** 授权人 */
  authorizer = "";

  /** 单据号 */
  businessNo = "";

  /** 申请币种 */
  currency = "";
}

class AuthorizationRecordResponseDto {
  /** 是否审批 0 否 1 是 */
  approvalFlag = undefined;

  /** 授权附件，附件（多个），非必填 */
  authorizationAttachments = "";

  /** 授权金额币种 */
  authorizationCurrency = "";

  /** 授权说明 */
  authorizationDescription = "";

  /** 授权结束时间 */
  authorizationEndTime = "";

  /** 授权最大金额 */
  authorizationMaxAmount = undefined;

  /** 授权节点 */
  authorizationNode = "";

  /** 授权流程 */
  authorizationProcess = "";

  /** 授权开始时间 */
  authorizationStartTime = "";

  /** 授权代理人 */
  authorizedAgent = "";

  /** 授权人 */
  authorizer = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 启用状态 0 否 1 是 */
  enableStatus = undefined;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class AuthorizationRecordResponseRpcDto {
  /** 是否审批 0 否 1 是 */
  approvalFlag = undefined;

  /** 授权金额币种 */
  authorizationCurrency = "";

  /** 授权结束时间 */
  authorizationEndTime = "";

  /** 授权最大金额 */
  authorizationMaxAmount = undefined;

  /** 授权节点 */
  authorizationNode = "";

  /** 授权流程 */
  authorizationProcess = "";

  /** 授权开始时间 */
  authorizationStartTime = "";

  /** 授权代理人 */
  authorizedAgent = "";

  /** 授权人 */
  authorizer = "";

  /** 单据号 */
  businessNo = "";

  /** 启用状态 0 否 1 是 */
  enableStatus = undefined;

  /** 汇率 */
  exchangeRate = undefined;

  /** 转换汇率后金额 */
  exchangeRateAmount = undefined;

  /** id */
  id = undefined;
}

class BankAccountNumRequest {
  /** 银行账户开户人 */
  accountOwnerParty = "";

  /** 账号 */
  bankAccountNum = "";

  /** 币种 */
  currencyCode = "";
}

class BankInfoRequest {
  /** 账户性质 */
  accountNature = "";

  /** 银行账户开户人 */
  accountOwnerParty = "";

  /** 付款标识 */
  apUseAllowedFlag = "";

  /** 收款标识 */
  arUseAllowedFlag = "";

  /** 银行账户唯一标识 */
  bankAccountId = "";

  /** 帐户名 */
  bankAccountName = "";

  /** 账号 */
  bankAccountNum = "";

  /** 分行名称 */
  bankBranchName = "";

  /** 分行编号 */
  bankBranchNum = "";

  /** 银行名称 */
  bankName = "";

  /** 银行编号 */
  bankNum = "";

  /** 市 */
  city = "";

  /** 企业号 */
  companyNumber = "";

  /** 币种 */
  currencyCode = "";

  /** 是否支持cbs付款,0为否,1为是 */
  enableCbs = undefined;

  /** 失效日期 */
  endDateActive = "";

  /** 失效日期 */
  endDateActiveFrom = "";

  /** 失效日期 */
  endDateActiveTo = "";

  /** id */
  id = undefined;

  /** 允许多币种 */
  multiCurrency = "";

  /** 访问组织 */
  orgName = "";

  /** 访问组织编号 */
  orgNum = "";

  /** 省 */
  province = "";

  /** 启用日期 */
  startDateActive = "";

  /** 启用日期 */
  startDateActiveFrom = "";

  /** 启用日期 */
  startDateActiveTo = "";

  /** 是否支持票据支付（0-不支持，1-支持） */
  supportBillPayment = undefined;

  /** 国家 */
  territoryShortName = "";
}

class BankInfoRequestParamsDto {
  /** 账户性质 */
  accountNature = "";

  /** 银行账户开户人 */
  accountOwnerParty = "";

  /** 付款标识 */
  apUseAllowedFlag = "";

  /** 收款标识 */
  arUseAllowedFlag = "";

  /** 银行账户唯一标识 */
  bankAccountId = "";

  /** 帐户名 */
  bankAccountName = "";

  /** 账号 */
  bankAccountNum = "";

  /** 分行名称 */
  bankBranchName = "";

  /** 分行编号 */
  bankBranchNum = "";

  /** 银行名称 */
  bankName = "";

  /** 银行编号 */
  bankNum = "";

  /** 开户市 */
  city = "";

  /** 企业号 */
  companyNumber = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currencyCode = "";

  /** 删除标识 0:否 1:是 */
  deleted = undefined;

  /** 是否支持cbs付款,0为否,1为是 */
  enableCbs = undefined;

  /** 失效日期 */
  endDateActive = "";

  /** 乐观锁 */
  lockVersion = undefined;

  /** 允许多币种 */
  multiCurrency = "";

  /** 访问组织 */
  orgName = "";

  /** 访问组织编号 */
  orgNum = "";

  /** 开户省 */
  province = "";

  /** 启用日期 */
  startDateActive = "";

  /** 创建时间-结束 */
  startDateActiveEnd = "";

  /** 创建时间-开始 */
  startDateActiveStart = "";

  /** 是否支持票据支付（0-不支持，1-支持） */
  supportBillPayment = undefined;

  /** 国家 */
  territoryShortName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class BankInfoResponse {
  /** 科目段 */
  accountCode = "";

  /** 账户性质 */
  accountNature = "";

  /** 银行账户开户人 */
  accountOwnerParty = "";

  /** 付款标识 */
  apUseAllowedFlag = "";

  /** 收款标识 */
  arUseAllowedFlag = "";

  /** 银行账户唯一标识 */
  bankAccountId = "";

  /** 帐户名 */
  bankAccountName = "";

  /** 账号 */
  bankAccountNum = "";

  /** 分行名称 */
  bankBranchName = "";

  /** 分行编号 */
  bankBranchNum = "";

  /** 银行名称 */
  bankName = "";

  /** 银行编号 */
  bankNum = "";

  /** 开户市 */
  city = "";

  /** 企业号 */
  companyNumber = "";

  /** 币种 */
  currencyCode = "";

  /** 是否支持cbs付款,0为否,1为是 */
  enableCbs = undefined;

  /** 失效日期 */
  endDateActive = "";

  /** id */
  id = undefined;

  /** 允许多币种 */
  multiCurrency = "";

  /** 访问组织 */
  orgName = "";

  /** 访问组织编号 */
  orgNum = "";

  /** 开户省 */
  province = "";

  /** 启用日期 */
  startDateActive = "";

  /** 子目段 */
  subaccountCode = "";

  /** 是否支持票据支付（0-不支持，1-支持） */
  supportBillPayment = undefined;

  /** 国家 */
  territoryShortName = "";
}

class BankInfoResponseDto {
  /** 科目段 */
  accountCode = "";

  /** 账户性质 */
  accountNature = "";

  /** 银行账户开户人 */
  accountOwnerParty = "";

  /** 付款标识 */
  apUseAllowedFlag = "";

  /** 收款标识 */
  arUseAllowedFlag = "";

  /** 银行账户唯一标识 */
  bankAccountId = "";

  /** 帐户名 */
  bankAccountName = "";

  /** 账号 */
  bankAccountNum = "";

  /** 分行名称 */
  bankBranchName = "";

  /** 分行编号 */
  bankBranchNum = "";

  /** 银行名称 */
  bankName = "";

  /** 银行编号 */
  bankNum = "";

  /** 开户市 */
  city = "";

  /** 企业号 */
  companyNumber = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currencyCode = "";

  /** 删除标识 0:否 1:是 */
  deleted = undefined;

  /** 是否支持cbs付款,0为否,1为是 */
  enableCbs = undefined;

  /** 失效日期 */
  endDateActive = "";

  /** 乐观锁 */
  lockVersion = undefined;

  /** 允许多币种 */
  multiCurrency = "";

  /** 访问组织 */
  orgName = "";

  /** 访问组织编号 */
  orgNum = "";

  /** 开户省 */
  province = "";

  /** 启用日期 */
  startDateActive = "";

  /** 子目段 */
  subaccountCode = "";

  /** 是否支持票据支付（0-不支持，1-支持） */
  supportBillPayment = undefined;

  /** 国家 */
  territoryShortName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class BaseAreaRequestDto {
  /** 区县代码 */
  areaCode = "";

  /** 区县中文名称 */
  areaNameCn = "";

  /** 区县英文名称 */
  areaNameEn = "";

  /** 城市代码 */
  cityCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 国家二字码 */
  secondWord = "";

  /** 州省代码 */
  stateCode = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseAreaResponseDto {
  /** 区县代码 */
  areaCode = "";

  /** 区县中文名称 */
  areaNameCn = "";

  /** 区县英文名称 */
  areaNameEn = "";

  /** 城市代码 */
  cityCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 国家二字码 */
  secondWord = "";

  /** 州省代码 */
  stateCode = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseCityModel {
  /** 城市代码 */
  cityCode = "";

  /** 城市中文名称 */
  cityNameCn = "";

  /** 城市英文名称 */
  cityNameEn = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 国家二字码 */
  secondWord = "";

  /** 洲（省）代码 */
  stateCode = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseCityRequestDto {
  /** 城市代码 */
  cityCode = "";

  /** 城市中文名称 */
  cityNameCn = "";

  /** 城市英文名称 */
  cityNameEn = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 国家二字码 */
  secondWord = "";

  /** 洲（省）代码 */
  stateCode = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseCityRequestParamsDto {
  /** 城市代码 */
  cityCode = "";

  /** 城市中文名称 */
  cityNameCn = "";

  /** 城市英文名称 */
  cityNameEn = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 国家二字码 */
  secondWord = "";

  /** 洲（省）代码 */
  stateCode = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseCityResponseDto {
  /** 区县 */
  areaList = [];

  /** 城市代码 */
  cityCode = "";

  /** 城市中文名称 */
  cityNameCn = "";

  /** 城市英文名称 */
  cityNameEn = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 国家二字码 */
  secondWord = "";

  /** 洲（省）代码 */
  stateCode = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseCountryModel {
  /** 大洲 */
  continent = "";

  /** 中文名称 */
  countryNameCn = "";

  /** 英文名称 */
  countryNameEn = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 数字码 */
  digitalCode = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 二字码 */
  secondWord = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 三字码 */
  threeWord = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseCountryRequestDto {
  /** 大洲 */
  continent = "";

  /** 中文名称 */
  countryNameCn = "";

  /** 英文名称 */
  countryNameEn = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 数字码 */
  digitalCode = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 二字码 */
  secondWord = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 三字码 */
  threeWord = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseCountryRequestParamsDto {
  /** 大洲 */
  continent = "";

  /** 中文名称 */
  countryNameCn = "";

  /** 英文名称 */
  countryNameEn = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 数字码 */
  digitalCode = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 二字码 */
  secondWord = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 三字码 */
  threeWord = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseCountryResponseDto {
  /** 大洲 */
  continent = "";

  /** 中文名称 */
  countryNameCn = "";

  /** 英文名称 */
  countryNameEn = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 数字码 */
  digitalCode = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 二字码 */
  secondWord = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 三字码 */
  threeWord = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseCountryTreeResponseDto {
  /** 大洲 */
  continent = "";

  /** 中文名称 */
  countryNameCn = "";

  /** 英文名称 */
  countryNameEn = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 数字码 */
  digitalCode = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 二字码 */
  secondWord = "";

  /** 洲（省） */
  stateList = [];

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 三字码 */
  threeWord = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseCountryTreeResponseRpcDto {
  /** 大洲 */
  continent = "";

  /** 中文名称 */
  countryNameCn = "";

  /** 英文名称 */
  countryNameEn = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 数字码 */
  digitalCode = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 二字码 */
  secondWord = "";

  /** 洲（省） */
  stateList = [];

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 三字码 */
  threeWord = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseDictionaryCreateDto {
  /** 属性名称 */
  attrKey = "";

  /** 属性排序 */
  attrSort = undefined;

  /** 属性值 */
  attrValue = "";

  /** 作为自定义字段 */
  customFields = "";

  /** 字典类型编码 */
  dicCode = "";

  /** 备注 */
  remark = "";
}

class BaseDictionaryEditDto {
  /** 属性名称 */
  attrKey = "";

  /** 属性排序 */
  attrSort = undefined;

  /** 属性值 */
  attrValue = "";

  /** 作为自定义字段 */
  customFields = "";

  /** 字典类型编码 */
  dicCode = "";

  /** 备注 */
  remark = "";
}

class BaseDictionaryQueryDto {
  /** 属性key */
  attrKey = "";

  /** 属性值 */
  attrValue = "";

  /** 当前页 */
  current = undefined;

  /** 自定义字段 */
  customFields = "";

  /** 字典编码 */
  dicCode = "";

  /** 字典名称 */
  dicName = "";

  /** 排序 */
  orderBy = "";

  /** 每页条数 */
  size = undefined;
}

class BaseDictionaryResponseDto {
  /** 属性key */
  attrKey = "";

  /** 属性排序 */
  attrSort = undefined;

  /** 属性值 */
  attrValue = "";

  /** 可用作自定义字段 */
  customFields = "";

  /** 字典编码 */
  dicCode = "";

  /** 字典名称 */
  dicName = "";

  /** 主键id */
  id = undefined;

  /** 备注 */
  remark = "";
}

class BaseDictionaryResponseRpcDto {
  /** 属性key */
  attrKey = "";

  /** 属性排序 */
  attrSort = undefined;

  /** 属性值 */
  attrValue = "";

  /** 可用作自定义字段 */
  customFields = "";

  /** 字典编码 */
  dicCode = "";

  /** 字典名称 */
  dicName = "";

  /** 备注 */
  remark = "";
}

class BaseStateModel {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 国家二字码 */
  secondWord = "";

  /** 洲（省）代码 */
  stateCode = "";

  /** 中文名称 */
  stateNameCn = "";

  /** 英文名称 */
  stateNameEn = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseStateRequestDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 国家二字码 */
  secondWord = "";

  /** 洲（省）编号 */
  stateCode = "";

  /** 中文名称 */
  stateNameCn = "";

  /** 英文名称 */
  stateNameEn = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseStateRequestParamsDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 国家二字码 */
  secondWord = "";

  /** 洲（省）代码 */
  stateCode = "";

  /** 中文名称 */
  stateNameCn = "";

  /** 英文名称 */
  stateNameEn = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseStateResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 国家二字码 */
  secondWord = "";

  /** 洲（省）代码 */
  stateCode = "";

  /** 中文名称 */
  stateNameCn = "";

  /** 英文名称 */
  stateNameEn = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseStateTreeResponseRpcDto {
  /** 城市 */
  cityList = [];

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 国家二字码 */
  secondWord = "";

  /** 洲（省）代码 */
  stateCode = "";

  /** 中文名称 */
  stateNameCn = "";

  /** 英文名称 */
  stateNameEn = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseUnitModel {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 计量单位简称 */
  unitAbbreviation = "";

  /** 计量单位名称（CN） */
  unitNameCn = "";

  /** 计量单位名称（EN） */
  unitNameEn = "";

  /** 计量单位编号 */
  unitNo = "";

  /** 单位类型编号 */
  unitTypeNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseUnitRequestDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 计量单位简称 */
  unitAbbreviation = "";

  /** 计量单位名称（CN） */
  unitNameCn = "";

  /** 计量单位名称（EN） */
  unitNameEn = "";

  /** 计量单位编号 */
  unitNo = "";

  /** 单位类型编号 */
  unitTypeNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseUnitRequestParamsDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 计量单位简称 */
  unitAbbreviation = "";

  /** 计量单位名称（CN） */
  unitNameCn = "";

  /** 计量单位名称（EN） */
  unitNameEn = "";

  /** 计量单位编号 */
  unitNo = "";

  /** 单位类型编号 */
  unitTypeNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseUnitResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 计量单位简称 */
  unitAbbreviation = "";

  /** 计量单位名称（CN） */
  unitNameCn = "";

  /** 计量单位名称（EN） */
  unitNameEn = "";

  /** 计量单位编号 */
  unitNo = "";

  /** 单位类型编号 */
  unitTypeNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseUnitTypeDetailsResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** currentUnit */
  currentUnit = new BaseUnitModel();

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 单位类型简称 */
  typeAbbreviation = "";

  /** 单位类型名称（CN） */
  typeNameCn = "";

  /** 单位类型名称（EN） */
  typeNameEn = "";

  /** unitList */
  unitList = [];

  /** 单位类型编号 */
  unitTypeNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseUnitTypeModel {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 单位类型简称 */
  typeAbbreviation = "";

  /** 单位类型名称（CN） */
  typeNameCn = "";

  /** 单位类型名称（EN） */
  typeNameEn = "";

  /** 单位类型编号 */
  unitTypeNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseUnitTypeRequestDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 单位类型简称 */
  typeAbbreviation = "";

  /** 单位类型名称（CN） */
  typeNameCn = "";

  /** 单位类型名称（EN） */
  typeNameEn = "";

  /** 单位类型编号 */
  unitTypeNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseUnitTypeRequestParamsDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 单位类型简称 */
  typeAbbreviation = "";

  /** 单位类型名称（CN） */
  typeNameCn = "";

  /** 单位类型名称（EN） */
  typeNameEn = "";

  /** 单位类型编号 */
  unitTypeNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BaseUnitTypeResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 单位类型简称 */
  typeAbbreviation = "";

  /** 单位类型名称（CN） */
  typeNameCn = "";

  /** 单位类型名称（EN） */
  typeNameEn = "";

  /** 单位类型编号 */
  unitTypeNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BatchAssociatedFilesRequestDto {
  /** 文件类型 */
  fileCategory = "";

  /** 附件 */
  files = [];

  /** 来源标识 */
  sourceId = "";
}

class BuSbuModel {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 名称 */
  name = "";

  /** 父级ID */
  parentId = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BuSbuRequestParamsDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 名称 */
  name = "";

  /** 父级ID */
  parentId = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BuSbuResponseDtoRpc {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 名称 */
  name = "";

  /** 父级ID */
  parentId = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class BusinessCustomerAccountDetailResponseDto {
  /** 客户付款账户名 */
  accountName = "";

  /** 客户付款银行账号 */
  accountNumber = "";

  /** 分行名称 */
  bankBranchName = "";

  /** 客户编号 */
  customerCode = "";

  /** 委托代付协议 */
  delegatedPaymentAgreement = "";

  /** 付款方式 1:信用证 2:银行转账 3:微信 4:支付宝 5:平台结算 */
  paymentType = undefined;
}

class BusinessCustomerAddOrUpdateAccountRequestDto {
  /** 客户付款账户名 */
  accountName = "";

  /** 客户付款银行账号 */
  accountNumber = "";

  /** 分行名称 */
  bankBranchName = "";

  /** 客户编号 */
  customerCode = "";

  /** 委托代付协议 */
  delegatedPaymentAgreement = "";

  /** 付款方式 1:信用证 2:银行转账 3:微信 4:支付宝 5:平台结算 */
  paymentType = undefined;
}

class BusinessCustomerAddOrUpdateReceivingAddressRequestDto {
  /** 城市编码 */
  cityCode = "";

  /** 国家编码 */
  countryCode = "";

  /** 客户编号 */
  customerCode = "";

  /** 详细地址 */
  fullAddress = "";

  /** 邮编 */
  postCode = "";

  /** 省份编码 */
  provinceCode = "";

  /** 收货联系人 */
  receiver = "";

  /** 收货人邮箱 */
  receiverEmail = "";

  /** 收货联系电话 */
  receiverPhone = "";

  /** 收货地址 */
  receivingAddress = "";
}

class BusinessCustomerAddOrUpdateTransactionCompanyRequestDto {
  /** 附件 */
  annexFile = "";

  /** 是否申请信保 */
  applyCreditInsurance = false;

  /** 尾款比例 */
  balanceRatio = undefined;

  /** 合同结束日期 */
  contractEndDate = "";

  /** 合同开始日期 */
  contractStartDate = "";

  /** 信保限额 */
  creditInsuranceLimit = undefined;

  /** 赊销额度账期 */
  creditSalesQuotaPeriod = undefined;

  /** 客户编号 */
  customerCode = "";

  /** 账期/天 */
  dayNumber = undefined;

  /** 定金比例 */
  depositRatio = undefined;

  /** 资金占用费比例 */
  fundOccupyRate = undefined;

  /** 限额账期 */
  quotaPeriod = undefined;

  /** 结算方式Code 1：账期 2：现结 */
  settlementCode = undefined;

  /** 税率 */
  taxRate = undefined;

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";
}

class BusinessCustomerApprovalPageListResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 客户编号 */
  customerCode = "";

  /** 工作流实例ID */
  instanceId = "";

  /** 状态 10：变更中 20：已变更 30 已取消 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class BusinessCustomerChangeDetailResponseDto {
  /** 修改后快照 */
  afterSnapshot = "";

  /** 修改前快照 */
  beforeSnapshot = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 客户编号 */
  customerCode = "";

  /** 客户名称 */
  customerName = "";

  /** 客户简称 */
  customerShortName = "";

  /** 工作流实例ID */
  instanceId = "";

  /** 状态 10：变更中 20：已变更 30 已取消 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class BusinessCustomerDetailResponseDto {
  /** 账号信息 */
  accountList = [];

  /** 地址、电话（发票专用） */
  addressAndPhone = "";

  /** 区域 */
  area = "";

  /** 开户行及账号（发票专用） */
  bankAndAccount = "";

  /** 联系人 */
  contact = "";

  /** 联系方式 */
  contactDetails = "";

  /** 国家名称 */
  country = "";

  /** 国家编码 */
  countryCode = "";

  /** 赊销额度 */
  creditLimit = undefined;

  /** 币种 */
  currency = "";

  /** 客户编号 */
  customerCode = "";

  /** 客户EORI */
  customerEori = "";

  /** 客户名称 */
  customerName = "";

  /** 客户简称 */
  customerShortName = "";

  /** 客户VAT */
  customerVat = "";

  /** 邮箱 */
  email = "";

  /** 是否包邮 1:是 0：否 */
  freeShipping = undefined;

  /** 详细地址 */
  fullAddress = "";

  /** 工作流实例ID */
  instanceId = "";

  /** 物流渠道 */
  logisticsChannel = "";

  /** 物流渠道编码 */
  logisticsChannelCode = "";

  /** 物流商 */
  logisticsCompany = "";

  /** 物流商编码 */
  logisticsCompanyCode = "";

  /** 国家类型：1:国内 2:国外 */
  overseasFlag = undefined;

  /** 客户归属渠道(平台) */
  ownershipChannel = "";

  /** 客户归属渠道(平台)key */
  ownershipChannelKey = "";

  /** 收货地址信息 */
  receivingAddressList = [];

  /** 备注 */
  remark = "";

  /** 销售负责人 */
  salesperson = "";

  /** 销售负责人姓名 */
  salespersonName = "";

  /** 贸易术语 */
  standardTradeTerms = "";

  /** 客户状态 1:启用 0：禁用 -1：未启用 */
  status = undefined;

  /** 纳税人识别号 */
  taxNumber = "";

  /** 交易主体合同信息 */
  transactionCompanyList = [];

  /** 客户类型 1:培训 2：批发 3:综合 4:零售 */
  type = undefined;
}

class BusinessCustomerListResponseDto {
  /** 收款信息 */
  accountList = [];

  /** 地址、电话（发票专用） */
  addressAndPhone = "";

  /** 区域 */
  area = "";

  /** 开户行及账号（发票专用） */
  bankAndAccount = "";

  /** 联系人 */
  contact = "";

  /** 联系方式 */
  contactDetails = "";

  /** 国家名称 */
  country = "";

  /** 国家编码 */
  countryCode = "";

  /** 赊销额度 */
  creditLimit = undefined;

  /** 币种 */
  currency = "";

  /** 客户编号 */
  customerCode = "";

  /** 客户EORI */
  customerEori = "";

  /** 客户名称 */
  customerName = "";

  /** 客户简称 */
  customerShortName = "";

  /** 客户VAT */
  customerVat = "";

  /** 邮箱 */
  email = "";

  /** 是否包邮 1:是 0：否 */
  freeShipping = undefined;

  /** 详细地址 */
  fullAddress = "";

  /** 物流渠道 */
  logisticsChannel = "";

  /** 物流渠道编码 */
  logisticsChannelCode = "";

  /** 物流商 */
  logisticsCompany = "";

  /** 物流商编码 */
  logisticsCompanyCode = "";

  /** 国家类型：1:国内 2:国外 */
  overseasFlag = undefined;

  /** 客户归属渠道(平台) */
  ownershipChannel = "";

  /** 客户归属渠道(平台)key */
  ownershipChannelKey = "";

  /** 收货地址信息 */
  receivingAddressList = [];

  /** 备注 */
  remark = "";

  /** 销售负责人 */
  salesperson = "";

  /** 跳过流程标识-内部使用 */
  skipProcessFlag = false;

  /** 贸易术语 */
  standardTradeTerms = "";

  /** 客户状态 1:启用 0：禁用 -1：未启用 */
  status = undefined;

  /** 纳税人识别号 */
  taxNumber = "";

  /** 交易主体合同信息 */
  transactionCompanyList = [];

  /** 客户类型 1:培训 2：批发 3:综合 4:零售 */
  type = undefined;
}

class BusinessCustomerListResponseDto0 {
  /** 地址、电话（发票专用） */
  addressAndPhone = "";

  /** 审核状态  -1:未提交审批 0:已驳回 1:已通过 2:审批中 */
  approvalStatus = undefined;

  /** 区域 */
  area = "";

  /** 开户行及账号（发票专用） */
  bankAndAccount = "";

  /** 联系人 */
  contact = "";

  /** 联系方式 */
  contactDetails = "";

  /** 国家名称 */
  country = "";

  /** 国家编码 */
  countryCode = "";

  /** 赊销额度 */
  creditLimit = undefined;

  /** 币种 */
  currency = "";

  /** 客户编号 */
  customerCode = "";

  /** 客户名称 */
  customerName = "";

  /** 邮箱 */
  email = "";

  /** 是否包邮 1:是 0：否 */
  freeShipping = undefined;

  /** 详细地址 */
  fullAddress = "";

  /** 工作流实例ID */
  instanceId = "";

  /** 国家类型：1:国内 2:国外 */
  overseasFlag = undefined;

  /** 客户归属渠道(平台) */
  ownershipChannel = "";

  /** 客户归属渠道(平台)key */
  ownershipChannelKey = "";

  /** 备注 */
  remark = "";

  /** 销售负责人 */
  salesperson = "";

  /** 客户状态 1:启用 0：禁用 -1：未启用 */
  status = undefined;

  /** 纳税人识别号 */
  taxNumber = "";

  /** 客户类型 1:培训 2：批发 3:综合 4:零售 */
  type = undefined;
}

class BusinessCustomerPageListResponseDto {
  /** 审核状态  -1:未提交审批 0:已驳回 1:已通过 2:审批中 */
  approvalStatus = undefined;

  /** 区域 */
  area = "";

  /** 联系人 */
  contact = "";

  /** 联系方式 */
  contactDetails = "";

  /** 国家名称 */
  country = "";

  /** 国家编码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 客户编号 */
  customerCode = "";

  /** 客户名称 */
  customerName = "";

  /** 客户简称 */
  customerShortName = "";

  /** 工作流实例ID */
  instanceId = "";

  /** 下个处理人/角色 */
  nextApproval = "";

  /** 销售负责人 */
  salesperson = "";

  /** 结算方式Code 1：账期 2：现结 */
  settlementCode = undefined;

  /** 客户状态 1:启用 0：禁用 -1：未启用 */
  status = undefined;

  /** 税率 */
  taxRate = undefined;

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 更新时间 */
  updateTime = "";
}

class BusinessCustomerReceivingAddressDetailResponseDto {
  /** 城市编码 */
  cityCode = "";

  /** 国家名称 */
  country = "";

  /** 国家编码 */
  countryCode = "";

  /** 客户编号 */
  customerCode = "";

  /** 详细地址 */
  fullAddress = "";

  /** 邮编 */
  postCode = "";

  /** 省份编码 */
  provinceCode = "";

  /** 收货联系人 */
  receiver = "";

  /** 收货人邮箱 */
  receiverEmail = "";

  /** 收货联系电话 */
  receiverPhone = "";

  /** 收货地址 */
  receivingAddress = "";
}

class BusinessCustomerTransactionCompanyDetailResponseDto {
  /** 附件 */
  annexFile = "";

  /** 是否申请信保 */
  applyCreditInsurance = false;

  /** 尾款比例 */
  balanceRatio = undefined;

  /** 合同结束日期 */
  contractEndDate = "";

  /** 合同开始日期 */
  contractStartDate = "";

  /** 信保限额 */
  creditInsuranceLimit = undefined;

  /** 赊销额度账期 */
  creditSalesQuotaPeriod = undefined;

  /** 客户编号 */
  customerCode = "";

  /** 账期/天 */
  dayNumber = undefined;

  /** depositRatio */
  depositRatio = undefined;

  /** 资金占用费比例 */
  fundOccupyRate = undefined;

  /** 限额账期 */
  quotaPeriod = undefined;

  /** settlementCode */
  settlementCode = undefined;

  /** 税率 */
  taxRate = undefined;

  /** 交易主体编号 */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";
}

class CenterCountyMappingRequestDto {
  /** 区域 */
  area = "";

  /** centerId */
  centerId = "";

  /** 国家简码 */
  countyCode = "";

  /** id */
  id = undefined;

  /** 邮编 */
  postCode = "";

  /** shipTo */
  shipTo = "";

  /** 状态 1: 启用 0: 禁用 */
  status = undefined;

  /** 类型 10: FBA 20: WFS */
  type = undefined;

  /** 类型 10: 大货仓 20: 小货仓 */
  warehouseType = undefined;
}

class CenterCountyMappingRequestParamsDto {
  /** centerId */
  centerId = "";

  /** 国家简码 */
  countyCode = "";

  /** 状态 1: 启用 0: 禁用 */
  status = undefined;

  /** 类型 10: FBA 20: WFS */
  type = undefined;
}

class CenterCountyMappingResponseDto {
  /** 区域 */
  area = "";

  /** centerId */
  centerId = "";

  /** 国家简码 */
  countyCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 邮编 */
  postCode = "";

  /** shipTo */
  shipTo = "";

  /** 状态 0禁用 1启用 */
  status = undefined;

  /** 类型 10: FBA 20: WFS */
  type = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 类型 10: 大货仓 20: 小货仓 */
  warehouseType = undefined;
}

class CertBatteryRequestDto {
  /** 电池种类：1-锂电池 2-干电池 3-铅酸电池 4-碳锌电池 5-锌锰电池 */
  batteryCategory = undefined;

  /** 电池/电池组数量 */
  batteryCount = undefined;

  /** 电池型号 */
  batteryModel = "";

  /** 电池部位: 1-产品主体 2-配件-调音器 3-配件-音箱 4-配件-遥控器 5-配件-充电盒 6-配件-麦克风 7-其他 */
  batteryPosition = undefined;

  /** 电池容量(mAh) */
  capacityMah = undefined;

  /** 电芯/电池组：0-电芯 1-电池组 */
  cellType = undefined;

  /** 电池图片列表 */
  certBatteryPictureList = [];

  /** 认证文件列表 */
  certFileList = [];

  /** 电池内置/外置：1-单独包装 2-装于设备内 3-与货物包装在一起 */
  installType = undefined;

  /** 电芯/电池/电池组备注 */
  remark = "";

  /** UN编号 */
  unCode = "";

  /** 电池电压(V) */
  voltageV = undefined;
}

class CertBatteryResponseDto {
  /** 电池种类：1-锂电池 2-干电池 3-铅酸电池 4-碳锌电池 5-锌锰电池 */
  batteryCategory = undefined;

  /** 电池/电池组数量 */
  batteryCount = undefined;

  /** 电池型号 */
  batteryModel = "";

  /** 电池部位: 1-产品主体 2-配件-调音器 3-配件-音箱 4-配件-遥控器 5-配件-充电盒 6-配件-麦克风 7-其他 */
  batteryPosition = undefined;

  /** 电池容量(mAh) */
  capacityMah = undefined;

  /** 电芯/电池组：0-电芯 1-电池组 */
  cellType = undefined;

  /** 认证电池图片列表 */
  certBatteryPictureList = [];

  /** 认证文件列表 */
  certFileList = [];

  /** 认证主表ID */
  certId = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = false;

  /** 主键ID */
  id = undefined;

  /** 电池内置/外置：1-单独包装 2-装于设备内 3-与货物包装在一起 */
  installType = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 电芯/电池/电池组备注 */
  remark = "";

  /** UN编号 */
  unCode = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 电池电压(V) */
  voltageV = undefined;
}

class CertFileRequestDto {
  /** 文件类型（如：MSDS、海运报告、空运报告…） */
  fileType = undefined;

  /** 文件链接 */
  link = "";

  /** 有效期开始 */
  validFrom = "";

  /** 有效期结束 */
  validTo = "";
}

class CertFileResponseDto {
  /** 电池ID */
  batteryId = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = false;

  /** 文件类型（如：MSDS、海运报告、空运报告…） */
  fileType = undefined;

  /** id */
  id = undefined;

  /** 文件链接 */
  link = "";

  /** 版本号 */
  lockVersion = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 有效期开始 */
  validFrom = "";

  /** 有效期结束 */
  validTo = "";
}

class CertMainInfoRequestDto {
  /** 审批状态,-1：待提交、0:审批驳回 1:审批通过 2：审批中 */
  approvalStatus = undefined;

  /** 电池信息列表 */
  batteryList = [];

  /** 认证类型：0-带电认证 1-产品认证 */
  certType = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 主键ID */
  id = undefined;

  /** 审批实例ID */
  instanceId = "";

  /** 绑定的SKU列表 */
  skuList = [];

  /** 供应商Code */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class CertMainRequestDto {
  /** 电池信息列表 */
  batteryList = [];

  /** 认证类型：0-带电认证 1-产品认证 */
  certType = undefined;

  /** 主键ID */
  id = undefined;

  /** 绑定的SKU列表 */
  skuList = [];

  /** 供应商Code */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";
}

class CertMainResponseDto {
  /** 审批状态,-1：待提交、0:审批驳回 1:审批通过 2：审批中 */
  approvalStatus = undefined;

  /** 认证类型：0-带电认证 1-产品认证 */
  certType = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 主键ID */
  id = undefined;

  /** 审批实例ID */
  instanceId = "";

  /** 绑定的SKU编号 */
  skuNoList = "";

  /** 供应商Code */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class CertMainSkuRequestDto {
  /** 绑定的SKU编号 */
  skuNo = "";
}

class CertMainSkuResponseDto {
  /** 认证主表ID */
  certId = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = false;

  /** 主键ID */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 绑定的SKU编号 */
  skuNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class CertPictureResponseDto {
  /** 文件名称 */
  fileName = "";

  /** 文件地址 */
  fileUrl = "";
}

class CertPictureResponseDto0 {
  /** 文件名称 */
  fileName = "";

  /** 文件地址 */
  fileUrl = "";
}

class CertificationDocumentAddAndModifyRequestDto {
  /** 电池信息 */
  batteryRequestDto = new CertificationDocumentBatteryAddAndModifyRequestDto();

  /** 生效结束日期 */
  expirationEndDate = "";

  /** 生效开始日期 */
  expirationStartDate = "";

  /** 文件 */
  file = "";

  /** 文件状态, 0:停用, 1:启用 */
  fileStatus = undefined;

  /** 文件类型 */
  fileType = "";

  /** id */
  id = undefined;

  /** SKU列表 */
  skuNoList = [];

  /** 供应商Code */
  supplierCode = "";
}

class CertificationDocumentBatteryAddAndModifyRequestDto {
  /** 电池属性 */
  attribute = "";

  /** 电池容量(mAh) */
  capacity = undefined;

  /** 电池类型, 1.电芯, 2.电池包 */
  category = undefined;

  /** 图片 */
  image = "";

  /** 电池型号 */
  model = "";

  /** 电池部位, 1.产品主体, 2.配件 */
  part = undefined;

  /** 电池位置, 1.内置, 2.外置 */
  position = undefined;

  /** 电池/电池包数量 */
  qty = undefined;

  /** 电芯/电池/电池组备注解释 */
  remark = "";

  /** UN编号 */
  unCode = "";

  /** 电池电压(V) */
  voltage = undefined;
}

class CertificationDocumentDetailResponseDto {
  /** 电池属性 */
  attribute = "";

  /** 电池容量(mAh) */
  capacity = undefined;

  /** 电芯/电池包, 1.电芯, 2.电池包 */
  category = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 有效期结束日期 */
  expirationEndDate = "";

  /** 有效期开始日期 */
  expirationStartDate = "";

  /** 报告文件 */
  file = "";

  /** 状态, 0:停用, 1:启用 */
  fileStatus = undefined;

  /** 认证报告种类 */
  fileType = undefined;

  /** id */
  id = undefined;

  /** 图片 */
  image = "";

  /** 电池型号 */
  model = "";

  /** 电池部位, 1.产品主体, 2.配件 */
  part = undefined;

  /** 电池内置/外置, 1.内置, 2.外置 */
  position = undefined;

  /** 电池/电池包数量 */
  qty = undefined;

  /** 电芯/电池/电池组备注解释 */
  remark = "";

  /** 关联SKU */
  skuNoList = "";

  /** 关联供应商Code */
  supplierCode = "";

  /** 关联供应商名称 */
  supplierName = "";

  /** UN编号 */
  unCode = "";

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 电池电压(V) */
  voltage = undefined;
}

class CertificationDocumentListResponseDto {
  /** 文件类型列表-key: name, value: code */
  fileTypeMap = undefined;

  /** SKU列表 */
  skuNoList = [];

  /** 供应商Code列表-key: name, value: code */
  supplierMap = undefined;
}

class CertificationDocumentPageResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 生效结束日期 */
  expirationEndDate = "";

  /** 生效开始日期 */
  expirationStartDate = "";

  /** 文件 */
  file = "";

  /** 文件状态, 0:停用, 1:启用 */
  fileStatus = undefined;

  /** 文件类型 */
  fileType = "";

  /** id */
  id = undefined;

  /** 关联SKU */
  skuNoList = "";

  /** 供应商Code */
  supplierCode = "";

  /** 供应商名称 */
  supplierName = "";

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class CorpsInfoRequestDto {
  /** 一级品类名称 */
  categoryName = "";

  /** 军团长code */
  commanderCode = "";

  /** 军团长名字 */
  commanderName = "";

  /** 军团名称 */
  corpsName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 财务bp编码 */
  financeBpCode = "";

  /** 财务bp名字 */
  financeBpName = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 运营对接人编码 */
  operatorCode = "";

  /** 运营对接人名字 */
  operatorName = "";

  /** 一级类目编号 */
  primaryProductLine = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class CorpsInfoResponseDto {
  /** 一级品类名称 */
  categoryName = "";

  /** 军团长code */
  commanderCode = "";

  /** 军团长名字 */
  commanderName = "";

  /** 军团名称 */
  corpsName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 财务bp编码 */
  financeBpCode = "";

  /** 财务bp名字 */
  financeBpName = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 运营对接人编码 */
  operatorCode = "";

  /** 运营对接人名字 */
  operatorName = "";

  /** 一级类目编号 */
  primaryProductLine = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class CostCenterAddOrUpdateRequestParamsDto {
  /** 编号 */
  code = "";

  /** 负责人编号 */
  headCode = "";

  /** 名称 */
  name = "";

  /** 状态 1:启用 0:禁用 */
  status = undefined;

  /** 类型 */
  type = "";
}

class CostCenterListResponseDto {
  /** 编号 */
  code = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 负责人编号 */
  headCode = "";

  /** 名称 */
  name = "";

  /** 状态 1:启用 0:禁用 */
  status = undefined;

  /** 类型 */
  type = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class CostCenterListRpcRequestDto {
  /** 编号列表 */
  codes = [];

  /** 创建人 */
  createBy = "";

  /** 创建日期-结束 */
  createTimeEnd = "";

  /** 创建日期-开始 */
  createTimeStart = "";

  /** 负责人编号列表 */
  headCodes = [];

  /** 名称列表 */
  names = [];

  /** 状态 1:启用 0:禁用 不传默认是启用 */
  status = undefined;

  /** 类型 */
  type = "";

  /** 更新人 */
  updateBy = "";

  /** 更新日期-结束 */
  updateTimeEnd = "";

  /** 更新日期-开始 */
  updateTimeStart = "";
}

class CostItemMappingRequestDto {
  /** 渠道辅助段 */
  channelAuxiliarySegment = "";

  /** 成本中心属性 */
  costCenterAttribute = "";

  /** 费用类型明细 */
  costDetail = "";

  /** 费用类型明细定义 */
  costDetailDefinition = "";

  /** 费用项编码 */
  costItemCode = "";

  /** 费用类别 */
  costType = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 是否核算部门段 */
  departmentSegment = "";

  /** 是否启用 0 否 1 是 */
  enabled = undefined;

  /** id */
  id = undefined;

  /** 是否合算内部往来段 */
  internalTransactionSegment = "";

  /** 是否对公支付 */
  isPublic = "";

  /** 负债科目编码 */
  liabilityCode = "";

  /** 负债科目名称 */
  liabilityName = "";

  /** 是否过负债科目 */
  liabilitySubjectIndicator = "";

  /** 是否核算平台段 */
  platformSegment = "";

  /** 预付科目编码 */
  prepaymentCode = "";

  /** 预付科目名称 */
  prepaymentName = "";

  /** 流程类型 */
  processType = "";

  /** 费用科目编码 */
  subjectsCode = "";

  /** 费用科目名称 */
  subjectsName = "";

  /** 是否核算子目段 */
  subsidiarySegmentIndicator = "";

  /** 是否挂供应商 */
  supplierIndicator = "";

  /** TMS辅助段 */
  tmsAuxiliarySegment = "";

  /** 转入方科目编码 */
  transferInCode = "";

  /** 转入方科目名称 */
  transferInName = "";

  /** 转出方科目编码 */
  transferOutCode = "";

  /** 转出方科目名称 */
  transferOutName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class CostItemMappingRequestParamsDto {
  /** 渠道辅助段 */
  channelAuxiliarySegment = "";

  /** 成本中心属性 */
  costCenterAttribute = "";

  /** 费用类型明细 */
  costDetail = "";

  /** 费用类型明细定义 */
  costDetailDefinition = "";

  /** 费用项编码 */
  costItemCode = "";

  /** 费用类别 */
  costType = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 是否核算部门段 */
  departmentSegment = "";

  /** 是否启用 0 否 1 是 */
  enabled = undefined;

  /** id */
  id = undefined;

  /** 是否合算内部往来段 */
  internalTransactionSegment = "";

  /** 是否对公支付 */
  isPublic = "";

  /** 负债科目编码 */
  liabilityCode = "";

  /** 负债科目名称 */
  liabilityName = "";

  /** 是否过负债科目 */
  liabilitySubjectIndicator = "";

  /** 是否核算平台段 */
  platformSegment = "";

  /** 预付科目编码 */
  prepaymentCode = "";

  /** 预付科目名称 */
  prepaymentName = "";

  /** 流程类型 */
  processType = "";

  /** 费用科目编码 */
  subjectsCode = "";

  /** 费用科目名称 */
  subjectsName = "";

  /** 是否核算子目段 */
  subsidiarySegmentIndicator = "";

  /** 是否挂供应商 */
  supplierIndicator = "";

  /** TMS辅助段 */
  tmsAuxiliarySegment = "";

  /** 转入方科目编码 */
  transferInCode = "";

  /** 转入方科目名称 */
  transferInName = "";

  /** 转出方科目编码 */
  transferOutCode = "";

  /** 转出方科目名称 */
  transferOutName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class CostItemMappingRequestRpcDto {
  /** 渠道辅助段 */
  channelAuxiliarySegment = "";

  /** 成本中心属性 */
  costCenterAttribute = "";

  /** 费用类型明细 */
  costDetail = "";

  /** 费用项编码 */
  costItemCode = "";

  /** 费用类别 */
  costType = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 是否核算部门段 */
  departmentSegment = "";

  /** 是否启用 0 否 1 是 */
  enabled = undefined;

  /** id */
  id = undefined;

  /** 是否合算内部往来段 */
  internalTransactionSegment = "";

  /** 是否对公支付 */
  isPublic = "";

  /** 负债科目编码 */
  liabilityCode = "";

  /** 负债科目名称 */
  liabilityName = "";

  /** 是否过负债科目 */
  liabilitySubjectIndicator = "";

  /** 是否核算平台段 */
  platformSegment = "";

  /** 预付科目编码 */
  prepaymentCode = "";

  /** 预付科目名称 */
  prepaymentName = "";

  /** 流程类型 */
  processType = "";

  /** 费用科目编码 */
  subjectsCode = "";

  /** 费用科目名称 */
  subjectsName = "";

  /** 是否核算子目段 */
  subsidiarySegmentIndicator = "";

  /** 是否挂供应商 */
  supplierIndicator = "";

  /** TMS辅助段 */
  tmsAuxiliarySegment = "";

  /** 转入方科目编码 */
  transferInCode = "";

  /** 转入方科目名称 */
  transferInName = "";

  /** 转出方科目编码 */
  transferOutCode = "";

  /** 转出方科目名称 */
  transferOutName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class CostItemMappingRequestRpcParamsDto {
  /** 渠道辅助段 */
  channelAuxiliarySegment = "";

  /** 成本中心属性 */
  costCenterAttribute = "";

  /** 费用类型明细 */
  costDetail = "";

  /** 费用类型明细定义 */
  costDetailDefinition = "";

  /** 费用项编码 */
  costItemCode = "";

  /** 费用类别 */
  costType = "";

  /** 是否核算部门段 */
  departmentSegment = "";

  /** 是否启用 0 否 1 是 */
  enabled = undefined;

  /** 是否合算内部往来段 */
  internalTransactionSegment = "";

  /** 是否对公支付 */
  isPublic = "";

  /** 负债科目编码 */
  liabilityCode = "";

  /** 负债科目名称 */
  liabilityName = "";

  /** 是否过负债科目 */
  liabilitySubjectIndicator = "";

  /** 是否核算平台段 */
  platformSegment = "";

  /** 预付科目编码 */
  prepaymentCode = "";

  /** 预付科目名称 */
  prepaymentName = "";

  /** 流程类型 */
  processType = "";

  /** 费用科目编码 */
  subjectsCode = "";

  /** 费用科目名称 */
  subjectsName = "";

  /** 是否核算子目段 */
  subsidiarySegmentIndicator = "";

  /** 是否挂供应商 */
  supplierIndicator = "";

  /** TMS辅助段 */
  tmsAuxiliarySegment = "";

  /** 转入方科目编码 */
  transferInCode = "";

  /** 转入方科目名称 */
  transferInName = "";

  /** 转出方科目编码 */
  transferOutCode = "";

  /** 转出方科目名称 */
  transferOutName = "";
}

class CostItemMappingResponseDto {
  /** 渠道辅助段 */
  channelAuxiliarySegment = "";

  /** 成本中心属性 */
  costCenterAttribute = "";

  /** 费用类型明细 */
  costDetail = "";

  /** 费用类型明细定义 */
  costDetailDefinition = "";

  /** 费用项编码 */
  costItemCode = "";

  /** 费用类别 */
  costType = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 是否核算部门段 */
  departmentSegment = "";

  /** 是否启用 0 否 1 是 */
  enabled = undefined;

  /** id */
  id = undefined;

  /** 是否合算内部往来段 */
  internalTransactionSegment = "";

  /** 是否对公支付 */
  isPublic = "";

  /** 负债科目编码 */
  liabilityCode = "";

  /** 负债科目名称 */
  liabilityName = "";

  /** 是否过负债科目 */
  liabilitySubjectIndicator = "";

  /** 是否核算平台段 */
  platformSegment = "";

  /** 预付科目编码 */
  prepaymentCode = "";

  /** 预付科目名称 */
  prepaymentName = "";

  /** 流程类型 */
  processType = "";

  /** 费用科目编码 */
  subjectsCode = "";

  /** 费用科目名称 */
  subjectsName = "";

  /** 是否核算子目段 */
  subsidiarySegmentIndicator = "";

  /** 是否挂供应商 */
  supplierIndicator = "";

  /** TMS辅助段 */
  tmsAuxiliarySegment = "";

  /** 转入方科目编码 */
  transferInCode = "";

  /** 转入方科目名称 */
  transferInName = "";

  /** 转出方科目编码 */
  transferOutCode = "";

  /** 转出方科目名称 */
  transferOutName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class CountryResponseDto {
  /** 大洲 */
  continent = "";

  /** 中文名称 */
  countryNameCn = "";

  /** 英文名称 */
  countryNameEn = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 数字码 */
  digitalCode = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 二字码 */
  secondWord = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 三字码 */
  threeWord = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class CurrentTaskDto {
  /** 节点当前处理人 */
  currentAssignee = new AssigneeDto();

  /** 节点编码 */
  nodeKey = "";

  /** 节点名称 */
  nodeName = "";

  /** 节点操作类型 驳回指定节点:backToStart；驳回:reject；通过:pass,；反对：oppose；弃权：abandon；终止：cadence */
  operate = "";

  /** 任务id */
  taskId = "";
}

class CustomsDetailRequestDto {
  /** 是否反倾销 */
  antiDumpingFlag = false;

  /** 反倾销税 */
  antiDumpingRate = undefined;

  /** 海关要素NO */
  cino = "";

  /** 国家中文名称 */
  countryNameCn = "";

  /** 海关编码 */
  hscodeCn = "";

  /** 主键 */
  id = undefined;

  /** 国家二字码 */
  secondWord = "";

  /** 关税率 */
  tariffRate = undefined;
}

class CustomsDetailResponseDto {
  /** 是否反倾销 */
  antiDumpingFlag = false;

  /** 反倾销税 */
  antiDumpingRate = undefined;

  /** 海关要素NO */
  cino = "";

  /** 国家中文名称 */
  countryNameCn = "";

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createName = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 海关编码 */
  hscodeCn = "";

  /** 主键 */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 国家二字码 */
  secondWord = "";

  /** 关税率 */
  tariffRate = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改人名称 */
  updateName = "";

  /** 修改时间 */
  updateTime = "";
}

class CustomsInfoRequestDto {
  /** 海关要素NO */
  cino = "";

  /** 是否商检 */
  commodityInspectionFlag = false;

  /** 海关要素明细 */
  customsDetails = [];

  /** 海关法定单位名称 */
  customsUnitName = "";

  /** 海关法定单位 */
  customsUnitNo = "";

  /** 是否报关 */
  declareFlag = undefined;

  /** 申报名称（CN） */
  declareNameCn = "";

  /** 申报名称（EN） */
  declareNameEn = "";

  /** 是否启用 0 否 1 是 */
  enableFlag = undefined;

  /** 海关编码 */
  hscodeCn = "";

  /** 主键 */
  id = undefined;

  /** 开票单位名称 */
  invoiceUnitName = "";

  /** 开票单位 */
  invoiceUnitNo = "";

  /** 退税率 */
  taxRebateRate = undefined;
}

class CustomsInfoResponseDto {
  /** 海关要素NO */
  cino = "";

  /** 是否商检 */
  commodityInspectionFlag = false;

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createName = "";

  /** 创建时间 */
  createTime = "";

  /** 海关要素明细 */
  customsDetails = [];

  /** 海关法定单位名称 */
  customsUnitName = "";

  /** 海关法定单位 */
  customsUnitNo = "";

  /** 是否报关 */
  declareFlag = undefined;

  /** 申报名称（CN） */
  declareNameCn = "";

  /** 申报名称（EN） */
  declareNameEn = "";

  /** 删除标识 */
  deleted = undefined;

  /** 是否启用 0 否 1 是 */
  enableFlag = undefined;

  /** 海关编码 */
  hscodeCn = "";

  /** 主键 */
  id = undefined;

  /** 开票单位名称 */
  invoiceUnitName = "";

  /** 开票单位 */
  invoiceUnitNo = "";

  /** 版本 */
  lockVersion = undefined;

  /** 退税率 */
  taxRebateRate = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改人名称 */
  updateName = "";

  /** 修改时间 */
  updateTime = "";
}

class CustomsInfosResponseDto {
  /** 海关要素NO */
  cino = "";

  /** 是否商检 */
  commodityInspectionFlag = false;

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createName = "";

  /** 创建时间 */
  createTime = "";

  /** 海关要素明细 */
  customsDetails = [];

  /** 海关法定单位名称 */
  customsUnitName = "";

  /** 海关法定单位 */
  customsUnitNo = "";

  /** 申报名称（CN） */
  declareNameCn = "";

  /** 申报名称（EN） */
  declareNameEn = "";

  /** 删除标识 */
  deleted = undefined;

  /** 海关编码 */
  hscodeCn = "";

  /** 主键 */
  id = undefined;

  /** 开票单位名称 */
  invoiceUnitName = "";

  /** 开票单位 */
  invoiceUnitNo = "";

  /** 版本 */
  lockVersion = undefined;

  /** 退税率 */
  taxRebateRate = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改人名称 */
  updateName = "";

  /** 修改时间 */
  updateTime = "";
}

class DetailsDTO {
  /** description */
  description = "";

  /** field */
  field = "";

  /** issue */
  issue = "";

  /** location */
  location = "";

  /** value */
  value = "";
}

class EbsBankOutputParameters {
  /** exchangeRateReturnBody */
  exchangeRateReturnBody = new ExchangeRateReturnBody();

  /** resultRec */
  resultRec = new ResultRec();
}

class EbsExchangeRateModel {
  /** 汇率日期 */
  conversionDate = "";

  /** 汇率 */
  conversionRate = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 1:是 */
  deleted = undefined;

  /** 源币种 */
  fromCurrency = "";

  /** id */
  id = undefined;

  /** 更新时间 */
  lastUpdateDate = "";

  /** 乐观锁 */
  lockVersion = undefined;

  /** 目标币种 */
  toCurrency = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class EbsFeedBackRequestDto {
  /** EBS系统批次表处理ID */
  batchId = "";

  /** 各系统传入EBS系统时的extBatchId. */
  extBatchId = "";

  /** 各系统传入EBS的接口编码, 依据双方的接口卡确定的 */
  interfaceCode = "";

  /** 外系统行记录Id的错误信息 */
  interfaceLines = [];

  /** 处理信息 */
  processMessage = "";

  /** 处理结果状态。E(验证错误)/S(处理成功) */
  processStatus = "";

  /** EBS系统收到外系统的extBatchId这批数据的接收日期 */
  receivedDate = "";

  /** 来源系统编码 */
  sourceSystem = "";
}

class EbsFeedBackResponseDto {
  /** EBS系统批次表处理ID */
  batchId = "";

  /** 返回信息 */
  returnMessage = "";

  /** 反馈报文接收状态，S:成功，E：错误 */
  returnStatus = "";
}

class EbsPageInfo {
  /** 页号 */
  pageId = "";

  /** 页大小 */
  pageSize = "";
}

class EbsRateRequest {
  /** 汇率日期 */
  conversionDate = "";

  /** 汇率日期开始 */
  endConversionDate = "";

  /** 源币种 */
  fromCurrency = "";

  /** 源币种集合 */
  fromCurrencyList = [];

  /** 汇率日期开始 */
  startConversionDate = "";

  /** 目标币种 */
  toCurrency = "";
}

class EbsRateResponse {
  /** 汇率日期 */
  conversionDate = "";

  /** 汇率 */
  conversionRate = "";

  /** 源币种 */
  fromCurrency = "";

  /** 更新时间 */
  lastUpdateDate = "";

  /** 目标币种 */
  toCurrency = "";
}

class ErrorsDTO {
  /** debugId */
  debugId = "";

  /** details */
  details = [];

  /** message */
  message = "";

  /** name */
  name = "";
}

class ExchangeRateBodyItem {
  /** 汇率日期 */
  currencyConversionDate = "";

  /** 汇率类型 */
  currencyConversionType = "";

  /** 初始币种 */
  fromCurrency = "";

  /** 兑换率 */
  showConversionRate = "";

  /** 汇率 */
  showInverseConRate = "";

  /** 转换币种 */
  toCurrency = "";
}

class ExchangeRateQuery {
  /** 初始币种 */
  fromCurrency = "";

  /** 开始时间 */
  fromDate = "";

  /** 转换币种 */
  toCurrency = "";

  /** 结束时间 */
  toDate = "";
}

class ExchangeRateRequest {
  /** exchangeRateQuery */
  exchangeRateQuery = new ExchangeRateQuery();

  /** pageInfo */
  pageInfo = new EbsPageInfo();
}

class ExchangeRateResponse {
  /** outputParameters */
  outputParameters = new EbsBankOutputParameters();
}

class ExchangeRateReturnBody {
  /** bankReturnBodyItems */
  bankReturnBodyItems = [];
}

class FinanceAccountDesensitizationResponseDto {
  /** 账号，登录名 */
  appId = "";

  /** 应用名称 */
  appName = "";

  /** 账号类别 (如paypal,alipay) */
  appType = "";

  /** 创建人 */
  createBy = "";

  /** 创建人姓名 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 1:是 */
  deleted = undefined;

  /** 备注 */
  description = "";

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新人姓名 */
  updateByName = "";

  /** 更新时间 */
  updateTime = "";
}

class FinanceAccountRequestDto {
  /** 支付宝公钥 */
  alipayKey = "";

  /** 账号，登录名 */
  appId = "";

  /** 应用名称 */
  appName = "";

  /** 应用私钥 */
  appSecret = "";

  /** 账号类别 (如paypal,alipay) */
  appType = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 1:是 */
  deleted = undefined;

  /** 备注 */
  description = "";

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 密码 */
  secret = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class FinanceAccountRequestParamsDto {
  /** 支付宝公钥 */
  alipayKey = "";

  /** 账号，登录名 */
  appId = "";

  /** 应用名称 */
  appName = "";

  /** 应用私钥 */
  appSecret = "";

  /** 账号类别 (如paypal,alipay) */
  appType = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间开始时间 */
  createTimeGe = "";

  /** 创建时间结束时间 */
  createTimeLe = "";

  /** 删除标识 0:否 1:是 */
  deleted = undefined;

  /** 备注 */
  description = "";

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 密码 */
  secret = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 更新人 */
  updateBy = "";
}

class FinanceAccountResponseDto {
  /** 支付宝公钥 */
  alipayKey = "";

  /** 账号，登录名 */
  appId = "";

  /** 应用名称 */
  appName = "";

  /** 应用私钥 */
  appSecret = "";

  /** 账号类别 (如paypal,alipay) */
  appType = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 1:是 */
  deleted = undefined;

  /** 备注 */
  description = "";

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 密码 */
  secret = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class FinanceAccountResponseRpcDto {
  /** 支付宝公钥 */
  alipayKey = "";

  /** 账号，登录名 */
  appId = "";

  /** 应用名称 */
  appName = "";

  /** 应用私钥 */
  appSecret = "";

  /** 账号类别 (如paypal,alipay) */
  appType = "";

  /** 备注 */
  description = "";

  /** 财务收支账号表id */
  financeId = undefined;

  /** 密码 */
  secret = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;
}

class FreshdeskDataReportManageImportRequestDto {
  /** 来源/上传文件地址 */
  sourceFileUrl = "";
}

class FreshdeskDataReportManagePageListRequestDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间-结束 */
  createTimeEnd = "";

  /** 创建时间-开始 */
  createTimeStart = "";

  /** 当前页 */
  current = undefined;

  /** 执行次数 */
  executeCount = undefined;

  /** 工单编号 */
  freshdeskNo = "";

  /** 主键 */
  id = undefined;

  /** 最后一次执行时间-结束 */
  latelyExecTimeEnd = "";

  /** 最后一次执行时间-开始 */
  latelyExecTimeStart = "";

  /** 排序 */
  orderBy = "";

  /** 每页条数 */
  size = undefined;

  /** 状态 1:待生成,2:生成中,3:生成成功,4:生成失败 */
  statusList = [];

  /** 修改人 */
  updateBy = "";

  /** 更新时间-结束 */
  updateTimeEnd = "";

  /** 更新时间-开始 */
  updateTimeStart = "";
}

class FreshdeskDataReportManagePageResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 错误信息 */
  errorMsg = "";

  /** 执行次数 */
  executeCount = undefined;

  /** 工单编号 */
  freshdeskNo = "";

  /** 生成/下载文件地址 */
  generateFileUrl = "";

  /** 主键 */
  id = undefined;

  /** 最后一次执行时间 */
  latelyExecTime = "";

  /** 来源/上传文件地址 */
  sourceFileUrl = "";

  /** 状态 1:待生成,2:生成中,3:生成成功,4:生成失败 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class HolidayManagementCreateRequestParamsDto {
  /** 年度 */
  annual = "";

  /** 当前页 */
  current = undefined;

  /** 假日放假天数 */
  daysOff = undefined;

  /** 删除标识 */
  deleted = undefined;

  /** 假日截止时间 */
  endTime = "";

  /** 节假日名称 labor_day 劳动节 national_day 国庆  spring_festival 春节 */
  holidayName = "";

  /** id */
  id = undefined;

  /** 排序 */
  orderBy = "";

  /** 每页条数 */
  size = undefined;

  /** 假日开始时间 */
  startTime = "";
}

class HolidayManagementListResponseDto {
  /** 年度 */
  annual = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 假日放假天数 */
  daysOff = undefined;

  /** 删除标识 */
  deleted = undefined;

  /** 假日截止时间 */
  endTime = "";

  /** 节假日名称 labor_day 劳动节 national_day 国庆  spring_festival 春节 */
  holidayName = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 假日开始时间 */
  startTime = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class HolidayManagementListRpcResponseDto {
  /** 年度 */
  annual = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 假日放假天数 */
  daysOff = undefined;

  /** 删除标识 */
  deleted = undefined;

  /** 假日截止时间 */
  endTime = "";

  /** 节假日名称 labor_day 劳动节 national_day 国庆  spring_festival 春节 */
  holidayName = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 假日开始时间 */
  startTime = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class HolidayManagementRequestParamsDto {
  /** 年度 */
  annual = "";

  /** 当前页 */
  current = undefined;

  /** 假日截止时间首 */
  endTimeBegin = "";

  /** 假日截止时间尾 */
  endTimeEnd = "";

  /** 节假日名称 labor_day 劳动节 national_day 国庆  spring_festival 春节 */
  holidayName = "";

  /** 排序 */
  orderBy = "";

  /** 每页条数 */
  size = undefined;

  /** 假日开始时间首 */
  startTimeBegin = "";

  /** 假日开始时间尾 */
  startTimeEnd = "";
}

class HolidayManagementRpcRequestParamsDto {
  /** 年度 */
  annual = "";

  /** 假日截止时间首 */
  endTimeBegin = "";

  /** 假日截止时间尾 */
  endTimeEnd = "";

  /** 节假日名称 labor_day 劳动节 national_day 国庆  spring_festival 春节 */
  holidayName = "";

  /** 假日开始时间首 */
  startTimeBegin = "";

  /** 假日开始时间尾 */
  startTimeEnd = "";
}

class IPage {
  /** current */
  current = undefined;

  /** hitCount */
  hitCount = false;

  /** pages */
  pages = undefined;

  /** records */
  records = [];

  /** searchCount */
  searchCount = false;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class InterfaceLines {
  /** 由EBS将原来外系统传入extBatchId返回给外系统 */
  extBatchId = "";

  /** 由EBS将原来外系统传入extLineId返回给外系统 */
  extLineId = "";

  /** EBS接口头ID,用于追溯 */
  ifaceHeaderId = "";

  /** EBS接口行ID,用于追溯 */
  ifaceLineId = "";

  /** 每一行的错误消息显示在此信息. */
  processMessage = "";
}

class LabelDepartmentInfoRequestDto {
  /** 部门编码 */
  code = "";

  /** 部门英语名称 */
  enName = "";

  /** 部门名称 */
  name = "";
}

class LabelDepartmentInfoRequestParamsDto {
  /** 部门编码 */
  code = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标志 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 部门名称 */
  name = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class LabelDepartmentInfoResponseDto {
  /** 部门编码 */
  code = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标志 */
  deleted = undefined;

  /** 部门英语名称 */
  enName = "";

  /** id */
  id = undefined;

  /** 部门名称 */
  name = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class LabelInfoQueryDto {
  /** 标签编码 */
  code = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 创建开始时间 */
  createTimeGe = "";

  /** 创建结束时间 */
  createTimeLe = "";

  /** 删除标志 */
  deleted = undefined;

  /** 部门编码 */
  departmentCode = "";

  /** 部门名称 */
  departmentName = "";

  /** 级别 */
  level = undefined;

  /** 备注 */
  memo = "";

  /** 名称 */
  name = "";

  /** 父级编码，默认为0 */
  parentCode = "";

  /** 状态(1:启用，0:不启用) */
  state = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 更新开始时间 */
  updateTimeGe = "";

  /** 更新结束时间 */
  updateTimeLe = "";

  /** wm标签 */
  wmLabel = "";
}

class LabelInfoRequestDto {
  /** 标签编码 */
  code = "";

  /** 部门编码 */
  departmentCode = "";

  /** 部门英语名称 */
  departmentEnName = "";

  /** 部门名称 */
  departmentName = "";

  /** 英语备注 */
  enMemo = "";

  /** 英语名称 */
  enName = "";

  /** 级别 */
  level = undefined;

  /** 备注 */
  memo = "";

  /** 名称 */
  name = "";

  /** 父级编码，默认为0 */
  parentCode = "";

  /** 状态(1:启用，0:不启用) */
  state = undefined;

  /** 沃尔玛标签 */
  wmLabel = "";
}

class LabelInfoRequestParamsDto {
  /** 标签编码 */
  code = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 创建开始时间 */
  createTimeGe = "";

  /** 创建结束时间 */
  createTimeLe = "";

  /** 删除标志 */
  deleted = undefined;

  /** 部门编码 */
  departmentCode = "";

  /** 部门名称 */
  departmentName = "";

  /** id */
  id = undefined;

  /** 级别 */
  level = undefined;

  /** 备注 */
  memo = "";

  /** 名称 */
  name = "";

  /** 父级编码，默认为0 */
  parentCode = "";

  /** 路径 */
  path = "";

  /** 状态(1:启用，0:不启用) */
  state = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 更新开始时间 */
  updateTimeGe = "";

  /** 更新结束时间 */
  updateTimeLe = "";

  /** 沃尔玛标签 */
  wmLabel = "";
}

class LabelInfoResponseDto {
  /** 下级标签对象 */
  children = [];

  /** 标签编码 */
  code = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标志 */
  deleted = undefined;

  /** 部门编码 */
  departmentCode = "";

  /** 部门英语名称 */
  departmentEnName = "";

  /** 部门名称 */
  departmentName = "";

  /** 英语备注 */
  enMemo = "";

  /** 英语名称 */
  enName = "";

  /** 英语名称1 */
  enName1 = "";

  /** 英语名称2 */
  enName2 = "";

  /** 英语名称3 */
  enName3 = "";

  /** 英语名称4 */
  enName4 = "";

  /** 英语名称5 */
  enName5 = "";

  /** 英语名称6 */
  enName6 = "";

  /** 英语名称名称7 */
  enName7 = "";

  /** id */
  id = undefined;

  /** 级别 */
  level = undefined;

  /** 备注 */
  memo = "";

  /** 名称 */
  name = "";

  /** 名称1 */
  name1 = "";

  /** 名称2 */
  name2 = "";

  /** 名称3 */
  name3 = "";

  /** 名称4 */
  name4 = "";

  /** 名称5 */
  name5 = "";

  /** 名称6 */
  name6 = "";

  /** 名称7 */
  name7 = "";

  /** 父级编码，默认为0 */
  parentCode = "";

  /** 路径 */
  path = "";

  /** 状态(1:启用，0:不启用) */
  state = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";

  /** 沃尔玛标签 */
  wmLabel = "";
}

class LabelInfoTreeResponseDto {
  /** 部门编码 */
  code = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标志 */
  deleted = undefined;

  /** 部门英语名称 */
  enName = "";

  /** id */
  id = undefined;

  /** 下级标签对象 */
  labels = [];

  /** 级别 */
  level = undefined;

  /** 部门名称 */
  name = "";

  /** 父节点 */
  parentCode = "";

  /** 地址 */
  path = "";

  /** 是否启用 */
  state = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class LinksDTO {
  /** href */
  href = "";

  /** method */
  method = "";

  /** rel */
  rel = "";
}

class ListingQuoteModel {
  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 删除 0:否 1:是 */
  deleted = undefined;

  /** 有效期结束时间 */
  effectiveEndDate = "";

  /** 有效期开始时间 */
  effectiveStartDate = "";

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 店铺名称 */
  marketName = "";

  /** 平台sku */
  msku = "";

  /** 平台 */
  platform = "";

  /** 平台key */
  platformKey = "";

  /** 价格 */
  price = undefined;

  /** 0：关闭  1：启动 */
  quoteState = false;

  /** 0:默认报价 1:正常报价 */
  quoteType = undefined;

  /** 店铺key */
  shopKey = "";

  /** 站点 */
  site = "";

  /** 更新人 */
  updateBy = "";

  /** 修改人名称 */
  updateByName = "";

  /** 更新时间 */
  updateTime = "";
}

class ListingQuoteRequestDto {
  /** 币种 */
  currency = "";

  /** 有效期结束时间 */
  effectiveEndDate = "";

  /** 有效期开始时间 */
  effectiveStartDate = "";

  /** 店铺名称 */
  marketName = "";

  /** 平台sku */
  msku = "";

  /** 平台 */
  platform = "";

  /** 平台key */
  platformKey = "";

  /** 价格 */
  price = undefined;

  /** 0：禁用 1：启用 */
  quoteState = false;

  /** 0:默认报价 1:正常报价 */
  quoteType = undefined;

  /** 店铺ID */
  shopKey = "";

  /** 站点 */
  site = "";
}

class ListingQuoteRequestParamsDto {
  /** 创建人 */
  createBy = "";

  /** 创建开始时间 */
  createTimeGe = "";

  /** 创建结束时间 */
  createTimeLe = "";

  /** 有效期结束时间 */
  effectiveEndDate = "";

  /** 有效期开始时间 */
  effectiveStartDate = "";

  /** 平台sku */
  msku = "";

  /** 平台key */
  platformKey = "";

  /** 0：禁用 1：启用 */
  quoteState = false;

  /** 0:默认报价 1:正常报价 */
  quoteType = undefined;

  /** 店铺ID */
  shopKey = "";

  /** 站点 */
  site = "";

  /** 更新人 */
  updateBy = "";

  /** 更新开始时间 */
  updateTimeGe = "";

  /** 更新结束时间 */
  updateTimeLe = "";
}

class ListingQuoteRpcRequestDto {
  /** 店铺名称 */
  marketName = "";

  /** 平台sku */
  msku = "";

  /** 店铺key */
  shopKey = "";
}

class ListingQuoteRpcResponseDto {
  /** 有效期结束时间 */
  effectiveEndDate = "";

  /** 有效期开始时间 */
  effectiveStartDate = "";

  /** 店铺名称 */
  marketName = "";

  /** 平台sku */
  msku = "";

  /** 平台 */
  platform = "";

  /** 平台key */
  platformKey = "";

  /** 价格 */
  price = undefined;

  /** 0：关闭  1：启动 */
  quoteState = false;

  /** 0:默认报价 1:正常报价 */
  quoteType = undefined;

  /** 店铺key */
  shopKey = "";

  /** 站点 */
  site = "";
}

class ListingQuoteUpdateRequestDto {
  /** 有效期结束时间 */
  effectiveEndDate = "";

  /** 有效期开始时间 */
  effectiveStartDate = "";

  /** id */
  id = undefined;

  /** 价格 */
  price = undefined;

  /** 0：禁用 1：启用 */
  quoteState = false;

  /** 0:默认报价 1:正常报价 */
  quoteType = undefined;
}

class LogisticsAttrModel {
  /** 物流属性名称（CN） */
  attrNameCn = "";

  /** 物流属性名称（EN） */
  attrNameEn = "";

  /** 物流属性编号 */
  attrNo = "";

  /** 物流属性值（暂时作用不大预留） */
  attrValue = "";

  /** 物流属性类型编号 */
  attrtypeNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 描述 */
  description = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class LogisticsAttrRequestDto {
  /** 物流属性名称（CN） */
  attrNameCn = "";

  /** 物流属性名称（EN） */
  attrNameEn = "";

  /** 物流属性编号 */
  attrNo = "";

  /** 物流属性值（暂时作用不大预留） */
  attrValue = "";

  /** 物流属性类型编号 */
  attrtypeNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 描述 */
  description = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class LogisticsAttrRequestParamsDto {
  /** 物流属性名称（CN） */
  attrNameCn = "";

  /** 物流属性名称（EN） */
  attrNameEn = "";

  /** 物流属性编号 */
  attrNo = "";

  /** 物流属性值（暂时作用不大预留） */
  attrValue = "";

  /** 物流属性类型编号 */
  attrtypeNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 描述 */
  description = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class LogisticsAttrResponseDto {
  /** 物流属性名称（CN） */
  attrNameCn = "";

  /** 物流属性名称（EN） */
  attrNameEn = "";

  /** 物流属性编号 */
  attrNo = "";

  /** 物流属性值（暂时作用不大预留） */
  attrValue = "";

  /** 物流属性类型编号 */
  attrtypeNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 描述 */
  description = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class LogisticsAttrTypeDetailsResponseDto {
  /** 物流属性列表 */
  attrModelList = [];

  /** 物流属性类型名称（CN） */
  attrtypeNameCn = "";

  /** 物流属性类型名称（EN） */
  attrtypeNameEn = "";

  /** 物流属性类型编号 */
  attrtypeNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 描述 */
  description = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class LogisticsAttrTypeModel {
  /** 物流属性类型名称（CN） */
  attrtypeNameCn = "";

  /** 物流属性类型名称（EN） */
  attrtypeNameEn = "";

  /** 物流属性类型编号 */
  attrtypeNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 描述 */
  description = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class LogisticsAttrTypeRequestDto {
  /** 物流属性类型名称（CN） */
  attrtypeNameCn = "";

  /** 物流属性类型名称（EN） */
  attrtypeNameEn = "";

  /** 物流属性类型编号 */
  attrtypeNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 描述 */
  description = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class LogisticsAttrTypeRequestParamsDto {
  /** 物流属性类型名称（CN） */
  attrtypeNameCn = "";

  /** 物流属性类型名称（EN） */
  attrtypeNameEn = "";

  /** 物流属性类型编号 */
  attrtypeNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 描述 */
  description = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class LogisticsAttrTypeResponseDto {
  /** 物流属性类型名称（CN） */
  attrtypeNameCn = "";

  /** 物流属性类型名称（EN） */
  attrtypeNameEn = "";

  /** 物流属性类型编号 */
  attrtypeNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 描述 */
  description = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class LogisticsGroupAttrModel {
  /** 物流属性名称（CN） */
  attrNameCn = "";

  /** 物流属性名称（EN） */
  attrNameEn = "";

  /** 物流属性编号 */
  attrNo = "";

  /** 物流属性类型编号 */
  attrtypeNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 物流分组编号 */
  groupNo = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1有效 or 0失效 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class LogisticsGroupAttrRequestDto {
  /** 物流属性名称（CN） */
  attrNameCn = "";

  /** 物流属性名称（EN） */
  attrNameEn = "";

  /** 物流属性编号 */
  attrNo = "";

  /** 物流属性类型编号 */
  attrtypeNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 物流分组编号 */
  groupNo = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1有效 or 0失效 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class LogisticsGroupAttrRequestParamsDto {
  /** 物流属性名称（CN） */
  attrNameCn = "";

  /** 物流属性名称（EN） */
  attrNameEn = "";

  /** 物流属性编号 */
  attrNo = "";

  /** 物流属性类型编号 */
  attrtypeNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 物流分组编号 */
  groupNo = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1有效 or 0失效 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class LogisticsGroupAttrResponseDto {
  /** 物流属性名称（CN） */
  attrNameCn = "";

  /** 物流属性名称（EN） */
  attrNameEn = "";

  /** 物流属性编号 */
  attrNo = "";

  /** 物流属性类型编号 */
  attrtypeNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 物流分组编号 */
  groupNo = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1有效 or 0失效 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class LogisticsGroupDetailsResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 描述 */
  description = "";

  /** 物流分组-物流属性列表 */
  groupModelList = [];

  /** 物流分组名称（CN） */
  groupNameCn = "";

  /** 物流分组名称（EN） */
  groupNameEn = "";

  /** 物流分组编号 */
  groupNo = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class LogisticsGroupModel {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 描述 */
  description = "";

  /** 物流分组名称（CN） */
  groupNameCn = "";

  /** 物流分组名称（EN） */
  groupNameEn = "";

  /** 物流分组编号 */
  groupNo = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class LogisticsGroupRequestDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 描述 */
  description = "";

  /** 物流分组名称（CN） */
  groupNameCn = "";

  /** 物流分组名称（EN） */
  groupNameEn = "";

  /** 物流分组编号 */
  groupNo = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class LogisticsGroupRequestParamsDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 描述 */
  description = "";

  /** 物流分组名称（CN） */
  groupNameCn = "";

  /** 物流分组名称（EN） */
  groupNameEn = "";

  /** 物流分组编号 */
  groupNo = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class LogisticsGroupResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 描述 */
  description = "";

  /** 物流分组名称（CN） */
  groupNameCn = "";

  /** 物流分组名称（EN） */
  groupNameEn = "";

  /** 物流分组编号 */
  groupNo = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class OrderCompanyAccountResponseDto {
  /** 账号名称 */
  accountNo = "";

  /** 类型 1：开户 2：收款 */
  accountType = undefined;

  /** 银行账号 */
  bankAccount = "";

  /** ebs编码 */
  bankAccountEbsId = "";

  /** ns编码 */
  bankAccountNsId = "";

  /** 银行名称 */
  bankName = "";

  /** 开户行市级代码 */
  cityCode = "";

  /** 开户行市级名称 */
  cityName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 货币 */
  currency = "";

  /** id */
  id = undefined;

  /** order_company公司主体id */
  orderCompanyId = undefined;

  /** 开户行省级代码 */
  provinceCode = "";

  /** 开户行省级名称 */
  provinceName = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class OrderCompanyAccountRpcResponseDto {
  /** 账号名称 */
  accountNo = "";

  /** 类型 1：开户 2：收款 */
  accountType = undefined;

  /** 银行账号 */
  bankAccount = "";

  /** 银行账号ebs编码 */
  bankAccountEbsId = "";

  /** 银行账号ns编码 */
  bankAccountNsId = "";

  /** 银行名称 */
  bankName = "";

  /** 开户行市级代码 */
  cityCode = "";

  /** 开户行市级名称 */
  cityName = "";

  /** 货币 */
  currency = "";

  /** 开户行省级代码 */
  provinceCode = "";

  /** 开户行省级名称 */
  provinceName = "";
}

class OrderCompanyAccountSaveDto {
  /** 账号名称 */
  accountNo = "";

  /** 类型 1：开户 2：收款 */
  accountType = undefined;

  /** 银行账号 */
  bankAccount = "";

  /** ebs编码 */
  bankAccountEbsId = "";

  /** ns编码 */
  bankAccountNsId = "";

  /** 银行名称 */
  bankName = "";

  /** 开户行市级代码 */
  cityCode = "";

  /** 开户行市级名称 */
  cityName = "";

  /** 货币 */
  currency = "";

  /** id */
  id = undefined;

  /** 开户行省级代码 */
  provinceCode = "";

  /** 开户行省级名称 */
  provinceName = "";
}

class OrderCompanyDetailDto {
  /** 账号信息 */
  accountResponseDtoList = [];

  /** 主体信息 */
  orderCompanyResponseDto = new OrderCompanyResponseDto();
}

class OrderCompanyModel {
  /** 地址 */
  address = "";

  /** 市 */
  city = "";

  /** 主体简称 */
  companyAbbreviation = "";

  /** 主体名称 */
  companyName = "";

  /** 主体名称英文名字 */
  companyNameEn = "";

  /** 国家 */
  country = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** ebs_id */
  ebsId = "";

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** ns_id */
  nsId = "";

  /** 库存组织编码 */
  organizeCode = "";

  /** 库存组织名称 */
  organizeName = "";

  /** 电话号码 */
  phoneNumber = "";

  /** 省/州 */
  province = "";

  /** 是否采购开票 0否 1是 */
  purchaseFlag = undefined;

  /** 备注 */
  remark = "";

  /** 使用状态 0停用 1启用 */
  status = undefined;

  /** 税号 */
  taxFileNumber = "";

  /** 税率 */
  taxRate = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class OrderCompanyRequestParamsDto {
  /** 主体名称 */
  companyName = "";

  /** 主体名称英文名字 */
  companyNameEn = "";

  /** 创建人 */
  createBy = "";

  /** 创建开始时间 */
  createTimeGe = "";

  /** 创建结束时间 */
  createTimeLe = "";

  /** 更新开始时间 */
  updateTimeGe = "";

  /** 更新结束时间 */
  updateTimeLe = "";
}

class OrderCompanyResponseDto {
  /** 地址 */
  address = "";

  /** 市 */
  city = "";

  /** 主体简称 */
  companyAbbreviation = "";

  /** 主体名称 */
  companyName = "";

  /** 主体名称英文名字 */
  companyNameEn = "";

  /** 国家 */
  country = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** ebs_id */
  ebsId = "";

  /** id */
  id = undefined;

  /** ns_id */
  nsId = "";

  /** 库存组织编码 */
  organizeCode = "";

  /** 库存组织名称 */
  organizeName = "";

  /** 电话号码 */
  phoneNumber = "";

  /** 省/州 */
  province = "";

  /** 是否采购开票 0否 1是 */
  purchaseFlag = undefined;

  /** 备注 */
  remark = "";

  /** 使用状态 0停用 1启用 */
  status = undefined;

  /** 税号 */
  taxFileNumber = "";

  /** 税率 */
  taxRate = undefined;

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class OrderCompanyRpcRequestDto {
  /** 市 */
  city = "";

  /** 主体简称 */
  companyAbbreviation = "";

  /** 主体名称 */
  companyName = "";

  /** 主体名称英文名字 */
  companyNameEn = "";

  /** 国家 */
  country = "";

  /** ebs_id */
  ebsId = "";

  /** ns_id */
  nsId = "";

  /** 电话号码 */
  phoneNumber = "";

  /** 省/州 */
  province = "";

  /** 使用状态 0停用 1启用 */
  status = undefined;

  /** 税号 */
  taxFileNumber = "";

  /** 税率 */
  taxRate = undefined;
}

class OrderCompanyRpcResponseDto {
  /** 地址 */
  address = "";

  /** 市 */
  city = "";

  /** 主体简称 */
  companyAbbreviation = "";

  /** 主体名称 */
  companyName = "";

  /** 主体名称英文名字 */
  companyNameEn = "";

  /** 国家 */
  country = "";

  /** ebs_id */
  ebsId = "";

  /** id */
  id = undefined;

  /** 账号信息列表 */
  orderCompanyAccount = [];

  /** 组织编码 */
  organizeCode = "";

  /** 组织名称 */
  organizeName = "";

  /** 电话号码 */
  phoneNumber = "";

  /** 省/州 */
  province = "";

  /** 是否采购开票 0否 1是 */
  purchaseFlag = undefined;

  /** 备注 */
  remark = "";

  /** 使用状态 0停用 1启用 */
  status = undefined;

  /** 税号 */
  taxFileNumber = "";

  /** 税率 */
  taxRate = undefined;
}

class OrderCompanySaveDto {
  /** 账号列表 */
  accountList = [];

  /** 收货地址 */
  address = "";

  /** 市 */
  city = "";

  /** 主体简称 */
  companyAbbreviation = "";

  /** 主体名称 */
  companyName = "";

  /** 主体名称英文名字 */
  companyNameEn = "";

  /** 国家 */
  country = "";

  /** ebs_id */
  ebsId = "";

  /** id */
  id = undefined;

  /** nsId */
  nsId = "";

  /** 库存组织编码 */
  organizeCode = "";

  /** 库存组织名称 */
  organizeName = "";

  /** 电话号码 */
  phoneNumber = "";

  /** 省/州 */
  province = "";

  /** 是否采购开票 0否 1是 */
  purchaseFlag = undefined;

  /** 备注 */
  remark = "";

  /** 使用状态 0停用 1启用 */
  status = undefined;

  /** 税号 */
  taxFileNumber = "";

  /** 税率 */
  taxRate = undefined;
}

class OwnershipChannelResponseDto {
  /** ownershipChannel */
  ownershipChannel = "";

  /** ownershipChannelKey */
  ownershipChannelKey = "";
}

class PQueryInfo {
  /** 查询结束日期 */
  endDate = "";

  /** 访问主体名称 */
  orgName = "";

  /** 访问主体编号 */
  orgNum = "";

  /** 查询起始日期 */
  startDate = "";
}

class PdaVersionResponseDto {
  /** 应该更新说明 */
  bulidUpdateDescriptiion = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 应用下载地址 */
  downloadUrl = "";

  /** id */
  id = undefined;

  /** app名 */
  label = "";

  /** 是否最新版本：0-否  1-是 */
  latestVersion = undefined;

  /** app包名 */
  packageName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 版本code */
  versionCode = undefined;

  /** 版本中文名 */
  versionName = "";
}

class PdaVersionUpdateResponseDto {
  /** 应该更新说明 */
  bulidUpdateDescriptiion = "";

  /** 应用下载地址 */
  downloadUrl = "";

  /** 是否要更新 */
  haveNewVersion = false;

  /** 是否最新版本：0-否  1-是 */
  latestVersion = undefined;

  /** 新版本号 */
  versionName = "";
}

class PlatformAppTokenRequestDto {
  /** 授权令牌 */
  accessToken = "";

  /** 关联表id */
  id = undefined;

  /** 刷新令牌 */
  refreshToken = "";
}

class PlatformRequestDto {
  /** 受益部门 */
  benefitDepartment = "";

  /** 受益部门名称 */
  benefitDepartmentName = "";

  /** id（修改时提交） */
  id = undefined;

  /** 名称 */
  name = "";

  /** 库存归属 */
  platformChannel = "";

  /** 平台标识 */
  platformKey = "";

  /** 备注 */
  remark = "";

  /** 渠道归属 */
  salesChannelKey = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;
}

class PlatformResponseDto {
  /** 受益部门 */
  benefitDepartment = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 名称 */
  name = "";

  /** 渠道归属 */
  platformChannel = "";

  /** 平台标识 */
  platformKey = "";

  /** 备注 */
  remark = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class PlatformShopRequestDto {
  /** id（修改时提交） */
  id = undefined;

  /** 平台标识key */
  platformKey = "";

  /** 平台名称 */
  platformName = "";

  /** 备注 */
  remark = "";

  /** 店铺名称 */
  shopName = "";

  /** 店铺编号（修改时提交） */
  shopNo = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;
}

class PlatformShopResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 平台标识key */
  platformKey = "";

  /** 平台名称 */
  platformName = "";

  /** 备注 */
  remark = "";

  /** 亚马逊 sellerId */
  sellerId = "";

  /** 店铺名称 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class PlatformShopsRequestPatamsDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 平台标识key */
  platformKey = "";

  /** 备注 */
  remark = "";

  /** 店铺名称 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class PlatformShopsResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 平台标识key */
  platformKey = "";

  /** 平台名称 */
  platformName = "";

  /** 备注 */
  remark = "";

  /** sellerId */
  sellerId = "";

  /** 店铺名称 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class PlatformSiteRequestDto {
  /** 国家二字码 */
  countryCode = "";

  /** 币种 */
  currency = "";

  /** id（修改时提交） */
  id = undefined;

  /** 名称 */
  name = "";

  /** 平台标识key */
  platformKey = "";

  /** 平台名称 */
  platformName = "";

  /** 站点标识 */
  platformSiteKey = "";

  /** 备注 */
  remark = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 税率（含百分号），对应n%中的n */
  taxRate = undefined;
}

class PlatformSiteResponseDto {
  /** 国家二字码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 名称 */
  name = "";

  /** 平台标识key */
  platformKey = "";

  /** 平台名称 */
  platformName = "";

  /** 站点标识 */
  platformSiteKey = "";

  /** 备注 */
  remark = "";

  /** 渠道归属名称 */
  salesChannelName = "";

  /** 销售部门 */
  salesDeptName = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 税率（含百分号），对应n%中的n */
  taxRate = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class PlatformSiteRpcResponseDto {
  /** 国家二字码 */
  countryCode = "";

  /** id */
  id = undefined;

  /** 名称 */
  name = "";

  /** 平台渠道归属 */
  platformChannel = "";

  /** 平台标识key */
  platformKey = "";

  /** 平台名称 */
  platformName = "";

  /** 站点标识 */
  platformSiteKey = "";

  /** 备注 */
  remark = "";

  /** 渠道归属Key */
  salesChannelKey = "";

  /** 渠道归属名称 */
  salesChannelName = "";

  /** 销售部门Key */
  salesDeptKey = "";

  /** 销售部门 */
  salesDeptName = "";
}

class PlatformSiteShopAndAppAccountQueryRequestDto {
  /** API状态 启用:1 or 停用:0 */
  apiState = undefined;

  /** 平台标识列表 */
  platformKeyList = [];

  /** shopKey列表 */
  shopKeyList = [];

  /** 状态：1启用 or 0停用 */
  status = undefined;
}

class PlatformSiteShopAndAppAccountResponseDto {
  /** 授权状态(针对国内平台) 0：未授权 1：已授权 */
  accredit = undefined;

  /** API状态，亚马逊平台 */
  apiState = undefined;

  /** 平台店铺应用表账号 */
  appAccount = "";

  /** 平台应用相关信息 */
  appAccountResponseRpcDto = new AppAccountResponseRpcDto();

  /** 启用库存自动同步 0为否 1为是 */
  autoSyncStockFlag = undefined;

  /** 授权路径 */
  buildUrl = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 删除标识 */
  deleted = undefined;

  /** 财务收支表账号 */
  financeAccount = "";

  /** 财务收支应用相关信息 */
  financeAccountResponseRpcDto = new FinanceAccountResponseRpcDto();

  /** 财务编号 */
  financeCode = "";

  /** 多平台店铺编码 */
  gjShopCode = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** marketId */
  marketId = undefined;

  /** 站点店铺名 */
  name = "";

  /** 主体信息id */
  orderCompanyId = undefined;

  /** 主体相关信息 */
  orderCompanyRpcResponseDto = new OrderCompanyRpcResponseDto();

  /** 平台标识 */
  platformKey = "";

  /** 平台名称 */
  platformName = "";

  /** 平台店铺名称 */
  platformShopName = "";

  /** 站点标识key */
  platformSiteKey = "";

  /** 平台名称 */
  platformSiteName = "";

  /** 备注 */
  remark = "";

  /** sellerId */
  sellerId = "";

  /** 访问令牌 */
  shopAccessToken = "";

  /** 账号 */
  shopAccount = "";

  /** 账号名称 */
  shopAccountName = "";

  /** 账号KEY */
  shopApikey = "";

  /** 站点店铺唯一标识 */
  shopKey = "";

  /** 店铺编号 */
  shopNo = "";

  /** 密码 */
  shopPassword = "";

  /** 秘钥 */
  shopSecureKey = "";

  /** 店铺链接 */
  shopUrl = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 同步ebs错误信息 */
  syncEbsError = "";

  /** 同步ebs状态 0:未推送 1:推送中 2:推送失败 3:推送成功 4:EBS警告 */
  syncEbsStatus = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class PlatformSiteShopDesensitizationResponseDto {
  /** 启用库存自动同步 0为否 1为是 */
  autoSyncStockFlag = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 站点店铺名 */
  name = "";

  /** 平台标识 */
  platformKey = "";

  /** 平台名称 */
  platformName = "";

  /** 平台店铺名称 */
  platformShopName = "";

  /** 站点标识key */
  platformSiteKey = "";

  /** 平台名称 */
  platformSiteName = "";

  /** 备注 */
  remark = "";

  /** 站点店铺唯一标识 */
  shopKey = "";

  /** 店铺编号 */
  shopNo = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class PlatformSiteShopQueryRequestDto {
  /** api状态: 1启用 or 0停用 */
  apiState = undefined;

  /** 平台标识 */
  platformKey = "";

  /** shopKey集合 */
  shopKeyColl = [];

  /** 状态：1启用 or 0停用 */
  status = undefined;
}

class PlatformSiteShopRelevanceResponseDto {
  /** 授权令牌 */
  accessToken = "";

  /** 应用表id */
  accountId = undefined;

  /** 应用名称 */
  accountName = "";

  /** accountResponseDto */
  accountResponseDto = new AccountResponseDto();

  /** 应用类型 0：平台店铺应用类型 1：财务收支类型 */
  accountType = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 刷新令牌 */
  refreshToken = "";

  /** 备注 */
  remark = "";

  /** 店铺关系表id */
  siteShopId = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class PlatformSiteShopRequestDto {
  /** 授权状态(针对国内平台) 0：未授权 1：已授权 */
  accredit = undefined;

  /** API状态 */
  apiState = undefined;

  /** 平台店铺应用表账号 */
  appAccount = "";

  /** 启用库存自动同步 0为否 1为是 */
  autoSyncStockFlag = undefined;

  /** 币种 */
  currency = "";

  /** 财务收支表账号 */
  financeAccount = "";

  /** 财务编号 */
  financeCode = "";

  /** id（修改时提交） */
  id = undefined;

  /** 站点店铺名 */
  name = "";

  /** 主体信息id */
  orderCompanyId = undefined;

  /** 平台标识 */
  platformKey = "";

  /** 平台名称 */
  platformName = "";

  /** 平台店铺名称 */
  platformShopName = "";

  /** 站点标识key */
  platformSiteKey = "";

  /** 平台站点名称 */
  platformSiteName = "";

  /** 备注 */
  remark = "";

  /** sellerId */
  sellerId = "";

  /** 访问令牌 */
  shopAccessToken = "";

  /** 账号 */
  shopAccount = "";

  /** 账号名称 */
  shopAccountName = "";

  /** 账号KEY */
  shopApikey = "";

  /** 站点店铺唯一标识（修改时提交） */
  shopKey = "";

  /** 店铺编号 */
  shopNo = "";

  /** 密码 */
  shopPassword = "";

  /** 秘钥 */
  shopSecureKey = "";

  /** 店铺链接 */
  shopUrl = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;
}

class PlatformSiteShopRequestParamsDto {
  /** 授权状态(针对国内平台) 0：未授权 1：已授权 */
  accredit = undefined;

  /** 平台店铺应用表账号 */
  appAccount = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间-结束 */
  createTimeEnd = "";

  /** 创建时间-开始 */
  createTimeStart = "";

  /** 删除标识 */
  deleted = undefined;

  /** 财务收支表账号 */
  financeAccount = "";

  /** 财务编号 */
  financeCode = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** marketId（多个值用英文,拼接） */
  marketId = "";

  /** 站点店铺名 */
  name = "";

  /** 站点店铺名集合 */
  names = "";

  /** 主体信息id -1:表示无 */
  orderCompanyId = undefined;

  /** 平台标识（多个值用英文,拼接） */
  platformKey = "";

  /** 平台标识 */
  platformKeyList = [];

  /** 平台名称 */
  platformName = "";

  /** 平台店铺名称 */
  platformShopName = "";

  /** 站点标识key（多个值用英文,拼接） */
  platformSiteKey = "";

  /** 平台名称 */
  platformSiteName = "";

  /** 备注 */
  remark = "";

  /** sellerId */
  sellerId = "";

  /** 访问令牌 */
  shopAccessToken = "";

  /** 账号 */
  shopAccount = "";

  /** 账号名称 */
  shopAccountName = "";

  /** 账号KEY */
  shopApikey = "";

  /** 站点店铺唯一标识 */
  shopKey = "";

  /** 店铺编号（多个值用英文,拼接） */
  shopNo = "";

  /** 密码 */
  shopPassword = "";

  /** 秘钥 */
  shopSecureKey = "";

  /** 店铺链接 */
  shopUrl = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class PlatformSiteShopResponseDto {
  /** 授权状态(针对国内平台) 0：未授权 1：已授权 */
  accredit = undefined;

  /** API状态，亚马逊平台 */
  apiState = undefined;

  /** 平台店铺应用表账号 */
  appAccount = "";

  /** 启用库存自动同步 0为否 1为是 */
  autoSyncStockFlag = undefined;

  /** 授权路径 */
  buildUrl = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 删除标识 */
  deleted = undefined;

  /** 财务收支表账号 */
  financeAccount = "";

  /** 财务编号 */
  financeCode = "";

  /** 多平台店铺编码 */
  gjShopCode = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** marketId */
  marketId = undefined;

  /** 站点店铺名 */
  name = "";

  /** 主体信息id */
  orderCompanyId = undefined;

  /** 主体相关信息 */
  orderCompanyRpcResponseDto = new OrderCompanyRpcResponseDto();

  /** 平台标识 */
  platformKey = "";

  /** 平台名称 */
  platformName = "";

  /** 平台店铺名称 */
  platformShopName = "";

  /** 站点标识key */
  platformSiteKey = "";

  /** 平台名称 */
  platformSiteName = "";

  /** 备注 */
  remark = "";

  /** sellerId */
  sellerId = "";

  /** 访问令牌 */
  shopAccessToken = "";

  /** 账号 */
  shopAccount = "";

  /** 账号名称 */
  shopAccountName = "";

  /** 账号KEY */
  shopApikey = "";

  /** 站点店铺唯一标识 */
  shopKey = "";

  /** 店铺编号 */
  shopNo = "";

  /** 密码 */
  shopPassword = "";

  /** 秘钥 */
  shopSecureKey = "";

  /** 店铺链接 */
  shopUrl = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 同步ebs错误信息 */
  syncEbsError = "";

  /** 同步ebs状态 0:未推送 1:推送中 2:推送失败 3:推送成功 4:EBS警告 */
  syncEbsStatus = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class PlmBomAddOutGoingRequestDto {
  /** BOM共享路径 */
  BomOutgoUrlList = "";

  /** 变更描述 */
  ChangeDescription = "";

  /** 产品SKU */
  ChangeLevel = "";

  /** 变更阶段 */
  ChangePhase = "";

  /** 变更类型 */
  ChangeType = "";

  /** 成本变化 */
  CostChange = "";

  /** ECN编号 */
  ECN = "";

  /** 变更原因 */
  ReasonsChange = "";

  /** 变更名称 */
  name = "";
}

class PlmBomChildRequestDto {
  /** bom子件编码 */
  childNumber = "";

  /** bom子件版本 */
  childVersion = "";

  /** 位号 */
  designator = "";

  /** bom子件数量 */
  quantity = "";

  /** bom子件单位 */
  unit = "";
}

class PlmBomCreateRequestDto {
  /** BOM共享路径 */
  bomOutgoUrl = "";

  /** bom父件编码 */
  parentNumber = "";

  /** bom父件版本 */
  parentVersion = "";

  /** bom明细 */
  plmBomChildDtoList = [];
}

class PlmBomListResponseDto {
  /** 描述 */
  description = "";

  /** 位号 */
  designator = "";

  /** id */
  id = undefined;

  /** 数量 */
  quantity = "";

  /** sku名称 */
  skuNameCn = "";

  /** sku编码 */
  skuNo = "";

  /** 单位 */
  unit = "";

  /** 物料修改时间 */
  updateTime = "";

  /** 版本号 */
  version = "";
}

class PlmBomOutCreateRequestDto {
  /** 申请原因/特批原因 */
  applicationReason = "";

  /** 是否为特批申请（0-否，1-是） */
  applicationType = undefined;

  /** 审批附件 */
  approvalFiles = [];

  /** 审批备注 */
  approvalRemark = "";

  /** 审批结果 1:通过 0:驳回 */
  approvalStatus = undefined;

  /** bom外发编号 */
  bomOutNo = "";

  /** 业务主键 */
  businessKey = "";

  /** 库存处理 */
  inventoryHandling = "";

  /** bom外发详情表 */
  itemRequestDto = [];

  /** 节点编码 */
  nodeKey = "";

  /** 外发类型 1-新品外发，2-ECN变更外发，3-供应链申请外发，4-风险包材资料外发，5-产品申请外发 */
  outgoingType = "";

  /** plm编号 */
  plmNumber = "";

  /** 流程定义key */
  processKey = "";

  /** 备注 */
  remark = "";

  /** sku编码 */
  skuNo = "";

  /** 任务id */
  taskId = "";
}

class PlmBomOutSupplyApprovalRequestDto {
  /** 审批附件 */
  approvalFiles = [];

  /** 审批备注 */
  approvalRemark = "";

  /** 审批结果 1:通过 0:驳回 */
  approvalStatus = undefined;

  /** bom外发编号 */
  bomOutNo = "";

  /** BOM共享路径 */
  bomShare = [];

  /** 业务主键 */
  businessKey = "";

  /** 节点编码 */
  nodeKey = "";

  /** bom外发附件 */
  outFileUrl = "";

  /** 流程定义key */
  processKey = "";

  /** 任务id */
  taskId = "";
}

class PlmBomOutgoingDetailResponseDto {
  /** 申请原因/特批原因 */
  applicationReason = "";

  /** 是否为特批申请（0-否，1-是） */
  applicationType = undefined;

  /** 审批附件 */
  approvalFiles = [];

  /** 审批状态 -1:未提交审批 0:已驳回 1:已通过 2:审批中 */
  approvalStatus = "";

  /** 审批通过时间 */
  approvalTime = "";

  /** bom外发编号 */
  bomOutNo = "";

  /** BOM共享路径 */
  bomShare = "";

  /** bom共享路径 */
  bomShares = [];

  /** ECN变更描述 */
  changeDescription = "";

  /** ECN变更主题 */
  changeName = "";

  /** ECN变更类型 */
  changeType = "";

  /** 审批节点 */
  currentApproval = "";

  /** 当前审批节点 */
  currentApprovalNode = "";

  /** id */
  id = undefined;

  /** 工作流实例ID */
  instanceId = "";

  /** 库存处理 */
  inventoryHandling = "";

  /** bom外发附件链接 */
  outFileUrl = "";

  /** 外发类型 1-新品外发，2-ECN变更外发 */
  outgoingType = "";

  /** plm编号 */
  plmNumber = "";

  /** ECN变更原因 */
  reasonsChange = "";

  /** 备注 */
  remark = "";

  /** bom外发详情表 */
  responseDtos = [];

  /** sku编码 */
  skuNo = "";

  /** sku详细信息 */
  skuResponseDtos = [];
}

class PlmBomOutgoingItemRequestDto {
  /** 地址 */
  address = "";

  /** 地址编号 */
  addressCode = "";

  /** 是否已签保密协议 */
  secretType = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商邮箱 */
  supplierEmail = [];

  /** 供应商ID=Code+交易主体缩写+供应商名称 */
  supplierIdName = "";

  /** 供应商名称 */
  supplierName = "";

  /** 交易主体code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";
}

class PlmBomOutgoingItemRequestParamsDto {
  /** bom外发编号 */
  bomOutNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 是否已签保密协议 */
  secretType = undefined;

  /** 供应商邮箱 */
  supplierEmail = "";

  /** 供应商ID=Code+交易主体缩写+供应商名称 */
  supplierIdName = "";

  /** 供应商名称 */
  supplierName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class PlmBomOutgoingItemResponseDto {
  /** 地址 */
  address = "";

  /** 地址编号 */
  addressCode = "";

  /** bom外发编号 */
  bomOutNo = "";

  /** 是否已签保密协议 */
  secretType = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商邮箱 */
  supplierEmail = [];

  /** 供应商ID=Code+交易主体缩写+供应商名称 */
  supplierIdName = "";

  /** 供应商名称 */
  supplierName = "";

  /** 交易主体code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";
}

class PlmBomOutgoingListResponseDto {
  /** 审批状态 -1:未提交审批 0:已驳回 1:已通过 2:审批中 */
  approvalStatus = "";

  /** bom外发编号 */
  bomOutNo = "";

  /** 当前审批人 */
  currentApproval = "";

  /** id */
  id = undefined;

  /** 审批实例id */
  instanceId = "";

  /** 外发类型 1-新品外发，2-ECN变更外发 */
  outgoingType = "";

  /** sku详情 */
  responseDto = [];

  /** sku编码 */
  skuNo = "";

  /** 供应商编号 */
  supplierIdName = [];

  /** 修改时间 */
  updateTime = "";
}

class PlmBomOutgoingRequestParamsDto {
  /** 审批状态支持多选，英文逗号分割, -1:未提交审批 0:已驳回 1:已通过 2:审批中 */
  approvalStatus = "";

  /** 审批状态 */
  approvalStatusList = [];

  /** 查询审批通过结束时间 */
  approvedEndTime = "";

  /** 查询审批通过开始时间 */
  approvedStartTime = "";

  /** bom外发编号 */
  bomOutNo = "";

  /** 当前页 */
  current = undefined;

  /** 当前审批人 */
  currentApproval = "";

  /** 查询创建结束时间 */
  endTime = "";

  /** id */
  id = undefined;

  /** 排序 */
  orderBy = "";

  /** 外发类型 1-新品外发，2-ECN变更外发 */
  outgoingType = undefined;

  /** 外发类型List 1-新品外发，2-ECN变更外发 */
  outgoingTypeList = [];

  /** 产品负责人 */
  productOwner = "";

  /** 采购负责人 */
  purchaser = "";

  /** 每页条数 */
  size = undefined;

  /** sku名称（CN） */
  skuNameCn = "";

  /** sku编码 */
  skuNo = "";

  /** spu编码 */
  spuNo = "";

  /** 查询创建开始时间 */
  startTime = "";
}

class PlmBomOutgoingSkuResponseDto {
  /** bom附件链接 */
  bomFileUrl = "";

  /** 产品线，乐器，户外，文创，其他 */
  buCode = "";

  /** 产品负责人 */
  productOwner = "";

  /** 项目经理用户编码 */
  projectManager = "";

  /** 采购负责人 */
  purchaser = "";

  /** 二级品类 */
  secondaryProductLine = "";

  /** 二级品类名称 */
  secondaryProductLineName = "";

  /** sku名称 */
  skuNameCn = "";

  /** sku编码 */
  skuNo = "";

  /** spu编码 */
  spuNo = "";
}

class PlmCategoryListResponseDto {
  /** 品类编码 */
  categoryCode = "";

  /** 品类名称 */
  categoryName = "";

  /** id */
  id = undefined;

  /** 等级 */
  levelNum = undefined;

  /** 上级品类编码 */
  parentCategoryCode = "";

  /** 上级品类Id */
  parentId = undefined;

  /** 状态 */
  status = undefined;
}

class PlmCategoryListResponseRpcDto {
  /** 品类编码 */
  categoryCode = "";

  /** 品类名称 */
  categoryName = "";

  /** 等级 */
  levelNum = undefined;

  /** 上级品类编码 */
  parentCategoryCode = "";

  /** 上级品类Id */
  parentId = undefined;

  /** 状态 */
  status = undefined;
}

class PlmCategoryRequestParamsDto {
  /** 品类编码 */
  categoryCode = "";

  /** 品类名称 */
  categoryName = "";

  /** id */
  id = undefined;

  /** 等级 */
  levelNum = undefined;

  /** 上级品类编码 */
  parentCategoryCode = "";

  /** 上级品类Id */
  parentId = undefined;
}

class PlmCategoryTreeResponseDto {
  /** 品类编码 */
  categoryCode = "";

  /** 品类名称 */
  categoryName = "";

  /** id */
  id = undefined;

  /** 等级 */
  levelNum = undefined;

  /** 分类子集 */
  nextLevelList = [];

  /** 上级品类编码 */
  parentCategoryCode = "";

  /** 上级品类Id */
  parentId = undefined;
}

class PlmMaterialCategoryRequestParamsDto {
  /** 品类编码 */
  categoryCode = "";

  /** 品类名称 */
  categoryName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 等级 */
  levelNum = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 上级code */
  parentCode = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class PlmMaterialCategoryResponseDto {
  /** 品类编码 */
  categoryCode = "";

  /** 品类名称 */
  categoryName = "";

  /** 下级分类 */
  children = [];

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 等级 */
  levelNum = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 上级code */
  parentCode = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class PlmMaterialCreateRequestDto {
  /** 业务状态 */
  bizStatus = "";

  /** bomfileUrl */
  bomfileUrl = "";

  /** 创建时间 */
  createDate = "";

  /** 描述 */
  description = "";

  /** 更新时间 */
  modifyDate = "";

  /** 中文名称 */
  name = "";

  /** number-sku编码 */
  number = "";

  /** 预估单价(CNY) */
  partEstimateUnitPrice = "";

  /** 制造商 */
  partManufacturer = "";

  /** 制造商型号 */
  partManufacturerModel = "";

  /** 采购属性 */
  source = "";

  /** 单位 */
  unit = "";

  /** 版本号 */
  version = "";
}

class PlmNewOrderApprovalRequestDto {
  /** 审批备注 */
  approvalRemark = "";

  /** 审批结果 1:通过 0:驳回 */
  approvalStatus = undefined;

  /** 业务主键 */
  businessKey = "";

  /** 节点编码 */
  nodeKey = "";

  /** 新品下单no */
  npono = "";

  /** 流程定义key */
  processKey = "";

  /** purchaseRequisitionCreateList */
  purchaseRequisitionCreateList = [];

  /** 采购申请 */
  purchaseRequisitionList = [];

  /** 任务id */
  taskId = "";
}

class PlmNewOrderDemandCreateRequestDto {
  /** 需求金额 */
  demandAmount = undefined;

  /** MPQ */
  mpq = undefined;

  /** MSKU */
  msku = "";

  /** 平台标识key */
  platformKey = "";

  /** 需求数量 */
  qty = undefined;

  /** 店铺信息（编号、名称、msku） */
  shopInfo = "";

  /** 站点 */
  siteKey = "";

  /** 交易主体code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";
}

class PlmNewOrderDemandDetailResponseDto {
  /** 需求金额 */
  demandAmount = undefined;

  /** MPQ */
  mpq = undefined;

  /** MSKU */
  msku = "";

  /** 平台标识key */
  platformKey = "";

  /** 需求数量 */
  qty = undefined;

  /** 店铺信息（编号、名称、msku） */
  shopInfo = "";

  /** 站点 */
  siteKey = "";

  /** 交易主体code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";
}

class PlmPurchaseRequisitionDto {
  /** 渠道code 亚马逊：amazon，全球渠道：global_channels */
  channel = "";

  /** msku */
  msku = "";

  /** PR采购量 */
  number = undefined;

  /** planDeliveryDate, 计划交货日期 */
  planDeliveryDate = "";

  /** PR备注 */
  remark = "";

  /** 交易主体code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";
}

class PlmSkuApprovalRequestDto {
  /** 审批备注 */
  approvalRemark = "";

  /** 审批结果 1:通过 0:驳回 */
  approvalStatus = undefined;

  /** 业务主键 */
  businessKey = "";

  /** 节点编码 */
  nodeKey = "";

  /** sku报关信息 */
  plmSkuCustomsEditRequestDto = new PlmSkuCustomsEditRequestDto();

  /** sku主体信息 */
  plmSkuEditRequestDto = new PlmSkuEditRequestDto();

  /** 流程定义key */
  processKey = "";

  /** sku编码 */
  skuNo = "";

  /** 任务id */
  taskId = "";
}

class PlmSkuBillingResponseDto {
  /** 海关要素NO */
  cino = "";

  /** 是否商检 */
  commodityInspectionFlag = false;

  /** 法定海关单位 */
  customsUnitName = "";

  /** 申报名称（CN） */
  declareNameCn = "";

  /** 申报名称（EN） */
  declareNameEn = "";

  /** HSCODE(国内) */
  hscodeCn = "";

  /** 开票单位 */
  invoiceUnitName = "";

  /** 产品型号 */
  skuModel = "";

  /** 出口退税率 */
  taxRebateRate = undefined;
}

class PlmSkuBillingResponseRpcDto {
  /** 海关要素NO */
  cino = "";

  /** 是否商检 */
  commodityInspectionFlag = false;

  /** 法定海关单位 */
  customsUnitName = "";

  /** 申报名称（CN） */
  declareNameCn = "";

  /** 申报名称（EN） */
  declareNameEn = "";

  /** HSCODE(国内) */
  hscodeCn = "";

  /** 开票单位 */
  invoiceUnitName = "";

  /** 产品型号 */
  skuModel = "";

  /** 出口退税率 */
  taxRebateRate = undefined;
}

class PlmSkuBomDetailResponseDto {
  /** bom附件链接 */
  bomFileUrl = "";

  /** bom列表 */
  plmSkuBomTreeResponseDtos = [];

  /** bom更新时间 */
  updateTime = "";
}

class PlmSkuBomTreeResponseDto {
  /** bom修改时间 */
  bomUpdateTime = "";

  /** sku名称（物料名称） */
  childSkuName = "";

  /** sku编码（物料编码） */
  childSkuNo = "";

  /** 描述 */
  description = "";

  /** 位号 */
  designator = "";

  /** parentSkuNo */
  parentSkuNo = "";

  /** bom子树 */
  plmSkuBomTreeResponseDtos = [];

  /** 数量 */
  quantity = "";

  /** 物料修改时间 */
  skuUpdateTime = "";

  /** 单位 */
  unit = "";

  /** 版本号 */
  version = "";
}

class PlmSkuBriefDetailDto {
  /** 审核状态 */
  approvalStatus = undefined;

  /** 品牌编码，即是编码也是名称，plm传过来的数据 */
  brandNo = "";

  /** 产品线，乐器，户外，文创，其他 */
  buCode = "";

  /** 需求计划员 */
  demandPlanner = "";

  /** id */
  id = undefined;

  /** 图片链接 */
  imageUrl = "";

  /** 操盘负责人 */
  opOwner = "";

  /** 操盘产品组标识 0: 否，1：是 */
  opProductGroupFlag = undefined;

  /** 一级品类 */
  primaryProductLine = "";

  /** 一级品类名称 */
  primaryProductLineName = "";

  /** 产品模式 */
  productModel = "";

  /** 产品负责人 */
  productOwner = "";

  /** sku类型 */
  productType = "";

  /** 采购负责人 */
  purchaser = "";

  /** 二级品类 */
  secondaryProductLine = "";

  /** 二级品类名称 */
  secondaryProductLineName = "";

  /** sku名称（CN） */
  skuNameCn = "";

  /** sku名称（EN） */
  skuNameEn = "";

  /** sku编码 */
  skuNo = "";

  /** spu编码 */
  spuNo = "";

  /** 供应计划员 */
  supplyPlanner = "";
}

class PlmSkuBriefDetailResponseRpcDto {
  /** 审核状态 */
  approvalStatus = undefined;

  /** 品牌编码，即是编码也是名称，plm传过来的数据 */
  brandNo = "";

  /** 产品线，乐器，户外，文创，其他 */
  buCode = "";

  /** 需求计划员 */
  demandPlanner = "";

  /** id */
  id = undefined;

  /** 图片链接 */
  imageUrl = "";

  /** 操盘负责人 */
  opOwner = "";

  /** 操盘产品组标识 0: 否，1：是 */
  opProductGroupFlag = undefined;

  /** 一级品类 */
  primaryProductLine = "";

  /** 一级品类名称 */
  primaryProductLineName = "";

  /** 产品负责人 */
  productOwner = "";

  /** 采购负责人 */
  purchaser = "";

  /** 二级品类 */
  secondaryProductLine = "";

  /** 二级品类名称 */
  secondaryProductLineName = "";

  /** sku名称（CN） */
  skuNameCn = "";

  /** sku名称（EN） */
  skuNameEn = "";

  /** sku编码 */
  skuNo = "";

  /** spu编码 */
  spuNo = "";

  /** 供应计划员 */
  supplyPlanner = "";
}

class PlmSkuBriefInfoDto {
  /** id */
  id = undefined;

  /** 产品模式 */
  productMode = "";

  /** 采购属性 */
  purchaseProperty = "";

  /** sku名称（CN） */
  skuNameCn = "";

  /** sku名称（EN） */
  skuNameEn = "";

  /** sku编码 */
  skuNo = "";
}

class PlmSkuCostInfoRequestDto {
  /** 预估单价(CNY成本) */
  costEstimateUnitPrice = "";

  /** 制造商(成本) */
  costManufacturer = "";

  /** sku编码 */
  skuNo = "";
}

class PlmSkuCreateRequestDto {
  /** 业务状态 */
  bizStatus = "";

  /** BOM共享路径 */
  bomOutgoUrl = "";

  /** bomfileUrl */
  bomfileUrl = "";

  /** 箱规高（CM） */
  cartonSizeHigh = "";

  /** 产品包装高（CM） */
  cartonSizeLength = "";

  /** 箱规宽（CM） */
  cartonSizeWidth = "";

  /** 计费重量（KG） */
  chargedWeight = "";

  /** 商品尺寸分段 */
  commoditySize = "";

  /** 创建时间 */
  createDate = "";

  /** 立项时间 */
  createProjectTime = "";

  /** 产品负责人 */
  creator = "";

  /** 描述 */
  description = "";

  /** 每箱数量（MPQ） */
  eachCartonQTY = "";

  /** 英文名称 */
  englishName = "";

  /** 预计量产结束日 */
  estimatedProduction = "";

  /** 产品包装毛重（KG） */
  grossPackingWeight = "";

  /** 数据状态 */
  lifecycle = "";

  /** 更新时间 */
  modifyDate = "";

  /** 中文名称 */
  name = "";

  /** number-sku编码 */
  number = "";

  /** 装箱体积 */
  packingVolume = "";

  /** 预估单价(CNY) */
  partEstimateUnitPrice = "";

  /** 制造商 */
  partManufacturer = "";

  /** 制造商型号 */
  partManufacturerModel = "";

  /** 产品包装高（CM） */
  prdPackagingHigh = "";

  /** 产品包装长（CM） */
  prdPackagingLength = "";

  /** 产品包装长（CM） */
  prdPackagingWidth = "";

  /** 产品属性：1-全新品 2-迭代品 3-拓展品 */
  productAttribute = undefined;

  /** 产品高（CM） */
  productBodyWeight = "";

  /** 产品高（CM） */
  productHeight = "";

  /** 产品长（CM） */
  productLength = "";

  /** 产品长（CM） */
  productWidth = "";

  /** 关联旧SKU编码（当产品属性为迭代品/拓展品时必填） */
  relatedOldSku = "";

  /** 销售地区 */
  salesTerritory = "";

  /** 箱规高（CM） */
  singleBoxNet = "";

  /** 单箱毛重（KG） */
  singleGrossWeight = "";

  /** 采购属性 */
  source = "";

  /** spuNumber-spu编码 */
  spuNumber = "";

  /** 单位 */
  unit = "";

  /** 版本号 */
  version = "";

  /** 体积重（KG） */
  volumeWeight = "";
}

class PlmSkuCustomsClearanceResponseDto {
  /** 产品认证类型 */
  certificationType = "";

  /** 海关监管条件 */
  customsControl = "";

  /** 申报要素 */
  declareMemo = "";

  /** 是否申报型号 */
  declareTypeFlag = undefined;

  /** 检疫检验类别 */
  inspectionType = "";

  /** 产品材质名称（CN） */
  materialNameCn = "";

  /** 产品材质名称（EN） */
  materialNameEn = "";

  /** 海关要素明细 */
  plmSkuCustomsResponseDtos = [];

  /** 产品用途（CN） */
  productUseCn = "";

  /** 产品用途（EN） */
  productUseEn = "";
}

class PlmSkuCustomsClearanceResponseRpcDto {
  /** 产品认证类型 */
  certificationType = "";

  /** 海关监管条件 */
  customsControl = "";

  /** 申报要素 */
  declareMemo = "";

  /** 是否申报型号 */
  declareTypeFlag = undefined;

  /** 检疫检验类别 */
  inspectionType = "";

  /** 产品材质名称（CN） */
  materialNameCn = "";

  /** 产品材质名称（EN） */
  materialNameEn = "";

  /** 海关要素明细 */
  plmSkuCustomsResponseDtos = [];

  /** 产品用途（CN） */
  productUseCn = "";

  /** 产品用途（EN） */
  productUseEn = "";
}

class PlmSkuCustomsEditRequestDto {
  /** 产品认证类型 */
  certificationType = "";

  /** 申报编号 */
  cino = "";

  /** 海关监管条件 */
  customsControl = "";

  /** 申报要素 */
  declareMemo = "";

  /** 是否申报型号 0：是，1-否 */
  declareTypeFlag = undefined;

  /** 检疫检验类别 */
  inspectionType = "";

  /** 产品材质名称（CN） */
  materialNameCn = "";

  /** 产品材质名称（EN） */
  materialNameEn = "";

  /** 产品用途（CN） */
  productUseCn = "";

  /** 产品用途（EN） */
  productUseEn = "";

  /** 产品型号 */
  skuModel = "";

  /** sku编码 */
  skuNo = "";
}

class PlmSkuCustomsResponseDto {
  /** 是否反倾销 */
  antiDumpingFlag = undefined;

  /** 反倾销税 */
  antiDumpingRate = undefined;

  /** 中文名称 */
  countryNameCn = "";

  /** 海关编码 */
  hscodeCn = "";

  /** id */
  id = undefined;

  /** 国家二字码 */
  secondWord = "";

  /** SKU编号 */
  skuNo = "";

  /** 关税率 */
  tariffRate = undefined;
}

class PlmSkuCustomsResponseRpcDto {
  /** 是否反倾销 */
  antiDumpingFlag = undefined;

  /** 反倾销税 */
  antiDumpingRate = undefined;

  /** 中文名称 */
  countryNameCn = "";

  /** 海关编码 */
  hscodeCn = "";

  /** id */
  id = undefined;

  /** 国家二字码 */
  secondWord = "";

  /** SKU编号 */
  skuNo = "";

  /** 关税率 */
  tariffRate = undefined;
}

class PlmSkuDetailInfoResponseDto {
  /** 审核状态 */
  approvalStatus = undefined;

  /** 业务状态 DVT、PVT、MP、EOS、EOM、EOP、EOS */
  bizStatus = "";

  /** bom附件链接 */
  bomFileUrl = "";

  /** 品牌名称，只有物料有 */
  brandName = "";

  /** 预估单价(CNY成本) */
  costEstimateUnitPrice = "";

  /** 制造商(成本) */
  costManufacturer = "";

  /** 当前审批节点 */
  currentApprovalNode = "";

  /** 是否报关 1是 */
  customsClearanceFlag = undefined;

  /** 交货模式 计划交货：1 订单交货：2 */
  deliveryMode = undefined;

  /** 描述 */
  description = "";

  /** 预计量产 */
  estimatedProduct = "";

  /** GTIN编码 */
  gtinCode = "";

  /** GTIN编码eu */
  gtinCodeEu = "";

  /** GTIN编码jp */
  gtinCodeJp = "";

  /** 历史数据标识,0-是，1-否 */
  historyFlag = undefined;

  /** id */
  id = undefined;

  /** 图片链接 */
  imageUrl = "";

  /** 资料是否完整 0: 是，1：否 */
  informationCompleteFlag = undefined;

  /** 数据状态 正在工作、正在审核、已发布 */
  lifecycle = "";

  /** 物流分组编号 */
  logisticsGroupNo = "";

  /** 操盘负责人 */
  opOwner = "";

  /** 操盘产品组标识 0: 否，1：是 */
  opProductGroupFlag = undefined;

  /** 预估单价(CNY) */
  partEstimateUnitPrice = "";

  /** 制造商 */
  partManufacturer = "";

  /** 制造商型号 */
  partManufacturerModel = "";

  /** plmSkuBillingResponseDto */
  plmSkuBillingResponseDto = new PlmSkuBillingResponseDto();

  /** bom清单 */
  plmSkuBomDetailResponseDto = new PlmSkuBomDetailResponseDto();

  /** 报关信息 */
  plmSkuCustomsClearanceResponseDto = new PlmSkuCustomsClearanceResponseDto();

  /** sku管理信息 */
  plmSkuManageResponseDto = new PlmSkuManageResponseDto();

  /** sku包装信息 */
  plmSkuPackageResponseDto = new PlmSkuPackageResponseDto();

  /** sku供应商信息 */
  plmSkuVendorResponseDto = new PlmSkuVendorResponseDto();

  /** 仓储包装信息 */
  plmSkuWarehousePackageRootResponseDto = new PlmSkuWarehousePackageRootResponseDto();

  /** spu简要信息 */
  plmSpuBriefInfoResponseDto = new PlmSpuBriefInfoResponseDto();

  /** 物料一级分类 */
  primaryCategoryLine = "";

  /** 产品属性：1-全新品 2-迭代品 3-拓展品 */
  productAttribute = undefined;

  /** 产品属性名称 */
  productAttributeName = "";

  /** 是否产品化管理 0: 是，1：否 */
  productManagementFlag = undefined;

  /** 产品模式 外采、合作开发、自研 */
  productModel = "";

  /** 产品类型 成品、物料 */
  productType = "";

  /** 是否可采购,0-否，1-是 */
  purchaseFlag = undefined;

  /** 采购属性 */
  purchaseProperty = "";

  /** 关联旧SKU编码 */
  relatedOldSku = "";

  /** 销售链接 */
  saleLinks = "";

  /** 销售价格 */
  salePrice = undefined;

  /** 销售地区,多值（英文分号拼接） */
  salesTerritory = "";

  /** 物料二级分类 */
  secondaryCategoryLine = "";

  /** sku名称（CN） */
  skuNameCn = "";

  /** sku名称（EN） */
  skuNameEn = "";

  /** sku编码 */
  skuNo = "";

  /** 军团信息 */
  spuAndCorpsInfoResponseDto = new SpuAndCorpsInfoResponseDto();

  /** 物料三级分类 */
  tertiaryCategoryLine = "";

  /** 单位 */
  unit = "";

  /** 版本号 */
  version = "";
}

class PlmSkuDetailInfoResponseRpcDto {
  /** 审核状态 */
  approvalStatus = undefined;

  /** 业务状态 DVT、PVT、MP、EOS、EOM、EOP、EOS */
  bizStatus = "";

  /** bom附件链接 */
  bomFileUrl = "";

  /** 交货模式 计划交货：1 订单交货：2 */
  deliveryMode = undefined;

  /** 描述 */
  description = "";

  /** 预计量产结束日期 */
  endTime = "";

  /** 预计量产 */
  estimatedProduct = "";

  /** id */
  id = undefined;

  /** 图片链接 */
  imageUrl = "";

  /** 资料是否完整 0: 是，1：否 */
  informationCompleteFlag = undefined;

  /** 数据状态 正在工作、正在审核、已发布 */
  lifecycle = "";

  /** 物流分组编号 */
  logisticsGroupNo = "";

  /** plmSkuBillingResponseDto */
  plmSkuBillingResponseDto = new PlmSkuBillingResponseRpcDto();

  /** 报关信息 */
  plmSkuCustomsClearanceResponseDto = new PlmSkuCustomsClearanceResponseRpcDto();

  /** sku管理信息 */
  plmSkuManageResponseDto = new PlmSkuManageResponseRpcDto();

  /** sku包装信息 */
  plmSkuPackageResponseDto = new PlmSkuPackageResponseRpcDto();

  /** sku供应商信息 */
  plmSkuVendorResponseDto = new PlmSkuVendorResponseRpcDto();

  /** spu简要信息 */
  plmSpuBriefInfoResponseDto = new PlmSpuBriefInfoResponseRpcDto();

  /** 是否产品化管理 0: 是，1：否 */
  productManagementFlag = undefined;

  /** 产品模式 外采、合作开发、自研 */
  productModel = "";

  /** 产品类型 成品、物料 */
  productType = "";

  /** 采购属性 */
  purchaseProperty = "";

  /** 销售地区,多值（英文分号拼接） */
  salesTerritory = "";

  /** sku名称（CN） */
  skuNameCn = "";

  /** sku名称（EN） */
  skuNameEn = "";

  /** sku编码 */
  skuNo = "";

  /** 军团信息 */
  spuCorpResponseDto = new SpuCorpResponseRpcDto();

  /** 单位 */
  unit = "";

  /** 版本号 */
  version = "";
}

class PlmSkuEditHistoryRequestDto {
  /** 装箱高 */
  boxHeightCm = undefined;

  /** 装箱长 */
  boxLongCm = undefined;

  /** 每箱数量（MPQ） */
  boxMpq = undefined;

  /** 装箱宽 */
  boxWidthCm = undefined;

  /** 商品尺寸 */
  commoditySize = "";

  /** 预计量产 */
  estimatedProduct = "";

  /** 产品高 */
  heightCm = undefined;

  /** 产品长 */
  longCm = undefined;

  /** 产品包装高 */
  packHeightCm = undefined;

  /** 产品包装长 */
  packLongCm = undefined;

  /** 产品包装重量（g） */
  packWeight = undefined;

  /** 产品包装宽 */
  packWidthCm = undefined;

  /** 销售地区,多值（英文分号拼接） */
  salesTerritory = "";

  /** 单箱计费重（G） */
  singleBillingWeight = undefined;

  /** 装箱体积 */
  singleBoxVolume = undefined;

  /** 单箱体积重(G)' */
  singleBoxVolumeWeight = undefined;

  /** 单箱净重(G) */
  singleBoxWeight = undefined;

  /** 单箱毛重(G) */
  singleGrossWeight = undefined;

  /** sku名称（CN） */
  skuNameCn = "";

  /** sku名称（EN） */
  skuNameEn = "";

  /** sku编码 */
  skuNo = "";

  /** 产品本体净重（g） */
  weight = undefined;

  /** 产品宽 */
  widthCm = undefined;
}

class PlmSkuEditRequestDto {
  /** 品牌名称，只有物料有 */
  brandName = "";

  /** 申报编号 */
  cino = "";

  /** 是否报关 1是 */
  customsClearanceFlag = undefined;

  /** 交货模式 计划交货：1 订单交货：2 */
  deliveryMode = undefined;

  /** GTIN编码 */
  gtinCode = "";

  /** GTIN编码Eu */
  gtinCodeEu = "";

  /** GTIN编码JP */
  gtinCodeJp = "";

  /** 图片链接 */
  imageUrl = "";

  /** 物流分组编号 */
  logisticsGroupNo = "";

  /** 产品材质名称（CN） */
  materialNameCn = "";

  /** 产品材质名称（EN） */
  materialNameEn = "";

  /** 操盘负责人 */
  opOwner = "";

  /** 操盘产品组标识 0: 否，1：是 */
  opProductGroupFlag = undefined;

  /** 管理信息 */
  plmSkuManageEditRequestDto = new PlmSkuManageEditRequestDto();

  /** 销售信息 */
  plmSkuSaleEditRequestDto = new PlmSkuSaleEditRequestDto();

  /** 产品属性：1-全新品 2-迭代品 3-拓展品 */
  productAttribute = undefined;

  /** 是否产品化管理 0: 是，1：否 */
  productManagementFlag = undefined;

  /** 产品模式 外采、合作开发、自研 */
  productModel = "";

  /** 产品用途（CN） */
  productUseCn = "";

  /** 产品用途（EN） */
  productUseEn = "";

  /** 是否可采购 */
  purchaseFlag = undefined;

  /** 关联旧SKU编码（当产品属性为迭代品/拓展品时必填） */
  relatedOldSku = "";

  /** 产品型号 */
  skuModel = "";

  /** sku编码 */
  skuNo = "";
}

class PlmSkuForecastApprovalRequestDto {
  /** 审批备注 */
  approvalRemark = "";

  /** 审批结果 1:通过 0:驳回 */
  approvalStatus = undefined;

  /** 业务主键 */
  businessKey = "";

  /** 节点编码 */
  nodeKey = "";

  /** sku编码 */
  plmSkuForecastCreateRequestDto = new PlmSkuForecastCreateRequestDto();

  /** 流程定义key */
  processKey = "";

  /** sku编码 */
  skuNo = "";

  /** 任务id */
  taskId = "";
}

class PlmSkuForecastCreateRequestDto {
  /** 销售预测附件 */
  fileUrl = "";

  /** 销售预测列表 */
  plmSkuForecastInfoRequestDtos = [];

  /** sku编码 */
  skuNo = "";
}

class PlmSkuForecastDetailRequestDto {
  /** 衡量标准类型 ,1-销量，2-销售额 */
  metricsType = undefined;

  /** 销售指标，可以销量也可以是销售额 */
  salesQty = undefined;

  /** 时间维度序号，例如值为1，时间单位为month表示为一月份 */
  timeNumber = undefined;

  /** 时间单位 month-月，year-年 */
  timeUnit = "";
}

class PlmSkuForecastDetailResponseDto {
  /** 衡量标准类型 ,1-销量，2-销售额 */
  metricsType = undefined;

  /** 销售指标，可以销量也可以是销售额 */
  salesQty = undefined;

  /** 时间维度序号，例如值为1，时间单位为month表示为一月份 */
  timeNumber = undefined;

  /** 时间单位 month-月，year-年 */
  timeUnit = "";
}

class PlmSkuForecastInfoRequestDto {
  /** 币种 */
  currency = "";

  /** 预测销售单价 */
  expectUnitPrice = undefined;

  /** 赠品数量 */
  giftQuantity = undefined;

  /** 平台标识key */
  platformKey = "";

  /** 预测销售明细 */
  plmSkuForecastDetailRequestDtos = [];

  /** 备注 */
  remark = "";

  /** 销售负责人 */
  salesProcessor = "";

  /** 站点标识 */
  siteKey = "";

  /** 预计上架月份 */
  startSellMonth = "";
}

class PlmSkuForecastInfoResponseDto {
  /** 币种 */
  currency = "";

  /** 预测销售单价 */
  expectUnitPrice = undefined;

  /** 赠品数量 */
  giftQuantity = undefined;

  /** 平台标识key */
  platformKey = "";

  /** 预测销售明细 */
  plmSkuForecastDetailResponseDtos = [];

  /** 备注 */
  remark = "";

  /** 销售负责人 */
  salesProcessor = "";

  /** 站点标识 */
  siteKey = "";

  /** 预计上架月份 */
  startSellMonth = "";
}

class PlmSkuForecastResponseDto {
  /** 审核状态 */
  approvalStatus = undefined;

  /** 当前审批节点 */
  currentApprovalNode = "";

  /** 销售预测附件 */
  fileUrl = "";

  /** 销售预测列表 */
  plmSkuForecastInfoResponseDtos = [];

  /** sku名称（CN） */
  skuNameCn = "";

  /** sku编码 */
  skuNo = "";
}

class PlmSkuListForecastResponseDto {
  /** 审核状态 */
  approvalStatus = undefined;

  /** 预测销售单价 */
  expectUnitPrice = undefined;

  /** 是否已创建销售预测，0-是，1-否 */
  forecastCreateFlag = undefined;

  /** id */
  id = undefined;

  /** 审批实例id */
  instanceId = "";

  /** 是否新品通过，0-是，1-否 */
  newSkuFlag = undefined;

  /** 产品负责人 */
  productOwner = "";

  /** 销售负责人 */
  salesProcessor = "";

  /** sku名称（CN） */
  skuNameCn = "";

  /** sku编号 */
  skuNo = "";

  /** 修改时间 */
  updateTime = "";
}

class PlmSkuListResponseDto {
  /** 审核状态 */
  approvalStatus = undefined;

  /** 业务状态 */
  bizStatus = "";

  /** 装箱高 */
  boxHeightCm = undefined;

  /** 装箱长 */
  boxLongCm = undefined;

  /** 每箱数量（MPQ） */
  boxMpq = undefined;

  /** 装箱宽 */
  boxWidthCm = undefined;

  /** 品牌名称 */
  brandName = "";

  /** 品牌编号 */
  brandNo = "";

  /** 产品线，乐器，户外，文创，其他,数据由plm传，值为中文名称 */
  buCode = "";

  /** 海关要素NO */
  cino = "";

  /** 商品尺寸分段 */
  commoditySize = "";

  /** 归属军团 */
  corpsName = "";

  /** 预估单价(CNY成本) */
  costEstimateUnitPrice = "";

  /** 制造商(成本) */
  costManufacturer = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 是否报关 1是 */
  customsClearanceFlag = undefined;

  /** 申报要素 */
  declareMemo = "";

  /** 申报名称（CN） */
  declareNameCn = "";

  /** 交货模式 计划交货：1 订单交货：2 */
  deliveryMode = undefined;

  /** 需求计划员 */
  demandPlanner = "";

  /** 描述 */
  description = "";

  /** GTIN编码 */
  gtinCode = "";

  /** GTIN编码Eu */
  gtinCodeEu = "";

  /** GTIN编码jp */
  gtinCodeJp = "";

  /** 产品高 */
  heightCm = undefined;

  /** 历史数据标识,0-是，1-否 */
  historyFlag = undefined;

  /** HSCODE(国内) */
  hscodeCn = "";

  /** id */
  id = undefined;

  /** 图片链接 */
  imageUrl = "";

  /** 审批流实例id */
  instanceId = "";

  /** 开票单位 */
  invoiceUnitName = "";

  /** 数据状态 */
  lifecycle = "";

  /** 物流分组编号 */
  logisticsGroupNo = "";

  /** 产品长 */
  longCm = undefined;

  /** 最小供应商moq */
  minMoq = undefined;

  /** 包装高 */
  packHeightCm = undefined;

  /** 包装长 */
  packLongCm = undefined;

  /** 包装重量(g) */
  packWeight = undefined;

  /** 包装宽 */
  packWidthCm = undefined;

  /** 预估单价(CNY) */
  partEstimateUnitPrice = "";

  /** 制造商 */
  partManufacturer = "";

  /** 制造商型号 */
  partManufacturerModel = "";

  /** 一级品类 */
  primaryProductLine = "";

  /** 产品属性：1-全新品 2-迭代品 3-拓展品 */
  productAttribute = undefined;

  /** 产品属性名称 */
  productAttributeName = "";

  /** 产品模式 外采、合作开发、自研 */
  productModel = "";

  /** 产品负责人 */
  productOwner = "";

  /** 产品类型 end_product-成品、material-物料 */
  productType = "";

  /** 物流周期 */
  productionCycle = undefined;

  /** 项目经理 */
  projectManager = "";

  /** 是否可采购,0-否，1-是 */
  purchaseFlag = undefined;

  /** 采购属性 */
  purchaseProperty = "";

  /** 采购负责人 */
  purchaser = "";

  /** 关联旧SKU编码 */
  relatedOldSku = "";

  /** 二级品类 */
  secondaryProductLine = "";

  /** 单箱计费重（G） */
  singleBillingWeight = undefined;

  /** 装箱体积 */
  singleBoxVolume = undefined;

  /** 产品型号 */
  skuModel = "";

  /** sku名称（CN） */
  skuNameCn = "";

  /** sku名称（EN） */
  skuNameEn = "";

  /** sku编码 */
  skuNo = "";

  /** spu名称（CN） */
  spuNameCn = "";

  /** spu名称（EN） */
  spuNameEn = "";

  /** spu编码 */
  spuNo = "";

  /** 供应商名称Code */
  supplierCode = "";

  /** 默认供应商名称 */
  supplierIdName = "";

  /** 供应商名称 */
  supplierName = "";

  /** 供应计划员 */
  supplyPlanner = "";

  /** 三级品类 */
  tertiaryProductLine = "";

  /** 单位 */
  unit = "";

  /** 修改时间 */
  updateTime = "";

  /** 版本号 */
  version = "";

  /** 包装装箱信息1 */
  warehousePackageInfo1 = new PlmSkuWarehousePackageResponseDto();

  /** 包装装箱信息2 */
  warehousePackageInfo2 = new PlmSkuWarehousePackageResponseDto();

  /** weight */
  weight = undefined;

  /** 产品宽 */
  widthCm = undefined;
}

class PlmSkuListResponseRpcDto {
  /** 业务状态 */
  bizStatus = "";

  /** 品牌编号，字段为plm传，值为中文名称 */
  brandNo = "";

  /** 产品线，乐器，户外，文创，其他，字段为plm传，值为中文名称 */
  buCode = "";

  /** 海关要素NO */
  cino = "";

  /** 创建人 */
  createBy = "";

  /** 需求计划员 */
  demandPlanner = "";

  /** 产品高 */
  heightCm = undefined;

  /** id */
  id = undefined;

  /** 资料是否完整 0: 是，1：否 */
  informationCompleteFlag = undefined;

  /** 数据状态 */
  lifecycle = "";

  /** 物流分组编号 */
  logisticsGroupNo = "";

  /** 产品长 */
  longCm = undefined;

  /** 包装高 */
  packHeightCm = undefined;

  /** 包装长 */
  packLongCm = undefined;

  /** 包装重量(g) */
  packWeight = undefined;

  /** 包装宽 */
  packWidthCm = undefined;

  /** 一级品类 */
  primaryProductLine = "";

  /** 产品负责人 */
  productOwner = "";

  /** 产品类型 end_product-成品、material-物料 */
  productType = "";

  /** 项目经理 */
  projectManager = "";

  /** 采购负责人 */
  purchaser = "";

  /** 二级品类 */
  secondaryProductLine = "";

  /** 产品型号 */
  skuModel = "";

  /** sku名称（CN） */
  skuNameCn = "";

  /** sku名称（EN） */
  skuNameEn = "";

  /** sku编码 */
  skuNo = "";

  /** spu名称（CN） */
  spuNameCn = "";

  /** spu名称（EN） */
  spuNameEn = "";

  /** spu编码 */
  spuNo = "";

  /** 供应计划员 */
  supplyPlanner = "";

  /** 三级品类 */
  tertiaryProductLine = "";

  /** 单位 */
  unit = "";

  /** 修改时间 */
  updateTime = "";

  /** 产品重量 */
  weight = undefined;

  /** 产品宽 */
  widthCm = undefined;
}

class PlmSkuManageEditRequestDto {
  /** 需求计划员 */
  demandPlanner = "";

  /** 需求计划员名称 */
  demandPlannerName = "";

  /** 产品负责人 */
  productOwner = "";

  /** 产品负责人名称 */
  productOwnerName = "";

  /** 项目经理 */
  projectManager = "";

  /** 项目经理名称 */
  projectManagerName = "";

  /** 采购负责人 */
  purchaser = "";

  /** 采购负责人名称 */
  purchaserName = "";

  /** sku编码 */
  skuNo = "";

  /** 供应计划员 */
  supplyPlanner = "";

  /** 供应计划员名称 */
  supplyPlannerName = "";
}

class PlmSkuManageResponseDto {
  /** 需求计划员 */
  demandPlanner = "";

  /** 需求计划员名称 */
  demandPlannerName = "";

  /** 产品负责人 */
  productOwner = "";

  /** 产品负责人名称 */
  productOwnerName = "";

  /** 项目经理 */
  projectManager = "";

  /** 项目经理名称 */
  projectManagerName = "";

  /** 采购负责人 */
  purchaser = "";

  /** 采购负责人名称 */
  purchaserName = "";

  /** 供应计划员 */
  supplyPlanner = "";

  /** 供应计划员名称 */
  supplyPlannerName = "";
}

class PlmSkuManageResponseRpcDto {
  /** 需求计划员 */
  demandPlanner = "";

  /** 产品负责人 */
  productOwner = "";

  /** 项目经理 */
  projectManager = "";

  /** 采购负责人 */
  purchaser = "";

  /** 供应计划员 */
  supplyPlanner = "";
}

class PlmSkuNewOrderCreateRequestDto {
  /** 地址 */
  address = "";

  /** 地址编号 */
  addressCode = "";

  /** 审批备注 */
  approvalRemark = "";

  /** 审批结果 1:通过 0:驳回 */
  approvalStatus = undefined;

  /** 业务主键 */
  businessKey = "";

  /** 需求明细 */
  demandDetailList = [];

  /** moq */
  moq = undefined;

  /** mpq */
  mpq = undefined;

  /** 节点编码 */
  nodeKey = "";

  /** 新品下单编号，修改草稿是传该参数，创建时不传 */
  npono = "";

  /** 下单总数 */
  orderQty = undefined;

  /** 流程定义key */
  processKey = "";

  /** 生产周期/天 */
  productionCycle = undefined;

  /** 备注 */
  remark = "";

  /** sku编码 */
  skuNo = "";

  /** 供应商Code */
  supplierCode = "";

  /** 供应商ID=Code+交易主体缩写+供应商名称 */
  supplierIdName = "";

  /** 供应商供应商名称 */
  supplierName = "";

  /** 供应商报价 */
  supplierQuotation = undefined;

  /** 任务id */
  taskId = "";

  /** 交易主体code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";
}

class PlmSkuNewOrderDetailResponseDto {
  /** 地址 */
  address = "";

  /** 地址编号 */
  addressCode = "";

  /** 产品线，乐器，户外，文创，其他 */
  buCode = "";

  /** 当前审批节点 */
  currentApprovalNode = "";

  /** 需求明细 */
  demandDetailList = [];

  /** 需求计划员 */
  demandPlanner = "";

  /** id */
  id = undefined;

  /** moq */
  moq = undefined;

  /** mpq */
  mpq = undefined;

  /** 下单总金额 */
  orderAmount = undefined;

  /** 下单总数 */
  orderQty = undefined;

  /** 订单状态 */
  orderStatus = "";

  /** 产品模式 外采、合作开发、自研 */
  productModel = "";

  /** 产品负责人 */
  productOwner = "";

  /** 生产周期/天 */
  productionCycle = undefined;

  /** 计划分配 */
  purchaseRequisitionResponseDtos = [];

  /** 采购负责人 */
  purchaser = "";

  /** 备注 */
  remark = "";

  /** 二级品类 */
  secondaryProductLine = "";

  /** 二级品类名称 */
  secondaryProductLineName = "";

  /** sku名称（CN） */
  skuNameCn = "";

  /** sku编码 */
  skuNo = "";

  /** spu编码 */
  spuNo = "";

  /** 供应商Code */
  supplierCode = "";

  /** 供应商ID=Code+交易主体缩写+供应商名称 */
  supplierIdName = "";

  /** 供应商供应商名称 */
  supplierName = "";

  /** 供应商报价 */
  supplierQuotation = undefined;

  /** 供应计划员 */
  supplyPlanner = "";

  /** 交易主体code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";
}

class PlmSkuNewOrderListResponseDto {
  /** 产品线，乐器，户外，文创，其他 */
  buCode = "";

  /** 需求计划员 */
  demandPlanner = "";

  /** id */
  id = undefined;

  /** 审批实例id */
  instanceId = "";

  /** 新品下单no */
  npono = "";

  /** 下单总金额 */
  orderAmount = undefined;

  /** 下单总数 */
  orderQty = "";

  /** 订单状态 */
  orderStatus = "";

  /** 产品负责人 */
  productOwner = "";

  /** 采购负责人 */
  purchaser = "";

  /** sku名称（CN） */
  skuNameCn = "";

  /** sku编码 */
  skuNo = "";

  /** 供应商编码 */
  supplierCode = "";

  /** 供应商ID */
  supplierIdName = "";

  /** 供应商名称 */
  supplierName = "";

  /** 供应商报价 */
  supplierQuotation = undefined;

  /** 供应计划员 */
  supplyPlanner = "";

  /** 修改时间 */
  updateTime = "";
}

class PlmSkuNewOrderRequestParamsDto {
  /** 查询审批通过结束时间 */
  approvedEndTime = "";

  /** 查询审批通过开始时间 */
  approvedStartTime = "";

  /** 当前页 */
  current = undefined;

  /** 需求计划员 */
  demandPlanner = "";

  /** 查询创建结束时间 */
  endTime = "";

  /** id */
  id = undefined;

  /** npono */
  npono = "";

  /** 排序 */
  orderBy = "";

  /** 审批状态支持多选，英文逗号分割 */
  orderStatus = "";

  /** 审批状态 */
  orderStatusList = [];

  /** 产品负责人 */
  productOwner = "";

  /** 采购负责人 */
  purchaser = "";

  /** 每页条数 */
  size = undefined;

  /** sku名称（CN） */
  skuNameCn = "";

  /** sku编码 */
  skuNo = "";

  /** spu编码 */
  spuNo = "";

  /** 查询创建开始时间 */
  startTime = "";

  /** 供应计划员 */
  supplyPlanner = "";
}

class PlmSkuPackageInfoResponseRpcDto {
  /** 装箱高 */
  boxHeightCm = undefined;

  /** 装箱长 */
  boxLongCm = undefined;

  /** 每箱数量（MPQ） */
  boxMpq = undefined;

  /** 装箱宽 */
  boxWidthCm = undefined;

  /** 商品尺寸 */
  commoditySize = "";

  /** 产品高 */
  heightCm = undefined;

  /** 产品长 */
  longCm = undefined;

  /** 产品包装高 */
  packHeightCm = undefined;

  /** 产品包装长 */
  packLongCm = undefined;

  /** 产品包装重量（g） */
  packWeight = undefined;

  /** 产品包装宽 */
  packWidthCm = undefined;

  /** 单箱计费重（G） */
  singleBillingWeight = undefined;

  /** 装箱体积 */
  singleBoxVolume = undefined;

  /** 单箱体积重(G)' */
  singleBoxVolumeWeight = undefined;

  /** 单箱净重(G) */
  singleBoxWeight = undefined;

  /** 单箱毛重(G) */
  singleGrossWeight = undefined;

  /** sku名称（CN） */
  skuNameCn = "";

  /** sku名称（EN） */
  skuNameEn = "";

  /** sku编码 */
  skuNo = "";

  /** 供应计划员 */
  supplyPlanner = "";

  /** 产品本体净重（g） */
  weight = undefined;

  /** 产品宽 */
  widthCm = undefined;
}

class PlmSkuPackageResponseDto {
  /** 装箱高 */
  boxHeightCm = undefined;

  /** 装箱长 */
  boxLongCm = undefined;

  /** 每箱数量（MPQ） */
  boxMpq = undefined;

  /** 装箱宽 */
  boxWidthCm = undefined;

  /** 商品尺寸 */
  commoditySize = "";

  /** 产品高 */
  heightCm = undefined;

  /** 产品长 */
  longCm = undefined;

  /** 产品包装高 */
  packHeightCm = undefined;

  /** 产品包装长 */
  packLongCm = undefined;

  /** 产品包装重量（g） */
  packWeight = undefined;

  /** 产品包装宽 */
  packWidthCm = undefined;

  /** 单箱计费重（G） */
  singleBillingWeight = undefined;

  /** 装箱体积 */
  singleBoxVolume = undefined;

  /** 单箱体积重(G)' */
  singleBoxVolumeWeight = undefined;

  /** 单箱净重(G) */
  singleBoxWeight = undefined;

  /** 单箱毛重(G) */
  singleGrossWeight = undefined;

  /** 产品本体净重（g） */
  weight = undefined;

  /** 产品宽 */
  widthCm = undefined;
}

class PlmSkuPackageResponseRpcDto {
  /** 装箱高 */
  boxHeightCm = undefined;

  /** 装箱长 */
  boxLongCm = undefined;

  /** 每箱数量（MPQ） */
  boxMpq = undefined;

  /** 装箱宽 */
  boxWidthCm = undefined;

  /** 商品尺寸 */
  commoditySize = "";

  /** 产品高 */
  heightCm = undefined;

  /** 产品长 */
  longCm = undefined;

  /** 产品包装高 */
  packHeightCm = undefined;

  /** 产品包装长 */
  packLongCm = undefined;

  /** 产品包装重量（g） */
  packWeight = undefined;

  /** 产品包装宽 */
  packWidthCm = undefined;

  /** 单箱计费重（G） */
  singleBillingWeight = undefined;

  /** 装箱体积 */
  singleBoxVolume = undefined;

  /** 单箱体积重(G)' */
  singleBoxVolumeWeight = undefined;

  /** 单箱净重(G) */
  singleBoxWeight = undefined;

  /** 单箱毛重(G) */
  singleGrossWeight = undefined;

  /** 产品本体净重（g） */
  weight = undefined;

  /** 产品宽 */
  widthCm = undefined;
}

class PlmSkuProductLineAndCorpsRpcDto {
  /** 产品线，乐器，户外，文创，其他 */
  buCode = "";

  /** 一级品类名称 */
  categoryName = "";

  /** 军团长code */
  commanderCode = "";

  /** 军团长名字 */
  commanderName = "";

  /** 军团名称 */
  corpsName = "";

  /** 需求计划员 */
  demandPlanner = "";

  /** 一级品类 */
  primaryProductLine = "";

  /** sku名称（CN） */
  skuNameCn = "";

  /** sku编码 */
  skuNo = "";

  /** spu编码 */
  spuNo = "";
}

class PlmSkuRequestParamsDto {
  /** 审批状态 -1 待提交，0 已驳回，1 已通过，2审核中 英文逗号隔开 */
  approvalStatus = "";

  /** 业务状态 DVT、PVT、MP、EOS、EOM、EOP、EOS */
  bizStatus = "";

  /** 业务状态List DVT、PVT、MP、EOS、EOM、EOP、EOS */
  bizStatusList = [];

  /** 品牌编号 */
  brandNo = "";

  /** 申报编码 */
  cino = "";

  /** 当前页 */
  current = undefined;

  /** 需求计划员 */
  demandPlanner = "";

  /** 查询创建结束时间 */
  endTime = "";

  /** gtin编码 */
  gtinCode = "";

  /** gtin编码-eu */
  gtinCodeEu = "";

  /** id */
  id = undefined;

  /** 数据状态 正在工作、正在审核、已发布 */
  lifecycle = "";

  /** 数据状态List 正在工作、正在审核、已发布 */
  lifecycleList = [];

  /** 物料品类code */
  materialCategoryCode = "";

  /** 排序 */
  orderBy = "";

  /** 一级品类 */
  primaryProductLine = "";

  /** 一级品类列表 */
  primaryProductLineList = [];

  /** 产品属性：1-全新品 2-迭代品 3-拓展品 */
  productAttribute = undefined;

  /** 产品负责人 */
  productOwner = "";

  /** 产品类型 end_product-成品、material-物料 */
  productType = "";

  /** 项目经理 */
  projectManager = "";

  /** 采购负责人 */
  purchaser = "";

  /** 二级级品类列表 */
  secondaryProductLineList = [];

  /** 每页条数 */
  size = undefined;

  /** sku名称（CN） */
  skuNameCn = "";

  /** sku编码 */
  skuNo = "";

  /** sku编码模糊查询 */
  skuNoLike = "";

  /** spu名称（CN） */
  spuNameCn = "";

  /** spu编码 */
  spuNo = "";

  /** 查询创建开始时间 */
  startTime = "";

  /** 默认供应商Code */
  supplierCode = "";

  /** 默认供应商 */
  supplierName = "";

  /** 供应计划员 */
  supplyPlanner = "";

  /** 三级品类列表 */
  tertiaryProductLineList = [];

  /** 查询修改结束时间 */
  updateEndTime = "";

  /** 查询Spu修改结束时间 */
  updateSpuEndTime = "";

  /** 查询Spu修改开始时间 */
  updateSpuStartTime = "";

  /** 查询修改开始时间 */
  updateStartTime = "";
}

class PlmSkuRequestParamsRpcDto {
  /** 业务状态 DVT、PVT、MP、EOS、EOM、EOP、EOS */
  bizStatus = "";

  /** 品牌编号 */
  brandNo = "";

  /** 申报编码 */
  cino = "";

  /** 需求计划员 */
  demandPlanner = "";

  /** 查询创建结束时间 */
  endTime = "";

  /** id */
  id = undefined;

  /** 资料是否完整 0: 是，1：否 */
  informationCompleteFlag = undefined;

  /** 数据状态 正在工作、正在审核、已发布 */
  lifecycle = "";

  /** 产品负责人 */
  productOwner = "";

  /** 产品类型 end_product-成品、material-物料 */
  productType = "";

  /** 项目经理 */
  projectManager = "";

  /** 采购负责人 */
  purchaser = "";

  /** sku名称（CN） */
  skuNameCn = "";

  /** sku编码 */
  skuNo = "";

  /** spu名称（CN） */
  spuNameCn = "";

  /** spu编码 */
  spuNo = "";

  /** 查询创建开始时间 */
  startTime = "";

  /** 供应计划员 */
  supplyPlanner = "";

  /** 查询修改结束时间 */
  updateEndTime = "";

  /** 查询Spu修改结束时间 */
  updateSpuEndTime = "";

  /** 查询Spu修改开始时间 */
  updateSpuStartTime = "";

  /** 查询修改开始时间 */
  updateStartTime = "";
}

class PlmSkuSaleEditRequestDto {
  /** 是否报关 1是 */
  customsClearanceFlag = undefined;

  /** 预计量产结束日 */
  estimatedProduction = "";

  /** 销售链接 */
  saleLinks = "";

  /** 销售价格 */
  salePrice = undefined;

  /** 销售地区 */
  salesTerritory = "";

  /** sku编码 */
  skuNo = "";
}

class PlmSkuSimpleResponseRpcDto {
  /** SKU编号 */
  skuNo = "";

  /** SKU标题（CN） */
  skuTitleCn = "";
}

class PlmSkuVendorResponseDto {
  /** 地址 */
  address = "";

  /** 地址编号 */
  addressCode = "";

  /** id */
  id = undefined;

  /** 最小供应商moq */
  minMoq = undefined;

  /** 物流周期 */
  productionCycle = undefined;

  /** 供应商Code */
  supplierCode = "";

  /** 供应商ID=Code+交易主体缩写+供应商名称 */
  supplierIdName = "";

  /** 供应商供应商名称 */
  supplierName = "";

  /** 交易主体code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";
}

class PlmSkuVendorResponseRpcDto {
  /** id */
  id = undefined;

  /** 最小供应商moq */
  minMoq = undefined;

  /** 物流周期 */
  productionCycle = undefined;

  /** 供应商ID=Code+交易主体缩写+供应商名称 */
  supplierIdName = "";
}

class PlmSkuVendorRpcRequestDto {
  /** 地址 */
  address = "";

  /** 地址编号 */
  addressCode = "";

  /** 最小供应商moq */
  minMoq = undefined;

  /** 物流周期 */
  productionCycle = undefined;

  /** skuNo */
  skuNo = "";

  /** 供应商Code */
  supplierCode = "";

  /** 供应商ID=Code+交易主体缩写+供应商名称 */
  supplierIdName = "";

  /** 供应商供应商名称 */
  supplierName = "";

  /** 交易主体code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";
}

class PlmSkuWarehousePackageRequestDto {
  /** 箱规高（cm） */
  boxHeightCm = undefined;

  /** 箱规长（cm） */
  boxLongCm = undefined;

  /** 每箱数量（mpq） */
  boxMpq = undefined;

  /** 箱规宽（cm） */
  boxWidthCm = undefined;

  /** 是否选中 1：是，0：否 */
  checked = false;

  /** 单箱计费重（kg） */
  singleBillingWeight = undefined;

  /** 装箱体积（m3） */
  singleBoxVolume = undefined;

  /** 单箱体积重（kg） */
  singleBoxVolumeWeight = undefined;

  /** 单箱毛重（kg） */
  singleGrossWeight = undefined;
}

class PlmSkuWarehousePackageResponseDto {
  /** 箱规高（cm） */
  boxHeightCm = undefined;

  /** 箱规长（cm） */
  boxLongCm = undefined;

  /** 每箱数量（mpq） */
  boxMpq = undefined;

  /** 箱规宽（cm） */
  boxWidthCm = undefined;

  /** 是否选中 1：是，0：否 */
  checked = false;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 单箱计费重（kg） */
  singleBillingWeight = undefined;

  /** 装箱体积（m3） */
  singleBoxVolume = undefined;

  /** 单箱体积重（kg） */
  singleBoxVolumeWeight = undefined;

  /** 单箱毛重（kg） */
  singleGrossWeight = undefined;

  /** sku编码 */
  skuNo = "";

  /** 箱规类型：INFO_FIRST，INFO_SECOND */
  type = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class PlmSkuWarehousePackageRootRequestDto {
  /** 是否进行过编辑 */
  isEdit = false;

  /** 包装装箱信息1 */
  packageInfo1 = new PlmSkuWarehousePackageRequestDto();

  /** 包装装箱信息2 */
  packageInfo2 = new PlmSkuWarehousePackageRequestDto();

  /** sku编码 */
  skuNo = "";
}

class PlmSkuWarehousePackageRootResponseDto {
  /** 包装装箱信息1 */
  packageInfo1 = new PlmSkuWarehousePackageResponseDto();

  /** 包装装箱信息2 */
  packageInfo2 = new PlmSkuWarehousePackageResponseDto();

  /** sku编码 */
  skuNo = "";
}

class PlmSkuWarehousePackageRpcRequestDto {
  /** 箱规高（cm） */
  boxHeightCm = undefined;

  /** 箱规长（cm） */
  boxLongCm = undefined;

  /** 每箱数量（mpq） */
  boxMpq = undefined;

  /** 箱规宽（cm） */
  boxWidthCm = undefined;

  /** 产品标识，默认为是 */
  productFlag = false;

  /** 单箱计费重（kg） */
  singleBillingWeight = undefined;

  /** 装箱体积（m3） */
  singleBoxVolume = undefined;

  /** 单箱体积重（kg） */
  singleBoxVolumeWeight = undefined;

  /** 单箱毛重（kg） */
  singleGrossWeight = undefined;

  /** sku编码 */
  skuNo = "";
}

class PlmSkuWarehousePackageRpcResponseDto {
  /** 箱规高（cm） */
  boxHeightCm = undefined;

  /** 箱规长（cm） */
  boxLongCm = undefined;

  /** 每箱数量（mpq） */
  boxMpq = undefined;

  /** 箱规宽（cm） */
  boxWidthCm = undefined;

  /** 单箱计费重（kg） */
  singleBillingWeight = undefined;

  /** 装箱体积（m3） */
  singleBoxVolume = undefined;

  /** 单箱体积重（kg） */
  singleBoxVolumeWeight = undefined;

  /** 单箱毛重（kg） */
  singleGrossWeight = undefined;

  /** sku编码 */
  skuNo = "";

  /** 箱规类型：INFO_FIRST，INFO_SECOND */
  type = "";
}

class PlmSpuBriefInfoResponseDto {
  /** 品牌编号 */
  brandNo = "";

  /** 产品线，乐器，户外，文创，其他 */
  buCode = "";

  /** 一级品类 */
  primaryProductLine = "";

  /** 一级品类名称 */
  primaryProductLineName = "";

  /** 二级品类 */
  secondaryProductLine = "";

  /** 二级品类名称 */
  secondaryProductLineName = "";

  /** spu名称（CN） */
  spuNameCn = "";

  /** spu名称（EN） */
  spuNameEn = "";

  /** spu编码 */
  spuNo = "";

  /** 三级品类 */
  tertiaryProductLine = "";

  /** 三级品类名称 */
  tertiaryProductLineName = "";
}

class PlmSpuBriefInfoResponseRpcDto {
  /** 品牌编号 */
  brandNo = "";

  /** 产品线，乐器，户外，文创，其他 */
  buCode = "";

  /** 一级品类 */
  primaryProductLine = "";

  /** 一级品类名称 */
  primaryProductLineName = "";

  /** 二级品类 */
  secondaryProductLine = "";

  /** 二级品类名称 */
  secondaryProductLineName = "";

  /** spu名称（CN） */
  spuNameCn = "";

  /** spu名称（EN） */
  spuNameEn = "";

  /** spu编码 */
  spuNo = "";

  /** 三级品类 */
  tertiaryProductLine = "";

  /** 三级品类名称 */
  tertiaryProductLineName = "";
}

class PlmSpuCreateRequestDto {
  /** 品牌 */
  brand = "";

  /** bu */
  bu = "";

  /** sku英文名称 */
  englishName = "";

  /** sku中文名称 */
  name = "";

  /** number */
  number = "";

  /** 一级品类 */
  primaryProductLine = "";

  /** 二级品类 */
  secondaryProductLine = "";

  /** 三级品类 */
  tertiaryProductLine = "";
}

class PlmSpuDetailResponseDto {
  /** 品牌编号 */
  brandNo = "";

  /** 产品线，乐器，户外，文创，其他 */
  buCode = "";

  /** id */
  id = undefined;

  /** sku列表 */
  plmSkuBriefInfoDtoList = [];

  /** 一级品类 */
  primaryProductLine = "";

  /** 一级品类名称 */
  primaryProductLineName = "";

  /** 二级品类 */
  secondaryProductLine = "";

  /** 二级品类名称 */
  secondaryProductLineName = "";

  /** spu名称（CN） */
  spuNameCn = "";

  /** spu名称（EN） */
  spuNameEn = "";

  /** spu编码 */
  spuNo = "";

  /** 三级品类 */
  tertiaryProductLine = "";

  /** 三级品类名称 */
  tertiaryProductLineName = "";
}

class PlmSpuListResponseDto {
  /** 品牌编号 */
  brandNo = "";

  /** 产品线，乐器，户外，文创，其他 */
  buCode = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 一级品类 */
  primaryProductLine = "";

  /** 一级品类名称 */
  primaryProductLineName = "";

  /** 二级品类 */
  secondaryProductLine = "";

  /** 二级品类名称 */
  secondaryProductLineName = "";

  /** spu名称（CN） */
  spuNameCn = "";

  /** spu名称（EN） */
  spuNameEn = "";

  /** spu编码 */
  spuNo = "";

  /** 三级品类 */
  tertiaryProductLine = "";

  /** 三级品类名称 */
  tertiaryProductLineName = "";

  /** 修改时间 */
  updateTime = "";
}

class PlmSpuListResponseRpcDto {
  /** 品牌编号 */
  brandNo = "";

  /** 产品线，乐器，户外，文创，其他 */
  buCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** id */
  id = undefined;

  /** 一级品类编码 */
  primaryProductLine = "";

  /** 一级品类名称 */
  primaryProductLineName = "";

  /** 二级品类编码 */
  secondaryProductLine = "";

  /** 二级品类名称 */
  secondaryProductLineName = "";

  /** spu名称（CN） */
  spuNameCn = "";

  /** spu名称（EN） */
  spuNameEn = "";

  /** spu编码 */
  spuNo = "";

  /** 三级品类编码 */
  tertiaryProductLine = "";

  /** 三级品类名称 */
  tertiaryProductLineName = "";

  /** 修改时间 */
  updateTime = "";
}

class PlmSpuRequestParamsDto {
  /** 品牌编号 */
  brandNo = "";

  /** 产品线，乐器，户外，文创，其他 */
  buCode = "";

  /** 当前页 */
  current = undefined;

  /** 查询创建结束时间 */
  endTime = "";

  /** id */
  id = undefined;

  /** 排序 */
  orderBy = "";

  /** 一级品类 */
  primaryProductLine = "";

  /** 一级品类列表 */
  primaryProductLineList = [];

  /** 二级品类 */
  secondaryProductLine = "";

  /** 二级级品类列表 */
  secondaryProductLineList = [];

  /** 每页条数 */
  size = undefined;

  /** sku编码 */
  skuNo = "";

  /** spu名称（CN） */
  spuNameCn = "";

  /** spu编码 */
  spuNo = "";

  /** 查询创建开始时间 */
  startTime = "";

  /** 三级品类 */
  tertiaryProductLine = "";

  /** 三级品类列表 */
  tertiaryProductLineList = [];

  /** 查询更新结束时间 */
  updateEndTime = "";

  /** 查询更新开始时间 */
  updateStartTime = "";
}

class ProductBomApprovalRequestDto {
  /** 审批结果 1:通过 0:驳回 */
  approvalStatus = undefined;

  /** bomno */
  bomno = "";

  /** 附件 */
  files = [];

  /** 驳回备注 */
  rejectRemark = "";

  /** 工作流TaskID */
  taskId = "";
}

class ProductBomInvalidRequestDto {
  /** bomno */
  bomno = "";
}

class ProductBomRequestDto {
  /** 产品BOM */
  bomno = "";

  /** BU编码 */
  buCode = undefined;

  /** 开发模式 */
  developmentMode = "";

  /** 附件 */
  files = [];

  /** id */
  id = undefined;

  /** 新品类型(brand_new:全新品;spu_expand_new:spu拓展新品 */
  newProductType = "";

  /** 包装样品提交时间 */
  packageSampleTime = "";

  /** 计划员 */
  planner = "";

  /** 核价样品提交时间 */
  priceSampleTime = "";

  /** spu产品id */
  productKey = "";

  /** SPU产品名称（CN） */
  productNameCn = "";

  /** spu */
  productNo = "";

  /** 产品负责人 */
  productOwner = "";

  /** 质检样品提交时间 */
  qualitySampleTime = "";

  /** 备注 */
  remark = "";

  /** 是否研发产品 */
  researchFlag = false;

  /** 研发测试样品提交时间 */
  researchSampleTime = "";

  /** SBU编码 */
  sbuCode = undefined;

  /** sku产品id */
  skuKey = "";

  /** sku编号 */
  skuNo = "";

  /** SKU标题（CN） */
  skuTitleCn = "";

  /** 供应商邮箱 */
  supplierEmail = "";

  /** 默认供应商名称 */
  vendorName = "";

  /** 默认供应商编号 */
  vendorNo = "";
}

class ProductBomResponseDto {
  /** 审批状态 -1:未提交审批 0:已驳回 1:已通过 2:审批中 */
  approvalStatus = undefined;

  /** 审批时间 */
  approveTime = "";

  /** 审批人 */
  approver = "";

  /** 产品BOM */
  bomno = "";

  /** BU编码 */
  buCode = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当前审核状态 */
  currentApprovalStatus = "";

  /** 当前审批步骤 */
  currentApprovalSteps = "";

  /** 当前负责人 */
  currentProcessor = "";

  /** 当前处理人编号 */
  currentProcessorCode = "";

  /** 当前处理人类型：指定人、指定角色 */
  currentProcessorType = "";

  /** 删除标识 */
  deleted = undefined;

  /** 开发模式 */
  developmentMode = "";

  /** 附件 */
  files = [];

  /** id */
  id = undefined;

  /** 发起时间 */
  initiateTime = "";

  /** 发起人 */
  initiator = "";

  /** 工作流实例ID */
  instanceId = "";

  /** 版本 */
  lockVersion = undefined;

  /** 新品类型(brand_new:全新品;spu_expand_new:spu拓展新品 */
  newProductType = "";

  /** 包装样品提交时间 */
  packageSampleTime = "";

  /** 计划员 */
  planner = "";

  /** 核价样品提交时间 */
  priceSampleTime = "";

  /** spu产品id */
  productKey = "";

  /** SPU产品名称（CN） */
  productNameCn = "";

  /** spu */
  productNo = "";

  /** 产品负责人 */
  productOwner = "";

  /** 质检样品提交时间 */
  qualitySampleTime = "";

  /** 驳回备注 */
  rejectRemark = "";

  /** 驳回时间 */
  rejectTime = "";

  /** 驳回人 */
  rejector = "";

  /** 备注 */
  remark = "";

  /** 是否研发产品 */
  researchFlag = false;

  /** 研发测试样品提交时间 */
  researchSampleTime = "";

  /** SBU编码 */
  sbuCode = undefined;

  /** sku产品id */
  skuKey = "";

  /** sku编号 */
  skuNo = "";

  /** SKU标题（CN） */
  skuTitleCn = "";

  /** 供应商邮箱 */
  supplierEmail = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 默认供应商名称 */
  vendorName = "";

  /** 默认供应商编号 */
  vendorNo = "";
}

class ProductBrandModel {
  /** 品牌简称 */
  brandAbbreviation = "";

  /** 品牌名称（CN） */
  brandNameCn = "";

  /** 品牌名称（EN） */
  brandNameEn = "";

  /** 品牌编号 */
  brandNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 描述 */
  description = "";

  /** 品牌邮箱 */
  email = "";

  /** id */
  id = undefined;

  /** 品牌中文名称首字母 */
  initialsCn = "";

  /** 品牌英文名称首字母 */
  initialsEn = "";

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProductBrandRequestDto {
  /** 品牌简称 */
  brandAbbreviation = "";

  /** 品牌名称（CN） */
  brandNameCn = "";

  /** 品牌名称（EN） */
  brandNameEn = "";

  /** 品牌编号 */
  brandNo = "";

  /** 描述 */
  description = "";

  /** 品牌邮箱 */
  email = "";

  /** id */
  id = undefined;

  /** 品牌中文名称首字母 */
  initialsCn = "";

  /** 品牌英文名称首字母 */
  initialsEn = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;
}

class ProductBrandRequestParamsDto {
  /** 品牌简称 */
  brandAbbreviation = "";

  /** 品牌名称（CN） */
  brandNameCn = "";

  /** 品牌名称（EN） */
  brandNameEn = "";

  /** 品牌编号 */
  brandNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 描述 */
  description = "";

  /** 品牌邮箱 */
  email = "";

  /** id */
  id = undefined;

  /** 品牌中文名称首字母 */
  initialsCn = "";

  /** 品牌英文名称首字母 */
  initialsEn = "";

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProductBrandResponseDto {
  /** 品牌简称 */
  brandAbbreviation = "";

  /** 品牌名称（CN） */
  brandNameCn = "";

  /** 品牌名称（EN） */
  brandNameEn = "";

  /** 品牌编号 */
  brandNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 描述 */
  description = "";

  /** id */
  id = undefined;

  /** 品牌中文名称首字母 */
  initialsCn = "";

  /** 品牌英文名称首字母 */
  initialsEn = "";

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProductCategroyModel {
  /** 品类简称 */
  categoryAbbreviation = "";

  /** 品类名称（CN） */
  categoryNameCn = "";

  /** 品类名称（EN） */
  categoryNameEn = "";

  /** 品类编码 */
  categoryNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 等级 */
  levelNum = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 上级品类编码 */
  parentCategoryNo = "";

  /** 排序 */
  sortNum = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProductCategroyRequestDto {
  /** 品类简称 */
  categoryAbbreviation = "";

  /** 品类名称（CN） */
  categoryNameCn = "";

  /** 品类名称（EN） */
  categoryNameEn = "";

  /** 品类编码 */
  categoryNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 等级 */
  levelNum = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 上级品类编码 */
  parentCategoryNo = "";

  /** 排序 */
  sortNum = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProductCategroyRequestParamsDto {
  /** 品类简称 */
  categoryAbbreviation = "";

  /** 品类名称（CN） */
  categoryNameCn = "";

  /** 品类名称（EN） */
  categoryNameEn = "";

  /** 品类编码 */
  categoryNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 等级 */
  levelNum = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 上级品类编码 */
  parentCategoryNo = "";

  /** 排序 */
  sortNum = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProductCategroyResponseDto {
  /** 品类简称 */
  categoryAbbreviation = "";

  /** 品类名称（CN） */
  categoryNameCn = "";

  /** 品类名称（EN） */
  categoryNameEn = "";

  /** 品类编码 */
  categoryNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 等级 */
  levelNum = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 上级品类编码 */
  parentCategoryNo = "";

  /** 排序 */
  sortNum = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProductCategroyResponseDtoRpc {
  /** 品类简称 */
  categoryAbbreviation = "";

  /** 品类名称（CN） */
  categoryNameCn = "";

  /** 品类名称（CN）全名称 */
  categoryNameCnFull = "";

  /** 品类名称（EN） */
  categoryNameEn = "";

  /** 品类编码 */
  categoryNo = "";

  /** 品类编码全名称 */
  categoryNoFull = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 等级 */
  levelNum = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 上级品类编码 */
  parentCategoryNo = "";

  /** 排序 */
  sortNum = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProductCategroyTreeResponseDto {
  /** 品类简称 */
  categoryAbbreviation = "";

  /** 品类名称（CN） */
  categoryNameCn = "";

  /** 品类名称（EN） */
  categoryNameEn = "";

  /** 品类编码 */
  categoryNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 等级 */
  levelNum = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 分类子集 */
  nextLevelList = [];

  /** 上级品类编码 */
  parentCategoryNo = "";

  /** 排序 */
  sortNum = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProductConfirmAcceptRequestDto {
  /** 收样时间 */
  acceptTime = "";

  /** 样品确认no */
  pscno = "";
}

class ProductConfirmApprovalRequestDto {
  /** 审批结果 1:通过 0:驳回 */
  approvalStatus = undefined;

  /** 质检确认产品包装高（CM） */
  confirmPackHeightCm = undefined;

  /** 质检确认产品包装长（CM） */
  confirmPackLongCm = undefined;

  /** 质检确认产品包装重量（G） */
  confirmPackWeight = undefined;

  /** 质检确认产品包装宽（CM） */
  confirmPackWidthCm = undefined;

  /** 附件 */
  files = [];

  /** pscno */
  pscno = "";

  /** 驳回备注 */
  rejectRemark = "";

  /** 工作流TaskID */
  taskId = "";
}

class ProductConfirmCommitRequestDto {
  /** pscno */
  pscno = "";
}

class ProductConfirmFileRequestDto {
  /** 样品确认no */
  businessNo = "";

  /** 附件 */
  files = [];
}

class ProductConfirmFileResponseDto {
  /** 附件 */
  files = [];

  /** 样品确认no */
  pscno = "";
}

class ProductConfirmInvalidRequestDto {
  /** 样品确认no */
  pscno = "";
}

class ProductConfirmRequestDto {
  /** 项目助理提交时间 */
  assistantCommitTime = "";

  /** BU编码 */
  buCode = undefined;

  /** 质检确认产品包装高（CM） */
  confirmPackHeightCm = undefined;

  /** 质检确认产品包装长（CM） */
  confirmPackLongCm = undefined;

  /** 质检确认产品包装重量（G） */
  confirmPackWeight = undefined;

  /** 质检确认产品包装宽（CM） */
  confirmPackWidthCm = undefined;

  /** 附件 */
  files = [];

  /** id */
  id = undefined;

  /** 新品类型(brand_new:全新品;spu_expand_new:spu拓展新品 */
  newProductType = "";

  /** 包装样品提交时间 */
  packageSampleTime = "";

  /** 核价样品提交时间 */
  priceSampleTime = "";

  /** spu产品id */
  productKey = "";

  /** 产品名称（CN） */
  productNameCn = "";

  /** spu */
  productNo = "";

  /** 产品负责人 */
  productOwner = "";

  /** 样品确认no */
  pscno = "";

  /** 质检样品提交时间 */
  qualitySampleTime = "";

  /** 备注 */
  remark = "";

  /** 是否研发产品 */
  researchFlag = false;

  /** 研发测试样品提交时间 */
  researchSampleTime = "";

  /** SBU编码 */
  sbuCode = undefined;

  /** sku产品id */
  skuKey = "";

  /** sku编号 */
  skuNo = "";

  /** SKU标题（CN） */
  skuTitleCn = "";
}

class ProductConfirmResponseDto {
  /** 审批状态 -1:未提交审批 0:已驳回 1:已通过 2:审批中 */
  approvalStatus = undefined;

  /** 审批时间 */
  approveTime = "";

  /** 审批人 */
  approver = "";

  /** 项目助理提交时间 */
  assistantCommitTime = "";

  /** BU编码 */
  buCode = undefined;

  /** 质检确认产品包装高（CM） */
  confirmPackHeightCm = undefined;

  /** 质检确认产品包装长（CM） */
  confirmPackLongCm = undefined;

  /** 质检确认产品包装重量（G） */
  confirmPackWeight = undefined;

  /** 质检确认产品包装宽（CM） */
  confirmPackWidthCm = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当前审核状态 */
  currentApprovalStatus = "";

  /** 当前审批步骤 */
  currentApprovalSteps = "";

  /** 当前负责人 */
  currentProcessor = "";

  /** 当前处理人编号 */
  currentProcessorCode = "";

  /** 当前处理人类型：指定人、指定角色 */
  currentProcessorType = "";

  /** 删除标识 */
  deleted = undefined;

  /** 开发模式 */
  developmentMode = "";

  /** 附件 */
  files = [];

  /** id */
  id = undefined;

  /** 发起时间 */
  initiateTime = "";

  /** 发起人 */
  initiator = "";

  /** 工作流实例ID */
  instanceId = "";

  /** 版本 */
  lockVersion = undefined;

  /** 新品类型(brand_new:全新品;spu_expand_new:spu拓展新品 */
  newProductType = "";

  /** 包装样品提交时间 */
  packageSampleTime = "";

  /** 核价样品提交时间 */
  priceSampleTime = "";

  /** spu产品id */
  productKey = "";

  /** 产品名称（CN） */
  productNameCn = "";

  /** spu */
  productNo = "";

  /** 产品负责人 */
  productOwner = "";

  /** 样品确认no */
  pscno = "";

  /** 质检样品提交时间 */
  qualitySampleTime = "";

  /** 驳回备注 */
  rejectRemark = "";

  /** 驳回时间 */
  rejectTime = "";

  /** 驳回人 */
  rejector = "";

  /** 备注 */
  remark = "";

  /** 是否研发产品 */
  researchFlag = false;

  /** 研发测试样品提交时间 */
  researchSampleTime = "";

  /** SBU编码 */
  sbuCode = undefined;

  /** sku产品id */
  skuKey = "";

  /** sku编号 */
  skuNo = "";

  /** SKU标题（CN） */
  skuTitleCn = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProductDeclareInfoResponseDto {
  /** 申报要素 */
  declareMemo = "";

  /** 申报中文品名 */
  declareNameCn = "";

  /** 申报英文品名 */
  declareNameEn = "";

  /** 海关编码 */
  hscodeCn = "";

  /** SPU编号 */
  productNo = "";

  /** SKU */
  skuNo = "";

  /** 增值税率 */
  vatRate = undefined;
}

class ProductDeclareInforequestDto {
  /** 申报要素 */
  declareMemo = "";

  /** 申报名称（CN） */
  declareNameCn = "";

  /** 申报名称（EN） */
  declareNameEn = "";

  /** HSCODE(国内) */
  hscodeCn = "";

  /** SKU编号 */
  skuNo = "";
}

class ProductMasterApprovalRequestDto {
  /** 驳回备注 */
  applyMemo = "";

  /** 审批结果 1:通过 0:驳回 */
  approvalStatus = undefined;

  /** 审批号 */
  puno = "";

  /** 工作流TaskID */
  taskId = "";
}

class ProductMasterModel {
  /** 附件连接 */
  annexUrl = "";

  /** 提交人ID */
  applyUser = undefined;

  /** 提交人备注 */
  applyUserMemo = "";

  /** 提交人名称 */
  applyUserName = "";

  /** 审批状态 -1:未提交审批 0:已驳回 1:已通过 2:审批中 */
  approvalStatus = undefined;

  /** 品牌名称 */
  brandName = "";

  /** 品牌编号 */
  brandNo = "";

  /** BU编码 */
  buCode = undefined;

  /** 品类名称 */
  categoryName = "";

  /** 品类编号 */
  categoryNo = "";

  /** 制造国家名称 */
  countryName = "";

  /** 制造国家二字码 */
  countrySecondWord = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当前审核状态 */
  currentApprovalStatus = "";

  /** 当前审批步骤 */
  currentApprovalStep = "";

  /** 删除标识 */
  deleted = undefined;

  /** 初审会日期 */
  demandTime = "";

  /** 开发模式 */
  developmentMode = "";

  /** 质保期（月） */
  expirydate = undefined;

  /** 首次采购金额 */
  firstPurchasePrice = undefined;

  /** id */
  id = undefined;

  /** 工作流实例ID */
  instanceId = undefined;

  /** 产品等级 */
  levelNum = "";

  /** 版本 */
  lockVersion = undefined;

  /** 物流分组名称 */
  logisticsGroupName = "";

  /** 物流分组编号 */
  logisticsGroupNo = "";

  /** 产品材质名称 */
  materialName = "";

  /** 产品材质编号 */
  materialNo = "";

  /** MQ推送状态: -1 未推送 0 推送失败 1推送成功 */
  mqSendStatus = undefined;

  /** 是否是新数据(需求管理上线前的历史数据为false) */
  newDataFlag = false;

  /** 新品类型 */
  newProductType = "";

  /** NS消费状态：-1 未消费 0消费失败 1消费成功 */
  nsConsumeStatus = undefined;

  /** 事业部名称 */
  organizationNane = "";

  /** 事业部编号 */
  organizationNo = "";

  /** 产品简称 */
  productAbbreviation = "";

  /** spu产品id */
  productKey = "";

  /** 产品名称（CN） */
  productNameCn = "";

  /** 产品名称（EN） */
  productNameEn = "";

  /** 产品编号 */
  productNo = "";

  /** 产品用途 */
  productUse = "";

  /** 审批号 */
  puno = "";

  /** 驳回备注 */
  rejectRemark = "";

  /** 驳回人ID */
  rejecter = undefined;

  /** 驳回人名称 */
  rejecterName = "";

  /** 是否研发产品 */
  researchFlag = false;

  /** 研发立项日期 */
  researchTime = "";

  /** 新品评审会日期 */
  reviewTime = "";

  /** SBU编码 */
  sbuCode = undefined;

  /** 状态：启用 or 停用 */
  status = undefined;

  /** 退税率 */
  taxRebateRate = undefined;

  /** 产品类型名称 */
  typeName = "";

  /** 产品类型编号 */
  typeNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 增值税率 */
  vatRate = undefined;
}

class ProductMasterRequestDto {
  /** 附件连接 */
  annexUrl = "";

  /** BU编码 */
  buCode = undefined;

  /** 品类名称 */
  categoryName = "";

  /** 品类编号 */
  categoryNo = "";

  /** 制造国家名称 */
  countryName = "";

  /** 制造国家二字码 */
  countrySecondWord = "";

  /** id */
  id = undefined;

  /** 物流分组名称 */
  logisticsGroupName = "";

  /** 物流分组编号 */
  logisticsGroupNo = "";

  /** 新增SKU集合 */
  newSkuModelList = [];

  /** 事业部名称 */
  organizationNane = "";

  /** 事业部编号 */
  organizationNo = "";

  /** spu产品id */
  productKey = "";

  /** 产品名称（CN） */
  productNameCn = "";

  /** 产品名称（EN） */
  productNameEn = "";

  /** SPU */
  productNo = "";

  /** 产品负责人 */
  productOwner = "";

  /** 产品负责人名称 */
  productOwnerName = "";

  /** 审批号 */
  puno = "";

  /** 是否研发产品 */
  researchFlag = false;

  /** SBU编码 */
  sbuCode = undefined;

  /** 状态：启用 or 停用 */
  status = undefined;

  /** 产品类型名称 */
  typeName = "";

  /** 产品类型编号 */
  typeNo = "";
}

class ProductMasterRequestDtoRPC {
  /** 附件连接 */
  annexUrl = "";

  /** 审批状态 -1:未提交审批 0:已驳回 1:已通过 2:审批中 */
  approvalStatus = undefined;

  /** 品牌名称 */
  brandName = "";

  /** 品牌编号 */
  brandNo = "";

  /** BU编码 */
  buCode = undefined;

  /** 品类名称 */
  categoryName = "";

  /** 品类编号 */
  categoryNo = "";

  /** 制造国家名称 */
  countryName = "";

  /** 制造国家二字码 */
  countrySecondWord = "";

  /** 初审会日期 */
  demandTime = "";

  /** 开发模式 */
  developmentMode = "";

  /** 质保期（月） */
  expirydate = undefined;

  /** 首次采购金额 */
  firstPurchasePrice = undefined;

  /** 产品等级 */
  levelNum = "";

  /** 物流分组名称 */
  logisticsGroupName = "";

  /** 物流分组编号 */
  logisticsGroupNo = "";

  /** 产品材质名称 */
  materialName = "";

  /** 产品材质编号 */
  materialNo = "";

  /** 是否是新数据(需求管理上线前的历史数据为false) */
  newDataFlag = false;

  /** 新品类型 */
  newProductType = "";

  /** 事业部名称 */
  organizationNane = "";

  /** 事业部编号 */
  organizationNo = "";

  /** 产品简称 */
  productAbbreviation = "";

  /** spu产品id */
  productKey = "";

  /** 产品名称（CN） */
  productNameCn = "";

  /** 产品名称（EN） */
  productNameEn = "";

  /** 产品编号 */
  productNo = "";

  /** 产品用途 */
  productUse = "";

  /** 审批号 */
  puno = "";

  /** 是否研发产品 */
  researchFlag = false;

  /** 研发立项日期 */
  researchTime = "";

  /** 新品评审会日期 */
  reviewTime = "";

  /** SBU编码 */
  sbuCode = undefined;

  /** 状态：启用 or 停用 */
  status = undefined;

  /** 退税率 */
  taxRebateRate = undefined;

  /** 产品类型名称 */
  typeName = "";

  /** 产品类型编号 */
  typeNo = "";

  /** 增值税率 */
  vatRate = undefined;
}

class ProductMasterRequestParamsDto {
  /** 附件连接 */
  annexUrl = "";

  /** 提交人ID */
  applyUser = undefined;

  /** 提交人备注 */
  applyUserMemo = "";

  /** 提交人名称 */
  applyUserName = "";

  /** 审批状态 -1:未提交审批 0:已驳回 1:已通过 2:审批中 */
  approvalStatus = "";

  /** 品牌名称 */
  brandName = "";

  /** 品牌编号 */
  brandNo = "";

  /** BU编码 */
  buCode = undefined;

  /** 品类名称 */
  categoryName = "";

  /** 品类编号 */
  categoryNo = "";

  /** 制造国家名称 */
  countryName = "";

  /** 制造国家二字码 */
  countrySecondWord = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当前审批步骤 */
  currentApprovalStep = "";

  /** 删除标识 */
  deleted = undefined;

  /** 初审会日期 */
  demandTime = "";

  /** 质保期（月） */
  expirydate = undefined;

  /** 首次采购金额 */
  firstPurchasePrice = undefined;

  /** id */
  id = undefined;

  /** 工作流实例ID */
  instanceId = undefined;

  /** 产品等级 */
  levelNum = "";

  /** 版本 */
  lockVersion = undefined;

  /** 物流分组名称 */
  logisticsGroupName = "";

  /** 物流分组编号 */
  logisticsGroupNo = "";

  /** 产品材质名称 */
  materialName = "";

  /** 产品材质编号 */
  materialNo = "";

  /** MQ推送状态: -1 未推送 0 推送失败 1推送成功 */
  mqSendStatus = undefined;

  /** NS消费状态：-1 未消费 0消费失败 1消费成功 */
  nsConsumeStatus = undefined;

  /** 事业部名称 */
  organizationNane = "";

  /** 事业部编号 */
  organizationNo = "";

  /** 计划员 */
  planner = "";

  /** 计划员名称 */
  plannerName = "";

  /** 产品简称 */
  productAbbreviation = "";

  /** spu产品id */
  productKey = "";

  /** 产品名称（CN） */
  productNameCn = "";

  /** 产品名称（EN） */
  productNameEn = "";

  /** 产品编号 */
  productNo = "";

  /** 产品负责人 */
  productOwner = "";

  /** 产品负责人名称 */
  productOwnerName = "";

  /** 产品用途 */
  productUse = "";

  /** 审批号 */
  puno = "";

  /** 采购负责人 */
  purchaser = "";

  /** 采购负责人名称 */
  purchaserName = "";

  /** 驳回人ID */
  rejecter = undefined;

  /** 驳回人名称 */
  rejecterName = "";

  /** 是否研发产品 */
  researchFlag = false;

  /** 研发立项日期 */
  researchTime = "";

  /** 新品评审会日期 */
  reviewTime = "";

  /** SBU编码 */
  sbuCode = undefined;

  /** 副产品负责人 */
  secondOwner = "";

  /** 副产品负责人名称 */
  secondOwnerName = "";

  /** sku产品id */
  skuKey = "";

  /** SKU编号 */
  skuNo = "";

  /** 是否特批 */
  specialPermitFlag = false;

  /** 状态：启用 or 停用 */
  status = undefined;

  /** 退税率 */
  taxRebateRate = undefined;

  /** 产品类型名称 */
  typeName = "";

  /** 产品类型编号 */
  typeNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 增值税率 */
  vatRate = undefined;
}

class ProductMasterResponseDto {
  /** 附件连接 */
  annexUrl = "";

  /** 提交人ID */
  applyUser = undefined;

  /** 提交人备注 */
  applyUserMemo = "";

  /** 提交人名称 */
  applyUserName = "";

  /** 审批状态 -1:未提交审批 0:已驳回 1:已通过 2:审批中 */
  approvalStatus = undefined;

  /** 品牌 */
  brandModel = new ProductBrandModel();

  /** 品牌名称 */
  brandName = "";

  /** 品牌编号 */
  brandNo = "";

  /** BU编码 */
  buCode = undefined;

  /** BU名称 */
  buName = "";

  /** 品类名称 */
  categoryName = "";

  /** 品类名称（CN）全名称 */
  categoryNameCnFull = "";

  /** 品类编号 */
  categoryNo = "";

  /** 品类编码全名称 */
  categoryNoFull = "";

  /** 分类 */
  categroyModel = new ProductCategroyModel();

  /** 制造国家名称 */
  countryName = "";

  /** 制造国家二字码 */
  countrySecondWord = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当前审批步骤 */
  currentApprovalStep = "";

  /** 删除标识 */
  deleted = undefined;

  /** 需求计划员 */
  demandPlanner = "";

  /** 需求计划员名称 */
  demandPlannerName = "";

  /** 初审会日期 */
  demandTime = "";

  /** 开发模式 */
  developmentMode = "";

  /** 质保期（月） */
  expirydate = undefined;

  /** 首次采购金额 */
  firstPurchasePrice = undefined;

  /** 物流属性分组 */
  groupModel = new LogisticsGroupModel();

  /** id */
  id = undefined;

  /** 工作流实例ID */
  instanceId = undefined;

  /** 产品等级 */
  levelNum = "";

  /** 版本 */
  lockVersion = undefined;

  /** 物流分组名称 */
  logisticsGroupName = "";

  /** 物流分组编号 */
  logisticsGroupNo = "";

  /** 材质 */
  materialModel = new ProductMaterialModel();

  /** 产品材质名称 */
  materialName = "";

  /** 产品材质编号 */
  materialNo = "";

  /** MQ推送状态: -1 未推送 0 推送失败 1推送成功 */
  mqSendStatus = undefined;

  /** 是否是新数据(需求管理上线前的历史数据为false) */
  newDataFlag = false;

  /** NS消费状态：-1 未消费 0消费失败 1消费成功 */
  nsConsumeStatus = undefined;

  /** NS计划员名称 */
  nsPlannerName = "";

  /** NS产品负责人名称 */
  nsProductOwnerName = "";

  /** NS采购负责人名称 */
  nsPurchaserName = "";

  /** NS副产品负责人名称 */
  nsSecondOwnerName = "";

  /** 事业部名称 */
  organizationNane = "";

  /** 事业部编号 */
  organizationNo = "";

  /** 计划员 */
  planner = "";

  /** 计划员名称 */
  plannerName = "";

  /** 产品简称 */
  productAbbreviation = "";

  /** spu产品id */
  productKey = "";

  /** 产品名称（CN） */
  productNameCn = "";

  /** 产品名称（EN） */
  productNameEn = "";

  /** 产品编号 */
  productNo = "";

  /** 产品负责人 */
  productOwner = "";

  /** 产品负责人名称 */
  productOwnerName = "";

  /** 产品用途 */
  productUse = "";

  /** 审批号 */
  puno = "";

  /** 采购负责人 */
  purchaser = "";

  /** 采购负责人名称 */
  purchaserName = "";

  /** 驳回人ID */
  rejecter = undefined;

  /** 驳回人名称 */
  rejecterName = "";

  /** 是否研发产品 */
  researchFlag = false;

  /** 研发立项日期 */
  researchTime = "";

  /** 新品评审会日期 */
  reviewTime = "";

  /** SBU编码 */
  sbuCode = undefined;

  /** 副产品负责人 */
  secondOwner = "";

  /** 副产品负责人名称 */
  secondOwnerName = "";

  /** SKU集合 */
  skuModelList = [];

  /** 是否特批 */
  specialPermitFlag = false;

  /** 状态：启用 or 停用 */
  status = undefined;

  /** 退税率 */
  taxRebateRate = undefined;

  /** 类型 */
  typeModel = new ProductTypeModel();

  /** 产品类型名称 */
  typeName = "";

  /** 产品类型编号 */
  typeNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 增值税率 */
  vatRate = undefined;
}

class ProductMaterialModel {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 产品材质名称（CN） */
  materialNameCn = "";

  /** 产品材质名称（EN） */
  materialNameEn = "";

  /** 产品材质编号 */
  materialNo = "";

  /** 产品材质值 */
  materialValue = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProductMaterialRequestDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 产品材质名称（CN） */
  materialNameCn = "";

  /** 产品材质名称（EN） */
  materialNameEn = "";

  /** 产品材质编号 */
  materialNo = "";

  /** 产品材质值 */
  materialValue = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProductMaterialRequestParamsDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 产品材质名称（CN） */
  materialNameCn = "";

  /** 产品材质名称（EN） */
  materialNameEn = "";

  /** 产品材质编号 */
  materialNo = "";

  /** 产品材质值 */
  materialValue = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProductMaterialResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 产品材质名称（CN） */
  materialNameCn = "";

  /** 产品材质名称（EN） */
  materialNameEn = "";

  /** 产品材质编号 */
  materialNo = "";

  /** 产品材质值 */
  materialValue = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProductOrderApprovalRequestDto {
  /** 审批结果 1:通过 0:驳回 */
  approvalStatus = undefined;

  /** 新品下单no */
  npono = "";

  /** 采购申请 */
  purchaseRequisitionList = [];

  /** 驳回备注 */
  rejectRemark = "";
}

class ProductOrderDemandDetailRequestDto {
  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 新品下单no */
  npono = "";

  /** 平台标识key */
  platformKey = "";

  /** 平台名称 */
  platformName = "";

  /** 需求数量 */
  qty = undefined;

  /** 店铺信息 */
  shopInfoList = [];

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";
}

class ProductOrderDemandDetailResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 新品下单no */
  npono = "";

  /** 平台标识key */
  platformKey = "";

  /** 平台名称 */
  platformName = "";

  /** 需求数量 */
  qty = undefined;

  /** 店铺信息（编号、名称、msku） */
  shopInfo = "";

  /** 站点 */
  siteKey = "";

  /** 站点名称 */
  siteName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProductOrderRequestDto {
  /** 地址 */
  address = "";

  /** 地址编号 */
  addressCode = "";

  /** BU编码 */
  buCode = undefined;

  /** 样品确认通过时间 */
  confirmPassedTime = "";

  /** 样品确认提交时间 */
  confirmTime = "";

  /** 需求明细 */
  demandDetailList = [];

  /** 初审会日期 */
  demandTime = "";

  /** 预计下单时间 */
  expectOrderTime = "";

  /** 是否能工厂直发 */
  factoryDirectHairFlag = false;

  /** id */
  id = undefined;

  /** 是否能马上量产 */
  immediatelyProductionFlag = false;

  /** 是否包含独立站 */
  includeOwnFlag = false;

  /** 最小下单量 */
  moq = undefined;

  /** 新品类型(brand_new:全新品;spu_expand_new:spu拓展新品) */
  newProductType = "";

  /** 新品下单no */
  npono = "";

  /** 独立站数量 */
  ownSiteQty = undefined;

  /** 计划员 */
  planner = "";

  /** PO单据NO */
  pono = "";

  /** 产品等级code */
  productLevelCode = "";

  /** 产品名称（CN） */
  productNameCn = "";

  /** spu */
  productNo = "";

  /** 产品负责人 */
  productOwner = "";

  /** 货期(天) */
  productionCycle = undefined;

  /** 数量 */
  qty = undefined;

  /** 实际下PO单日期 */
  realityOrderTime = "";

  /** 备注 */
  remark = "";

  /** 是否研发产品 */
  researchFlag = false;

  /** 研发立项日期 */
  researchTime = "";

  /** 新品评审会日期 */
  reviewTime = "";

  /** SBU编码 */
  sbuCode = undefined;

  /** sku */
  skuNo = "";

  /** SKU标题（CN） */
  skuTitleCn = "";

  /** 供应商Code */
  supplierCode = "";

  /** 供应商ID=Code+交易主体缩写+供应商名称 */
  supplierIdName = "";

  /** 供应商供应商名称 */
  supplierName = "";

  /** 供应商报价 */
  supplierQuotation = undefined;

  /** 交易主体code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 产品类型编号 */
  typeNo = "";
}

class ProductOrderResponseDto {
  /** 地址 */
  address = "";

  /** 地址编号 */
  addressCode = "";

  /** 审批时间 */
  approveTime = "";

  /** 审批人 */
  approver = "";

  /** BU编码 */
  buCode = undefined;

  /** 样品确认通过时间 */
  confirmPassedTime = "";

  /** 样品确认提交时间 */
  confirmTime = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当前审核状态 */
  currentApprovalStatus = "";

  /** 当前审批步骤 */
  currentApprovalSteps = "";

  /** 当前负责人 */
  currentProcessor = "";

  /** 当前处理人编号 */
  currentProcessorCode = "";

  /** 当前处理人类型：指定人、指定角色 */
  currentProcessorType = "";

  /** 删除标识 */
  deleted = undefined;

  /** 需求明细 */
  demandDetailList = [];

  /** 初审会日期 */
  demandTime = "";

  /** 预计下单时间 */
  expectOrderTime = "";

  /** 是否能工厂直发 */
  factoryDirectHairFlag = false;

  /** id */
  id = undefined;

  /** 是否能马上量产 */
  immediatelyProductionFlag = false;

  /** 是否包含独立站 */
  includeOwnFlag = false;

  /** 发起时间 */
  initiateTime = "";

  /** 发起人 */
  initiator = "";

  /** 工作流实例ID */
  instanceId = "";

  /** 版本 */
  lockVersion = undefined;

  /** 最小下单量 */
  moq = undefined;

  /** mpq数量 */
  mpqQty = undefined;

  /** 新品类型(brand_new:全新品;spu_expand_new:spu拓展新品) */
  newProductType = "";

  /** 新品下单no */
  npono = "";

  /** 状态 */
  orderStatus = "";

  /** 独立站数量 */
  ownSiteQty = undefined;

  /** 计划员 */
  planner = "";

  /** PO单据NO */
  pono = "";

  /** 产品等级code */
  productLevelCode = "";

  /** 产品名称（CN） */
  productNameCn = "";

  /** spu */
  productNo = "";

  /** 产品负责人 */
  productOwner = "";

  /** 货期(天) */
  productionCycle = undefined;

  /** 数量 */
  qty = undefined;

  /** 实际下PO单日期 */
  realityOrderTime = "";

  /** 驳回备注 */
  rejectRemark = "";

  /** 驳回时间 */
  rejectTime = "";

  /** 驳回人 */
  rejector = "";

  /** 备注 */
  remark = "";

  /** 是否研发产品 */
  researchFlag = false;

  /** 研发立项日期 */
  researchTime = "";

  /** 新品评审会日期 */
  reviewTime = "";

  /** SBU编码 */
  sbuCode = undefined;

  /** sku */
  skuNo = "";

  /** SKU标题（CN） */
  skuTitleCn = "";

  /** 供应商Code */
  supplierCode = "";

  /** 供应商ID=Code+交易主体缩写+供应商名称 */
  supplierIdName = "";

  /** 供应商供应商名称 */
  supplierName = "";

  /** 供应商报价 */
  supplierQuotation = undefined;

  /** 交易主体code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 产品类型编号 */
  typeNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProductResponseDto {
  /** 附件连接 */
  annexUrl = "";

  /** 提交人ID */
  applyUser = undefined;

  /** 提交人备注 */
  applyUserMemo = "";

  /** 提交人名称 */
  applyUserName = "";

  /** 审批状态 -1:未提交审批 0:已驳回 1:已通过 2:审批中 */
  approvalStatus = undefined;

  /** 品牌 */
  brandModel = new ProductBrandResponseDto();

  /** 品牌名称 */
  brandName = "";

  /** 品牌编号 */
  brandNo = "";

  /** BU编码 */
  buCode = undefined;

  /** 品类名称 */
  categoryName = "";

  /** 品类名称（CN）全名称 */
  categoryNameCnFull = "";

  /** 品类编号 */
  categoryNo = "";

  /** 品类编码全名称 */
  categoryNoFull = "";

  /** 分类 */
  categroyModel = new ProductCategroyResponseDto();

  /** 制造国家名称 */
  countryName = "";

  /** 制造国家二字码 */
  countrySecondWord = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当前审批步骤 */
  currentApprovalStep = "";

  /** 申报要素 */
  declareMemo = "";

  /** 申报名称（CN） */
  declareNameCn = "";

  /** 申报名称（EN） */
  declareNameEn = "";

  /** 删除标识 */
  deleted = undefined;

  /** 初审会日期 */
  demandTime = "";

  /** 开发模式 */
  developmentMode = "";

  /** 质保期（月） */
  expirydate = undefined;

  /** 首次采购金额 */
  firstPurchasePrice = undefined;

  /** 物流属性分组 */
  groupModel = new LogisticsGroupResponseDto();

  /** HSCODE(国内) */
  hscodeCn = "";

  /** HSCODE(国外) */
  hscodeEn = "";

  /** id */
  id = undefined;

  /** 工作流实例ID */
  instanceId = undefined;

  /** 产品等级 */
  levelNum = "";

  /** 版本 */
  lockVersion = undefined;

  /** 物流分组名称 */
  logisticsGroupName = "";

  /** 物流分组编号 */
  logisticsGroupNo = "";

  /** 材质 */
  materialModel = new ProductMaterialResponseDto();

  /** 产品材质名称 */
  materialName = "";

  /** 产品材质编号 */
  materialNo = "";

  /** MQ推送状态: -1 未推送 0 推送失败 1推送成功 */
  mqSendStatus = undefined;

  /** 是否是新数据(需求管理上线前的历史数据为false) */
  newDataFlag = false;

  /** 新品类型 */
  newProductType = "";

  /** NS消费状态：-1 未消费 0消费失败 1消费成功 */
  nsConsumeStatus = undefined;

  /** 事业部名称 */
  organizationNane = "";

  /** 事业部编号 */
  organizationNo = "";

  /** 计划员 */
  planner = "";

  /** 计划员名称 */
  plannerName = "";

  /** 产品简称 */
  productAbbreviation = "";

  /** spu产品id */
  productKey = "";

  /** 产品名称（CN） */
  productNameCn = "";

  /** 产品名称（EN） */
  productNameEn = "";

  /** 产品编号 */
  productNo = "";

  /** 产品负责人 */
  productOwner = "";

  /** 产品负责人名称 */
  productOwnerName = "";

  /** 产品用途 */
  productUse = "";

  /** 审批号 */
  puno = "";

  /** 采购负责人 */
  purchaser = "";

  /** 采购负责人名称 */
  purchaserName = "";

  /** 驳回人ID */
  rejecter = undefined;

  /** 驳回人名称 */
  rejecterName = "";

  /** 是否研发产品 */
  researchFlag = false;

  /** 研发立项日期 */
  researchTime = "";

  /** 新品评审会日期 */
  reviewTime = "";

  /** SBU编码 */
  sbuCode = undefined;

  /** 副产品负责人 */
  secondOwner = "";

  /** 副产品负责人名称 */
  secondOwnerName = "";

  /** SKU集合 */
  skuModelList = [];

  /** 状态：启用 or 停用 */
  status = undefined;

  /** 退税率 */
  taxRebateRate = undefined;

  /** 类型 */
  typeModel = new ProductTypeResponseDto();

  /** 产品类型名称 */
  typeName = "";

  /** 产品类型编号 */
  typeNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 增值税率 */
  vatRate = undefined;
}

class ProductSkuApprovalRequestDto {
  /** 驳回备注 */
  applyMemo = "";

  /** 审批结果 1:通过 0:驳回 */
  approvalStatus = undefined;

  /** 品牌名称（CN） */
  brandNameCn = "";

  /** 品牌编号 */
  brandNo = "";

  /** 产品认证类型 */
  certificationType = "";

  /** 海关要素NO */
  cino = "";

  /** 是否商检 */
  commodityInspectionFlag = false;

  /** 海关监管条件 */
  customsControl = "";

  /** 法定海关单位 */
  customsUnit = "";

  /** 申报要素 */
  declareMemo = "";

  /** 申报名称（CN） */
  declareNameCn = "";

  /** 申报名称（EN） */
  declareNameEn = "";

  /** 是否申报型号 */
  declareTypeFlag = false;

  /** HSCODE(国内) */
  hscodeCn = "";

  /** 检疫检验类别 */
  inspectionType = "";

  /** 开票单位名称 */
  invoiceUnitName = "";

  /** 产品材质名称（CN） */
  materialNameCn = "";

  /** 产品材质名称（EN） */
  materialNameEn = "";

  /** 产品用途（CN） */
  productUseCn = "";

  /** 产品用途（EN） */
  productUseEn = "";

  /** 出口退税率 */
  rebateRate = undefined;

  /** 产品销售链接 */
  salesLink = "";

  /** 产品销售价格 */
  salesPrice = undefined;

  /** 国外海关编码 */
  skuCustomsList = [];

  /** sku产品id */
  skuKey = "";

  /** SKU型号 */
  skuModel = "";

  /** 工作流TaskID */
  taskId = "";
}

class ProductSkuCustomsRequestDto {
  /** 是否反倾销 */
  antiDumpingFlag = false;

  /** 反倾销税 */
  antiDumpingRate = undefined;

  /** 海关要素NO */
  cino = "";

  /** 中文名称 */
  countryNameCn = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 海关编码 */
  hscodeCn = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** spu产品id */
  productKey = "";

  /** 产品编号 */
  productNo = "";

  /** 国家二字码 */
  secondWord = "";

  /** sku产品id */
  skuKey = "";

  /** SKU编号 */
  skuNo = "";

  /** 关税率 */
  tariffRate = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProductSkuCustomsRequestDto0 {
  /** 是否反倾销 */
  antiDumpingFlag = false;

  /** 反倾销税 */
  antiDumpingRate = undefined;

  /** 海关要素NO */
  cino = "";

  /** 国家中文名称 */
  countryNameCn = "";

  /** 海关编码 */
  hscodeCn = "";

  /** 主键 */
  id = undefined;

  /** spu产品id */
  productKey = "";

  /** 产品编号 */
  productNo = "";

  /** 国家二字码 */
  secondWord = "";

  /** sku产品id */
  skuKey = "";

  /** SKU编号 */
  skuNo = "";

  /** 关税率 */
  tariffRate = undefined;
}

class ProductSkuForecastRequestDto {
  /** 币种 */
  currency = "";

  /** 预测销售单价 */
  expectUnitPrice = undefined;

  /** 首月销量目标 */
  firstMonthSalesQty = undefined;

  /** first年销售额 */
  firstYearSalesAmount = undefined;

  /** first年销量 */
  firstYearSalesQty = undefined;

  /** id */
  id = undefined;

  /** productKey */
  productKey = "";

  /** 销售负责人 */
  salesProcessor = "";

  /** 第二月销量目标 */
  secondMonthSalesQty = undefined;

  /** second年销售额 */
  secondYearSalesAmount = undefined;

  /** second年销量 */
  secondYearSalesQty = undefined;

  /** 站点标识 */
  siteKey = "";

  /** skuKey */
  skuKey = "";

  /** 第三月销量目标 */
  thirdMonthSalesQty = undefined;
}

class ProductSkuForecastResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 删除标识 */
  deleted = undefined;

  /** 预测销售单价 */
  expectUnitPrice = undefined;

  /** 首月销量目标 */
  firstMonthSalesQty = undefined;

  /** 年销售额 */
  firstYearSalesAmount = undefined;

  /** 年销量 */
  firstYearSalesQty = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** spu产品id */
  productKey = "";

  /** 销售负责人 */
  salesProcessor = "";

  /** 第二月销量目标 */
  secondMonthSalesQty = undefined;

  /** 年销售额 */
  secondYearSalesAmount = undefined;

  /** 年销量 */
  secondYearSalesQty = undefined;

  /** 站点标识 */
  siteKey = "";

  /** sku产品id */
  skuKey = "";

  /** 第三月销量目标 */
  thirdMonthSalesQty = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProductSkuModel {
  /** 附件链接 */
  annexUrl = "";

  /** 提交人ID */
  applyUser = undefined;

  /** 提交人备注 */
  applyUserMemo = "";

  /** 提交人名称 */
  applyUserName = "";

  /** 审批状态 -1:未提交审批 0:已驳回 1:已通过 2:审批中 */
  approvalStatus = undefined;

  /** 装箱高 */
  boxHeightCm = undefined;

  /** 装箱长 */
  boxLongCm = undefined;

  /** 装箱宽 */
  boxWidthCm = undefined;

  /** 品牌名称（CN） */
  brandNameCn = "";

  /** 品牌编号 */
  brandNo = "";

  /** BU编码 */
  buCode = undefined;

  /** BU名称 */
  buName = "";

  /** 产品认证类型 */
  certificationType = "";

  /** 海关要素NO */
  cino = "";

  /** 是否商检 */
  commodityInspectionFlag = false;

  /** 商品尺寸 */
  commoditySize = undefined;

  /** 质检确认箱规-高 */
  confirmBoxHeightCm = undefined;

  /** 质检确认箱规-长 */
  confirmBoxLongCm = undefined;

  /** 质检确认箱规-宽 */
  confirmBoxWidthCm = undefined;

  /** 质检确认产品包装高（CM） */
  confirmPackHeightCm = undefined;

  /** 质检确认产品包装长（CM） */
  confirmPackLongCm = undefined;

  /** 质检确认产品包装重量（G） */
  confirmPackWeight = undefined;

  /** 质检确认产品包装宽（CM） */
  confirmPackWidthCm = undefined;

  /** 质检确认单箱体积重 */
  confirmSingleBoxVolumeWeight = undefined;

  /** 质检确认单箱毛重 */
  confirmSinglePackingWeight = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当前审核状态 */
  currentApprovalStatus = "";

  /** 当前审批步骤 */
  currentApprovalStep = "";

  /** 海关监管条件 */
  customsControl = "";

  /** 法定海关单位 */
  customsUnit = "";

  /** 申报要素 */
  declareMemo = "";

  /** 申报名称（CN） */
  declareNameCn = "";

  /** 申报名称（EN） */
  declareNameEn = "";

  /** 是否申报型号 */
  declareTypeFlag = false;

  /** 删除标识 */
  deleted = undefined;

  /** 产品交期 */
  deliveryDay = undefined;

  /** 需求计划员 */
  demandPlanner = "";

  /** 描述 */
  description = "";

  /** 预计下单时间 */
  expectOrderTime = "";

  /** 预计上架时间 */
  expectShelveTime = "";

  /** 预计销售单价（CNY) */
  expectUnitPriceCny = undefined;

  /** 产品高 */
  heightCm = undefined;

  /** HSCODE(国内) */
  hscodeCn = "";

  /** HSCODE(国外) */
  hscodeEn = "";

  /** id */
  id = undefined;

  /** 图片链接 */
  imageUrl = "";

  /** 产品初始分级 */
  initLevelNum = "";

  /** 检疫检验类别 */
  inspectionType = "";

  /** 工作流实例ID */
  instanceId = undefined;

  /** 开票单位名称 */
  invoiceUnitName = "";

  /** 开票单位编号 */
  invoiceUnitNo = "";

  /** 是否研发产品：false or true */
  isDevolopFlag = false;

  /** 是否需要厂检 */
  isFactoryCheck = false;

  /** 是否需要质检 */
  isWarehouseCheck = false;

  /** 产品分级 */
  levelNum = "";

  /** 版本 */
  lockVersion = undefined;

  /** 物流周期 */
  logisticsCycle = undefined;

  /** 产品长 */
  longCm = undefined;

  /** 产品材质名称（CN） */
  materialNameCn = "";

  /** 产品材质名称（EN） */
  materialNameEn = "";

  /** 最小供应商moq */
  minMoq = undefined;

  /** 每箱数量（MPQ） */
  mpq = undefined;

  /** MQ推送状态: -1 未推送 0 推送失败 1推送成功 */
  mqSendStatus = undefined;

  /** 新品类型(brand_new:全新品;spu_expand_new:spu拓展新品) */
  newProductType = "";

  /** NS消费状态：-1 未消费 0消费失败 1消费成功 */
  nsConsumeStatus = undefined;

  /** 产品包装高 */
  packHeightCm = undefined;

  /** 产品包装长 */
  packLongCm = undefined;

  /** 产品包装重量（g） */
  packWeight = undefined;

  /** 产品包装宽 */
  packWidthCm = undefined;

  /** 计划员 */
  planner = "";

  /** spu产品id */
  productKey = "";

  /** 是否产品化管理 */
  productManagementFlag = false;

  /** 产品编号 */
  productNo = "";

  /** 产品负责人 */
  productOwner = "";

  /** 产品负责人名称 */
  productOwnerName = "";

  /** 产品用途（CN） */
  productUseCn = "";

  /** 产品用途（EN） */
  productUseEn = "";

  /** 生产周期 */
  productionCycle = undefined;

  /** 项目经理用户编码 */
  projectManager = "";

  /** 采购单位编号 */
  purchaseUnitNo = "";

  /** 采购负责人 */
  purchaser = "";

  /** 数量 */
  qty = undefined;

  /** 出口退税率 */
  rebateRate = undefined;

  /** 驳回备注 */
  rejectRemark = "";

  /** 驳回人ID */
  rejecter = undefined;

  /** 驳回人名称 */
  rejecterName = "";

  /** 备注 */
  remark = "";

  /** 产品销售链接 */
  salesLink = "";

  /** 产品销售价格 */
  salesPrice = undefined;

  /** 副产品负责人 */
  secondOwner = "";

  /** 副产品负责人名称 */
  secondOwnerName = "";

  /** 默认运输方式名称 */
  shippingMethodName = "";

  /** 默认运输方式编号 */
  shippingMethodNo = "";

  /** 单个产品计费重（g） */
  singleBillingWeight = undefined;

  /** 装箱体积（CM3） */
  singleBoxVolume = undefined;

  /** 单个产品装箱体积重(g) */
  singleBoxVolumeWeight = undefined;

  /** 单箱净重 */
  singlePackingSuttleWeight = undefined;

  /** 单个产品装箱重量(g) */
  singlePackingWeight = undefined;

  /** SKU简称 */
  skuAbbreviation = "";

  /** sku产品id */
  skuKey = "";

  /** SKU型号 */
  skuModel = "";

  /** SKU编号 */
  skuNo = "";

  /** SKU标题（CN） */
  skuTitleCn = "";

  /** SKU标题（EN） */
  skuTitleEn = "";

  /** 是否特批 */
  specialPermitFlag = false;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 计量单位名称 */
  unitName = "";

  /** 计量单位编号 */
  unitNo = "";

  /** 单位类型名称 */
  unitTypeName = "";

  /** 单位类型编号 */
  unitTypeNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 默认供应商名称 */
  vendorName = "";

  /** 默认供应商编号 */
  vendorNo = "";

  /** 体积重 */
  volumeWeight = undefined;

  /** 产品重量（g） */
  weight = undefined;

  /** 产品宽 */
  widthCm = undefined;
}

class ProductSkuRequestDto {
  /** 附件链接 */
  annexUrl = "";

  /** 审批状态 -1:未提交审批 0:已驳回 1:已通过 2:审批中 */
  approvalStatus = undefined;

  /** 装箱高 */
  boxHeightCm = undefined;

  /** 装箱长 */
  boxLongCm = undefined;

  /** 装箱宽 */
  boxWidthCm = undefined;

  /** 品牌名称（CN） */
  brandNameCn = "";

  /** 品牌编号 */
  brandNo = "";

  /** 产品认证类型 */
  certificationType = "";

  /** 海关要素NO */
  cino = "";

  /** 是否商检 */
  commodityInspectionFlag = false;

  /** 商品尺寸 */
  commoditySize = undefined;

  /** 质检确认箱规-高 */
  confirmBoxHeightCm = undefined;

  /** 质检确认箱规-长 */
  confirmBoxLongCm = undefined;

  /** 质检确认箱规-宽 */
  confirmBoxWidthCm = undefined;

  /** 质检确认产品包装高（CM） */
  confirmPackHeightCm = undefined;

  /** 质检确认产品包装长（CM） */
  confirmPackLongCm = undefined;

  /** 质检确认产品包装重量（G） */
  confirmPackWeight = undefined;

  /** 质检确认产品包装宽（CM） */
  confirmPackWidthCm = undefined;

  /** 质检确认单箱体积重 */
  confirmSingleBoxVolumeWeight = undefined;

  /** 质检确认单箱毛重 */
  confirmSinglePackingWeight = undefined;

  /** 海关监管条件 */
  customsControl = "";

  /** 法定海关单位 */
  customsUnit = "";

  /** 申报要素 */
  declareMemo = "";

  /** 申报名称（CN） */
  declareNameCn = "";

  /** 申报名称（EN） */
  declareNameEn = "";

  /** 是否申报型号 */
  declareTypeFlag = false;

  /** 产品交期 */
  deliveryDay = undefined;

  /** 需求计划员 */
  demandPlanner = "";

  /** 描述 */
  description = "";

  /** 预计下单时间 */
  expectOrderTime = "";

  /** 预计上架时间 */
  expectShelveTime = "";

  /** 预计销售单价（CNY) */
  expectUnitPriceCny = undefined;

  /** 产品高 */
  heightCm = undefined;

  /** HSCODE(国内) */
  hscodeCn = "";

  /** HSCODE(国外) */
  hscodeEn = "";

  /** id */
  id = undefined;

  /** 图片链接 */
  imageUrl = "";

  /** 产品初始分级 */
  initLevelNum = "";

  /** 检疫检验类别 */
  inspectionType = "";

  /** 开票单位名称 */
  invoiceUnitName = "";

  /** 开票单位 */
  invoiceUnitNo = "";

  /** 是否研发产品：false or true */
  isDevolopFlag = false;

  /** 是否需要厂检 */
  isFactoryCheck = false;

  /** 是否需要质检 */
  isWarehouseCheck = false;

  /** 产品分级 */
  levelNum = "";

  /** 物流周期 */
  logisticsCycle = undefined;

  /** 产品长 */
  longCm = undefined;

  /** 产品材质名称（CN） */
  materialNameCn = "";

  /** 产品材质名称（EN） */
  materialNameEn = "";

  /** 最小供应商moq */
  minMoq = undefined;

  /** 每箱数量（MPQ） */
  mpq = undefined;

  /** 新品类型(brand_new:全新品;spu_expand_new:spu拓展新品) */
  newProductType = "";

  /** 产品包装高 */
  packHeightCm = undefined;

  /** 产品包装长 */
  packLongCm = undefined;

  /** 产品包装重量（g） */
  packWeight = undefined;

  /** 产品包装宽 */
  packWidthCm = undefined;

  /** 计划员 */
  planner = "";

  /** spu产品id */
  productKey = "";

  /** 是否产品化管理 */
  productManagementFlag = false;

  /** spu */
  productNo = "";

  /** 产品负责人 */
  productOwner = "";

  /** 产品负责人名称 */
  productOwnerName = "";

  /** 产品用途（CN） */
  productUseCn = "";

  /** 产品用途（EN） */
  productUseEn = "";

  /** 生产周期 */
  productionCycle = undefined;

  /** 项目经理用户编码 */
  projectManager = "";

  /** 采购单位 */
  purchaseUnitNo = "";

  /** 采购负责人 */
  purchaser = "";

  /** 数量 */
  qty = undefined;

  /** 出口退税率 */
  rebateRate = undefined;

  /** 备注 */
  remark = "";

  /** 产品销售链接 */
  salesLink = "";

  /** 产品销售价格 */
  salesPrice = undefined;

  /** 副产品负责人 */
  secondOwner = "";

  /** 副产品负责人名称 */
  secondOwnerName = "";

  /** 默认运输方式名称 */
  shippingMethodName = "";

  /** 默认运输方式编号 */
  shippingMethodNo = "";

  /** 单个产品计费重（g） */
  singleBillingWeight = undefined;

  /** 装箱体积（CM3） */
  singleBoxVolume = undefined;

  /** 单个产品装箱体积重(g) */
  singleBoxVolumeWeight = undefined;

  /** 单箱净重 */
  singlePackingSuttleWeight = undefined;

  /** 单个产品装箱重量(g) */
  singlePackingWeight = undefined;

  /** SKU简称 */
  skuAbbreviation = "";

  /** 国外海关编码 */
  skuCustomsList = [];

  /** sku销售预测 */
  skuForecastList = [];

  /** sku产品id */
  skuKey = "";

  /** SKU型号 */
  skuModel = "";

  /** sku */
  skuNo = "";

  /** SKU标题（CN） */
  skuTitleCn = "";

  /** SKU标题（EN） */
  skuTitleEn = "";

  /** 是否特批 */
  specialPermitFlag = false;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 计量单位名称 */
  unitName = "";

  /** 计量单位编号 */
  unitNo = "";

  /** 单位类型名称 */
  unitTypeName = "";

  /** 单位类型编号 */
  unitTypeNo = "";

  /** 默认供应商名称 */
  vendorName = "";

  /** 默认供应商编号 */
  vendorNo = "";

  /** 体积重 */
  volumeWeight = undefined;

  /** 产品重量（g） */
  weight = undefined;

  /** 产品宽 */
  widthCm = undefined;
}

class ProductSkuRequestDtoRPC {
  /** 附件链接 */
  annexUrl = "";

  /** 装箱高 */
  boxHeightCm = undefined;

  /** 装箱长 */
  boxLongCm = undefined;

  /** 装箱宽 */
  boxWidthCm = undefined;

  /** 创建时间大于 */
  createTimeGe = "";

  /** 申报要素 */
  declareMemo = "";

  /** 申报名称（CN） */
  declareNameCn = "";

  /** 申报名称（EN） */
  declareNameEn = "";

  /** 产品交期 */
  deliveryDay = undefined;

  /** 描述 */
  description = "";

  /** 预计下单时间 */
  expectOrderTime = "";

  /** 预计上架时间 */
  expectShelveTime = "";

  /** 产品高 */
  heightCm = undefined;

  /** HSCODE(国内) */
  hscodeCn = "";

  /** HSCODE(国外) */
  hscodeEn = "";

  /** 图片链接 */
  imageUrl = "";

  /** 产品初始分级 */
  initLevelNum = "";

  /** 开票单位 */
  invoiceUnitNo = "";

  /** 是否研发产品：false or true */
  isDevolopFlag = false;

  /** 是否需要厂检 */
  isFactoryCheck = undefined;

  /** 是否需要质检 */
  isWarehouseCheck = undefined;

  /** 产品分级 */
  levelNum = "";

  /** 物流周期 */
  logisticsCycle = undefined;

  /** 产品长 */
  longCm = undefined;

  /** 最小供应商moq */
  minMoq = undefined;

  /** 每箱数量（MPQ） */
  mpq = undefined;

  /** spu产品id */
  productKey = "";

  /** 产品编号 */
  productNo = "";

  /** 产品负责人 */
  productOwner = "";

  /** 产品负责人名称 */
  productOwnerName = "";

  /** 生产周期 */
  productionCycle = undefined;

  /** 采购单位 */
  purchaseUnitNo = "";

  /** 数量 */
  qty = undefined;

  /** 副产品负责人 */
  secondOwner = "";

  /** 副产品负责人名称 */
  secondOwnerName = "";

  /** 默认运输方式名称 */
  shippingMethodName = "";

  /** 默认运输方式编号 */
  shippingMethodNo = "";

  /** 单个产品计费重（g） */
  singleBillingWeight = undefined;

  /** 装箱体积（CM3） */
  singleBoxVolume = undefined;

  /** 单个产品装箱体积重(g) */
  singleBoxVolumeWeight = undefined;

  /** 单个产品装箱重量(g) */
  singlePackingWeight = undefined;

  /** SKU简称 */
  skuAbbreviation = "";

  /** sku产品id */
  skuKey = "";

  /** SKU型号 */
  skuModel = "";

  /** SKU编号 */
  skuNo = "";

  /** SKU标题（CN） */
  skuTitleCn = "";

  /** SKU标题（EN） */
  skuTitleEn = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 计量单位名称 */
  unitName = "";

  /** 计量单位编号 */
  unitNo = "";

  /** 单位类型名称 */
  unitTypeName = "";

  /** 单位类型编号 */
  unitTypeNo = "";

  /** 修改时间大于 */
  updateTimeGe = "";

  /** 默认供应商名称 */
  vendorName = "";

  /** 默认供应商编号 */
  vendorNo = "";

  /** 体积重 */
  volumeWeight = undefined;

  /** 产品重量（g） */
  weight = undefined;

  /** 产品宽 */
  widthCm = undefined;
}

class ProductSkuRequestParamsDto {
  /** 附件链接 */
  annexUrl = "";

  /** 提交人ID */
  applyUser = undefined;

  /** 提交人备注 */
  applyUserMemo = "";

  /** 提交人名称 */
  applyUserName = "";

  /** 审批状态 -1:未提交审批 0:已驳回 1:已通过 2:审批中 */
  approvalStatus = "";

  /** 装箱高 */
  boxHeightCm = undefined;

  /** 装箱长 */
  boxLongCm = undefined;

  /** 装箱宽 */
  boxWidthCm = undefined;

  /** 品牌编号 */
  brandNo = "";

  /** 品类编号 */
  categoryNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 创建时间大于 */
  createTimeGe = "";

  /** 当前审批步骤 */
  currentApprovalStep = "";

  /** 申报名称（CN） */
  declareNameCn = "";

  /** 申报名称（EN） */
  declareNameEn = "";

  /** 删除标识 */
  deleted = undefined;

  /** 产品交期 */
  deliveryDay = undefined;

  /** 需求计划员 */
  demandPlanner = "";

  /** 描述 */
  description = "";

  /** 质保期（月） */
  expirydate = undefined;

  /** 产品高 */
  heightCm = undefined;

  /** HSCODE(国内) */
  hscodeCn = "";

  /** HSCODE(国外) */
  hscodeEn = "";

  /** id */
  id = undefined;

  /** 图片链接 */
  imageUrl = "";

  /** 产品初始分级 */
  initLevelNum = "";

  /** 工作流实例ID */
  instanceId = undefined;

  /** 是否研发产品：false or true */
  isDevolopFlag = false;

  /** 是否需要厂检 */
  isFactoryCheck = undefined;

  /** 是否需要质检 */
  isWarehouseCheck = undefined;

  /** 产品分级 */
  levelNum = "";

  /** 版本 */
  lockVersion = undefined;

  /** 物流周期 */
  logisticsCycle = undefined;

  /** 物流分组编号 */
  logisticsGroupNo = "";

  /** 产品长 */
  longCm = undefined;

  /** 最小供应商moq */
  minMoq = undefined;

  /** 每箱数量（MPQ） */
  mpq = undefined;

  /** MQ推送状态: -1 未推送 0 推送失败 1推送成功 */
  mqSendStatus = undefined;

  /** NS消费状态：-1 未消费 0消费失败 1消费成功 */
  nsConsumeStatus = undefined;

  /** 计划员 */
  planner = "";

  /** spu产品id */
  productKey = "";

  /** 产品名称（CN） */
  productNameCn = "";

  /** 产品名称（EN） */
  productNameEn = "";

  /** 产品编号 */
  productNo = "";

  /** 产品负责人 */
  productOwner = "";

  /** 产品负责人名称 */
  productOwnerName = "";

  /** 审批号 */
  puno = "";

  /** 采购负责人 */
  purchaser = "";

  /** 驳回人ID */
  rejecter = undefined;

  /** 驳回人名称 */
  rejecterName = "";

  /** 副产品负责人 */
  secondOwner = "";

  /** 副产品负责人名称 */
  secondOwnerName = "";

  /** 默认运输方式名称 */
  shippingMethodName = "";

  /** 默认运输方式编号 */
  shippingMethodNo = "";

  /** 单个产品计费重（g） */
  singleBillingWeight = undefined;

  /** 装箱体积（CM3） */
  singleBoxVolume = undefined;

  /** 单个产品装箱体积重(g) */
  singleBoxVolumeWeight = undefined;

  /** 单个产品装箱重量(g) */
  singlePackingWeight = undefined;

  /** SKU简称 */
  skuAbbreviation = "";

  /** sku产品id */
  skuKey = "";

  /** SKU编号 */
  skuNo = "";

  /** SKU标题（CN） */
  skuTitleCn = "";

  /** SKU标题（EN） */
  skuTitleEn = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 产品类型编号 */
  typeNo = "";

  /** 计量单位名称 */
  unitName = "";

  /** 计量单位编号 */
  unitNo = "";

  /** 单位类型名称 */
  unitTypeName = "";

  /** 单位类型编号 */
  unitTypeNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 修改时间大于 */
  updateTimeGe = "";

  /** 默认供应商名称 */
  vendorName = "";

  /** 默认供应商编号 */
  vendorNo = "";

  /** 体积重 */
  volumeWeight = undefined;

  /** 产品重量（g） */
  weight = undefined;

  /** 产品宽 */
  widthCm = undefined;
}

class ProductSkuResponseDto {
  /** 附件链接 */
  annexUrl = "";

  /** 提交人ID */
  applyUser = undefined;

  /** 提交人备注 */
  applyUserMemo = "";

  /** 提交人名称 */
  applyUserName = "";

  /** 审批状态 -1:未提交审批 0:已驳回 1:已通过 2:审批中 */
  approvalStatus = undefined;

  /** 装箱高 */
  boxHeightCm = undefined;

  /** 装箱长 */
  boxLongCm = undefined;

  /** 装箱宽 */
  boxWidthCm = undefined;

  /** 品牌名称（CN） */
  brandNameCn = "";

  /** 品牌编号 */
  brandNo = "";

  /** BU编码 */
  buCode = undefined;

  /** BU名称 */
  buName = "";

  /** 产品认证类型 */
  certificationType = "";

  /** 海关要素NO */
  cino = "";

  /** 是否商检 */
  commodityInspectionFlag = false;

  /** 商品尺寸 */
  commoditySize = undefined;

  /** 质检确认箱规-高 */
  confirmBoxHeightCm = undefined;

  /** 质检确认箱规-长 */
  confirmBoxLongCm = undefined;

  /** 质检确认箱规-宽 */
  confirmBoxWidthCm = undefined;

  /** 质检确认产品包装高（CM） */
  confirmPackHeightCm = undefined;

  /** 质检确认产品包装长（CM） */
  confirmPackLongCm = undefined;

  /** 质检确认产品包装重量（G） */
  confirmPackWeight = undefined;

  /** 质检确认产品包装宽（CM） */
  confirmPackWidthCm = undefined;

  /** 质检确认单箱体积重 */
  confirmSingleBoxVolumeWeight = undefined;

  /** 质检确认单箱毛重 */
  confirmSinglePackingWeight = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当前审批步骤 */
  currentApprovalStep = "";

  /** 海关监管条件 */
  customsControl = "";

  /** 法定海关单位 */
  customsUnit = "";

  /** 申报要素 */
  declareMemo = "";

  /** 申报名称（CN） */
  declareNameCn = "";

  /** 申报名称（EN） */
  declareNameEn = "";

  /** 是否申报型号 */
  declareTypeFlag = false;

  /** 删除标识 */
  deleted = undefined;

  /** 产品交期 */
  deliveryDay = undefined;

  /** 需求计划员 */
  demandPlanner = "";

  /** 描述 */
  description = "";

  /** 预计下单时间 */
  expectOrderTime = "";

  /** 预计上架时间 */
  expectShelveTime = "";

  /** 预计销售单价（CNY) */
  expectUnitPriceCny = undefined;

  /** 产品高 */
  heightCm = undefined;

  /** HSCODE(国内) */
  hscodeCn = "";

  /** HSCODE(国外) */
  hscodeEn = "";

  /** id */
  id = undefined;

  /** 图片链接 */
  imageUrl = "";

  /** 产品初始分级 */
  initLevelNum = "";

  /** 检疫检验类别 */
  inspectionType = "";

  /** 工作流实例ID */
  instanceId = undefined;

  /** 开票单位 */
  invoiceUnitName = "";

  /** 开票单位 */
  invoiceUnitNo = "";

  /** 是否研发产品：false or true */
  isDevolopFlag = false;

  /** 是否需要厂检 */
  isFactoryCheck = false;

  /** 是否需要质检 */
  isWarehouseCheck = false;

  /** 产品分级 */
  levelNum = "";

  /** 版本 */
  lockVersion = undefined;

  /** 物流周期 */
  logisticsCycle = undefined;

  /** 产品长 */
  longCm = undefined;

  /** 产品材质名称（CN） */
  materialNameCn = "";

  /** 产品材质名称（EN） */
  materialNameEn = "";

  /** 最小供应商moq */
  minMoq = undefined;

  /** 每箱数量（MPQ） */
  mpq = undefined;

  /** MQ推送状态: -1 未推送 0 推送失败 1推送成功 */
  mqSendStatus = undefined;

  /** 新品类型(brand_new:全新品;spu_expand_new:spu拓展新品) */
  newProductType = "";

  /** NS消费状态：-1 未消费 0消费失败 1消费成功 */
  nsConsumeStatus = undefined;

  /** NS产品负责人名称 */
  nsProductOwnerName = "";

  /** NS副产品负责人名称 */
  nsSecondOwnerName = "";

  /** 产品包装高 */
  packHeightCm = undefined;

  /** 产品包装长 */
  packLongCm = undefined;

  /** 产品包装重量（g） */
  packWeight = undefined;

  /** 产品包装宽 */
  packWidthCm = undefined;

  /** 计划员 */
  planner = "";

  /** spu产品id */
  productKey = "";

  /** 是否产品化管理 */
  productManagementFlag = false;

  /** 产品编号 */
  productNo = "";

  /** 产品负责人 */
  productOwner = "";

  /** 产品负责人名称 */
  productOwnerName = "";

  /** 产品用途（CN） */
  productUseCn = "";

  /** 产品用途（EN） */
  productUseEn = "";

  /** 生产周期 */
  productionCycle = undefined;

  /** 项目经理用户编码 */
  projectManager = "";

  /** 采购单位名称 */
  purchaseUnitName = "";

  /** 采购单位 */
  purchaseUnitNo = "";

  /** 采购负责人 */
  purchaser = "";

  /** 数量 */
  qty = undefined;

  /** 出口退税率 */
  rebateRate = undefined;

  /** 驳回人ID */
  rejecter = undefined;

  /** 驳回人名称 */
  rejecterName = "";

  /** 备注 */
  remark = "";

  /** 产品销售链接 */
  salesLink = "";

  /** 产品销售价格 */
  salesPrice = undefined;

  /** 副产品负责人 */
  secondOwner = "";

  /** 副产品负责人名称 */
  secondOwnerName = "";

  /** 默认运输方式名称 */
  shippingMethodName = "";

  /** 默认运输方式编号 */
  shippingMethodNo = "";

  /** 单个产品计费重（g） */
  singleBillingWeight = undefined;

  /** 装箱体积（CM3） */
  singleBoxVolume = undefined;

  /** 单个产品装箱体积重(g) */
  singleBoxVolumeWeight = undefined;

  /** 单箱净重 */
  singlePackingSuttleWeight = undefined;

  /** 单个产品装箱重量(g) */
  singlePackingWeight = undefined;

  /** SKU简称 */
  skuAbbreviation = "";

  /** 国外海关编码 */
  skuCustomsList = [];

  /** sku销售预测 */
  skuForecastList = [];

  /** sku产品id */
  skuKey = "";

  /** SKU型号 */
  skuModel = "";

  /** SKU编号 */
  skuNo = "";

  /** SKU标题（CN） */
  skuTitleCn = "";

  /** SKU标题（EN） */
  skuTitleEn = "";

  /** 是否特批 */
  specialPermitFlag = false;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 计量单位名称 */
  unitName = "";

  /** 计量单位编号 */
  unitNo = "";

  /** 单位类型名称 */
  unitTypeName = "";

  /** 单位类型编号 */
  unitTypeNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 默认供应商名称 */
  vendorName = "";

  /** 默认供应商编号 */
  vendorNo = "";

  /** 体积重 */
  volumeWeight = undefined;

  /** 产品重量（g） */
  weight = undefined;

  /** 产品宽 */
  widthCm = undefined;
}

class ProductSkuUpdateRequestDto {
  /** 供应商moq */
  moq = undefined;

  /** sku */
  skuNo = "";
}

class ProductTimelinessSettingResponseDto {
  /** 调拨单创建时效 */
  allotCreateTimeliness = undefined;

  /** 打包装箱时效 */
  allotPackboxTimeliness = undefined;

  /** 调拨发运总日期（工作日） */
  allotTotalTimeliness = undefined;

  /** 处理BOM */
  bomTimeliness = undefined;

  /** BOM总日期（自然日） */
  bomTotalTimeliness = undefined;

  /** 包装审批时效 */
  confirmPackageTimeliness = undefined;

  /** 成本审批时效 */
  confirmPriceTimeliness = undefined;

  /** 品控质检时效 */
  confirmQualityTimeliness = undefined;

  /** 测试审批时效 */
  confirmResearchTimeliness = undefined;

  /** 样品确定总日期（工作日） */
  confirmTotalTimeliness = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createName = "";

  /** 创建时间 */
  createTime = "";

  /** 是否默认设置:true=是,false=否 */
  defaultFlag = false;

  /** 删除标识 */
  deleted = undefined;

  /** 开发模式(review:新品评审;research:研发立项) */
  developmentMode = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 到达FBA时效-空运 */
  logisticsFbaAirTimeliness = undefined;

  /** 到达FBA时效-海运 */
  logisticsFbaSeaTimeliness = undefined;

  /** 物流运输总时效（自然日） */
  logisticsTotalTimeliness = undefined;

  /** PR审批通过时效 */
  orderPrApprovedTimeliness = undefined;

  /** 新品下单总日期（工作日） */
  orderTotalTimeliness = undefined;

  /** 样品准备时效 */
  prepareTimeliness = undefined;

  /** 样品准备总日期（自然日） */
  prepareTotalTimeliness = undefined;

  /** 采购订单审批通过时效 */
  purchaseApprovedTimeliness = undefined;

  /** 采购总日期（工作日） */
  purchaseTotalTimeliness = undefined;

  /** SKU产品id */
  skuKey = "";

  /** SKU编号,DEFAULT=默认设置 */
  skuNo = "";

  /** 时效设置NO */
  tsno = "";

  /** 修改人 */
  updateBy = "";

  /** 修改人名称 */
  updateName = "";

  /** 修改时间 */
  updateTime = "";
}

class ProductTypeModel {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 产品类型简称 */
  typeAbbreviation = "";

  /** 产品类型名称（CN） */
  typeNameCn = "";

  /** 产品类型名称（EN） */
  typeNameEn = "";

  /** 产品类型编号 */
  typeNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProductTypeRequestDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 产品类型简称 */
  typeAbbreviation = "";

  /** 产品类型名称（CN） */
  typeNameCn = "";

  /** 产品类型名称（EN） */
  typeNameEn = "";

  /** 产品类型编号 */
  typeNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProductTypeRequestParamsDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 产品类型简称 */
  typeAbbreviation = "";

  /** 产品类型名称（CN） */
  typeNameCn = "";

  /** 产品类型名称（EN） */
  typeNameEn = "";

  /** 产品类型编号 */
  typeNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class ProductTypeResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 产品类型简称 */
  typeAbbreviation = "";

  /** 产品类型名称（CN） */
  typeNameCn = "";

  /** 产品类型名称（EN） */
  typeNameEn = "";

  /** 产品类型编号 */
  typeNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class PurchaseCustomsInfoRequestDto {
  /** 海关要素NO */
  cino = "";

  /** 是否商检 */
  commodityInspectionFlag = false;

  /** 海关法定单位名称 */
  customsUnitName = "";

  /** 海关法定单位 */
  customsUnitNo = "";

  /** 是否报关 */
  declareFlag = undefined;

  /** 申报名称（CN） */
  declareNameCn = "";

  /** 申报名称（EN） */
  declareNameEn = "";

  /** 海关编码 */
  hscodeCn = "";

  /** 主键 */
  id = undefined;

  /** 开票单位名称 */
  invoiceUnitName = "";

  /** 开票单位 */
  invoiceUnitNo = "";

  /** 退税率 */
  taxRebateRate = undefined;
}

class PurchasePoOrderDto {
  /** 入库状态：0：待入库 10：部分入库 20：已入库 30：结束交货 */
  inventoryStatus = undefined;

  /** PO单号 */
  poNo = "";

  /** PO状态 */
  poOrderStatus = undefined;
}

class PurchaseRequisitionCreateRequestDto {
  /** 渠道code  亚马逊:amazon, 全球渠道:global_channels */
  channel = "";

  /** 创建人 */
  createBy = "";

  /** msku */
  msku = "";

  /** 新品编号 */
  npono = "";

  /** 采购量 */
  number = undefined;

  /** planDeliveryDate, 计划交货日期 */
  planDeliveryDate = "";

  /** 备注 */
  remark = "";

  /** sku */
  sku = "";

  /** 供应商ID */
  supplierIdName = "";

  /** 交易主体code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";
}

class PurchaseRequisitionDto {
  /** 采购量 */
  number = undefined;

  /** planDeliveryDate, 计划交货日期 */
  planDeliveryDate = "";

  /** 备注 */
  remark = "";
}

class PurchaseRequisitionRpcResponseDto {
  /** PR审批状态 */
  approvalStatus = undefined;

  /** 渠道code  亚马逊:amazon, 全球渠道: global_channels */
  channel = "";

  /** MPQ */
  mpq = undefined;

  /** planDeliveryDate, 计划交货日期 */
  planDeliveryDate = "";

  /** PR单单号 */
  prNo = "";

  /** Po单列表 */
  purchasePoOrderDtoList = [];

  /** 采购量 */
  purchaseRequisitionQty = undefined;

  /** 备注 */
  remark = "";

  /** PR订购状态 */
  subscribeStatus = undefined;

  /** 交易主体Code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";
}

class ResearchItemCreateRequestDto {
  /** 申报编码 */
  cino = "";

  /** 采购员编号 */
  purchaser = "";

  /** 产品型号 */
  skuModel = "";

  /** 物料名称 */
  skuNameCn = "";

  /** 单位编号 */
  unit = "";
}

class ResearchItemUpdateRequestDto {
  /** 申报编码 */
  cino = "";

  /** 采购员名称 */
  purchaser = "";

  /** 产品型号 */
  skuModel = "";

  /** 物料名称 */
  skuNameCn = "";

  /** 物料编码 */
  skuNo = "";

  /** 单位名称 */
  unit = "";
}

class Response {
  /** code */
  code = "";

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new AppAccountResponseDto();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResultRec {
  /** allPageIdQty */
  allPageIdQty = "";

  /** allQty */
  allQty = "";

  /** batchId */
  batchId = "";

  /** returnInfor */
  returnInfor = "";

  /** returnStatus */
  returnStatus = "";
}

class RevenueDepartmentDetailResponseDto {
  /** 成本中心属性 */
  attribute = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 父ID */
  parentId = undefined;

  /** 受益部门code */
  revenueDepartmentCode = "";

  /** 交易主体Code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class RevenueDepartmentRequestDto {
  /** 受益部门code */
  revenueDepartmentCode = "";

  /** 受益部门负责人 */
  revenueDepartmentHead = "";

  /** 受益部门名称 */
  revenueDepartmentName = "";

  /** 状态 0:禁用 1启用 */
  status = undefined;

  /** 类型 */
  type = "";
}

class RevenueDepartmentRequestParamsDto {
  /** 创建人列表 */
  createBys = [];

  /** 创建日期-结束 */
  createTimeEnd = "";

  /** 创建日期-开始 */
  createTimeStart = "";

  /** 受益部门编号列表 */
  revenueDepartmentCodes = [];

  /** 受益部门负责人 */
  revenueDepartmentHeads = [];

  /** 受益部门名称列表 */
  revenueDepartmentNames = [];

  /** 状态 0:禁用 1启用-默认查询启用状态数据 */
  status = undefined;

  /** 更新人列表 */
  updateBys = [];

  /** 更新日期-结束 */
  updateTimeEnd = "";

  /** 更新日期-开始 */
  updateTimeStart = "";
}

class RevenueDepartmentResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 主键id */
  id = undefined;

  /** 受益部门明细 */
  itemList = [];

  /** 版本 */
  lockVersion = undefined;

  /** 受益部门code */
  revenueDepartmentCode = "";

  /** 受益部门负责人 */
  revenueDepartmentHead = "";

  /** 受益部门名称	 */
  revenueDepartmentName = "";

  /** 状态 0:禁用 1启用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class SalesChannelRequestDto {
  /** id（修改时提交） */
  id = undefined;

  /** 备注 */
  remark = "";

  /** 渠道名称 */
  salesChannelName = "";

  /** 销售部门编码 */
  salesDeptKey = "";

  /** 销售部门 */
  salesDeptName = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;
}

class SalesChannelResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 备注 */
  remark = "";

  /** 渠道编码 */
  salesChannelKey = "";

  /** 渠道名称 */
  salesChannelName = "";

  /** 销售部门编码 */
  salesDeptKey = "";

  /** 销售部门 */
  salesDeptName = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class SalesChannelRpcResponseDto {
  /** 渠道编码 */
  salesChannelKey = "";

  /** 渠道名称 */
  salesChannelName = "";

  /** 销售部门编码 */
  salesDeptKey = "";

  /** 销售部门 */
  salesDeptName = "";
}

class SaveFiledDto {
  /** autoUpdatedStatus */
  autoUpdatedStatus = false;

  /** code */
  code = "";

  /** createdTime */
  createdTime = "";

  /** entity */
  entity = undefined;

  /** id */
  id = "";

  /** infoStr */
  infoStr = "";

  /** md5 */
  md5 = "";

  /** operatorCode */
  operatorCode = "";

  /** operatorName */
  operatorName = "";

  /** syncStatus */
  syncStatus = false;

  /** type */
  type = "";

  /** updatedStatus */
  updatedStatus = false;

  /** updatedTime */
  updatedTime = "";
}

class ShopInfo {
  /** mskuNo */
  mskuNo = "";

  /** 店铺名称 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";
}

class SkuCorpsInfoAndCategoryRpcResponseDto {
  /** 军团名称 */
  corpsName = "";

  /** moq */
  moq = undefined;

  /** 一级品类 */
  primaryProductLine = "";

  /** 一级品类名称 */
  primaryProductName = "";

  /** 二级品类 */
  secondaryProductLine = "";

  /** 二级品类名称 */
  secondaryProductName = "";

  /** sku编码 */
  skuNo = "";

  /** spu编号 */
  spuNo = "";

  /** 供应计划员 */
  supplyPlanner = "";

  /** 三级品类 */
  tertiaryProductLine = "";

  /** 三级品类名称 */
  tertiaryProductName = "";
}

class SkuListAndStatusRequestDto {
  /** sku编码列表 */
  skuList = [];

  /** 状态：1启用 or 0停用 */
  status = undefined;
}

class SkuListResponseDto {
  /** 附件链接 */
  annexUrl = "";

  /** 提交人ID */
  applyUser = undefined;

  /** 提交人备注 */
  applyUserMemo = "";

  /** 提交人名称 */
  applyUserName = "";

  /** 审批状态 -1:未提交审批 0:已驳回 1:已通过 2:审批中 */
  approvalStatus = undefined;

  /** 装箱高 */
  boxHeightCm = undefined;

  /** 装箱长 */
  boxLongCm = undefined;

  /** 装箱宽 */
  boxWidthCm = undefined;

  /** 品牌名称 */
  brandName = "";

  /** 品牌名称（CN） */
  brandNameCn = "";

  /** 品牌编号 */
  brandNo = "";

  /** BU编码 */
  buCode = undefined;

  /** BU名称 */
  buName = "";

  /** 品类编码 */
  categoryNo = "";

  /** 产品认证类型 */
  certificationType = "";

  /** 海关要素NO */
  cino = "";

  /** 是否商检 */
  commodityInspectionFlag = false;

  /** commoditySize */
  commoditySize = undefined;

  /** 质检确认箱规-高 */
  confirmBoxHeightCm = undefined;

  /** 质检确认箱规-长 */
  confirmBoxLongCm = undefined;

  /** 质检确认箱规-宽 */
  confirmBoxWidthCm = undefined;

  /** 质检确认产品包装高（CM） */
  confirmPackHeightCm = undefined;

  /** 质检确认产品包装长（CM） */
  confirmPackLongCm = undefined;

  /** 质检确认产品包装重量（G） */
  confirmPackWeight = undefined;

  /** 质检确认产品包装宽（CM） */
  confirmPackWidthCm = undefined;

  /** 质检确认单箱体积重 */
  confirmSingleBoxVolumeWeight = undefined;

  /** 质检确认单箱毛重 */
  confirmSinglePackingWeight = undefined;

  /** 当前审批步骤 */
  currentApprovalStep = "";

  /** 海关监管条件 */
  customsControl = "";

  /** 法定海关单位 */
  customsUnit = "";

  /** 申报名称（CN） */
  declareNameCn = "";

  /** 申报名称（EN） */
  declareNameEn = "";

  /** 是否申报型号 */
  declareTypeFlag = false;

  /** 产品交期 */
  deliveryDay = undefined;

  /** 描述 */
  description = "";

  /** 产品高 */
  heightCm = undefined;

  /** HSCODE(国内) */
  hscodeCn = "";

  /** HSCODE(国外) */
  hscodeEn = "";

  /** id */
  id = undefined;

  /** 图片链接 */
  imageUrl = "";

  /** 产品初始分级 */
  initLevelNum = "";

  /** 检疫检验类别 */
  inspectionType = "";

  /** 工作流实例ID */
  instanceId = undefined;

  /** 开票单位名称 */
  invoiceUnitName = "";

  /** 开票单位编号 */
  invoiceUnitNo = "";

  /** 是否研发产品：false or true */
  isDevolopFlag = false;

  /** 是否需要厂检 */
  isFactoryCheck = undefined;

  /** 是否需要质检 */
  isWarehouseCheck = undefined;

  /** 一级产品线 */
  level1Category = "";

  /** 二级产品线 */
  level2Category = "";

  /** 三级产品线 */
  level3Category = "";

  /** 产品分级 */
  levelNum = "";

  /** 物流周期 */
  logisticsCycle = undefined;

  /** 物流分组 */
  logisticsGroupNo = "";

  /** 产品长 */
  longCm = undefined;

  /** 产品材质名称（CN） */
  materialNameCn = "";

  /** 产品材质名称（EN） */
  materialNameEn = "";

  /** 最小供应商moq */
  minMoq = undefined;

  /** 每箱数量（MPQ） */
  mpq = undefined;

  /** MQ推送状态: -1 未推送 0 推送失败 1推送成功 */
  mqSendStatus = undefined;

  /** NS消费状态：-1 未消费 0消费失败 1消费成功 */
  nsConsumeStatus = undefined;

  /** 事业部 */
  organizationNane = "";

  /** 产品包装高 */
  packHeightCm = undefined;

  /** 产品包装长 */
  packLongCm = undefined;

  /** 产品包装重量（g） */
  packWeight = undefined;

  /** 产品包装宽 */
  packWidthCm = undefined;

  /** 计划员 */
  planner = "";

  /** 是否产品化管理 */
  productManagementFlag = false;

  /** 产品名称（CN） */
  productNameCn = "";

  /** 产品名称（EN） */
  productNameEn = "";

  /** 产品编号 */
  productNo = "";

  /** 产品负责人 */
  productOwner = "";

  /** 产品负责人名称 */
  productOwnerName = "";

  /** 产品用途（CN） */
  productUseCn = "";

  /** 产品用途（EN） */
  productUseEn = "";

  /** 项目经理用户编码 */
  projectManager = "";

  /** 采购单位名称 */
  purchaseUnitName = "";

  /** 采购单位编号 */
  purchaseUnitNo = "";

  /** 采购负责人 */
  purchaser = "";

  /** 出口退税率 */
  rebateRate = undefined;

  /** 驳回人ID */
  rejecter = undefined;

  /** 驳回人名称 */
  rejecterName = "";

  /** 备注 */
  remark = "";

  /** 产品销售链接 */
  salesLink = "";

  /** 产品销售价格 */
  salesPrice = undefined;

  /** SBU编码 */
  sbuCode = undefined;

  /** SBU名称 */
  sbuName = "";

  /** 副产品负责人 */
  secondOwner = "";

  /** 副产品负责人名称 */
  secondOwnerName = "";

  /** 默认运输方式名称 */
  shippingMethodName = "";

  /** 默认运输方式编号 */
  shippingMethodNo = "";

  /** 单个产品计费重（g） */
  singleBillingWeight = undefined;

  /** 装箱体积（CM3） */
  singleBoxVolume = undefined;

  /** 单个产品装箱体积重(g) */
  singleBoxVolumeWeight = undefined;

  /** 单箱净重 */
  singlePackingSuttleWeight = undefined;

  /** 单个产品装箱重量(g) */
  singlePackingWeight = undefined;

  /** SKU简称 */
  skuAbbreviation = "";

  /** SKU型号 */
  skuModel = "";

  /** SKU编号 */
  skuNo = "";

  /** SKU标题（CN） */
  skuTitleCn = "";

  /** SKU标题（EN） */
  skuTitleEn = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 计量单位名称(弃用字段，采购单位) */
  unitName = "";

  /** 计量单位编号(弃用字段，采购单位) */
  unitNo = "";

  /** 单位类型名称 */
  unitTypeName = "";

  /** 单位类型编号 */
  unitTypeNo = "";

  /** 默认供应商名称 */
  vendorName = "";

  /** 默认供应商编号 */
  vendorNo = "";

  /** 体积重 */
  volumeWeight = undefined;

  /** 产品重量（g） */
  weight = undefined;

  /** 产品宽 */
  widthCm = undefined;
}

class SkuNoAndNameResponseDto {
  /** SKU编号 */
  skuNo = "";

  /** SKU标题（CN） */
  skuTitleCn = "";
}

class SkuPurchaseRequisitionRpcResponseDto {
  /** 审批状体：审批中、审批通过、审批驳回、已作废 */
  approvalStatus = undefined;

  /** 创建时间 */
  createTime = "";

  /** PR单单号 */
  prNo = "";

  /** 采购量 */
  purchaseRequisitionQty = undefined;

  /** 订购状态(0:待订购, 10:已订购, 20:已下单, 30:采购驳回, 40:作废审批中, 50:回滚作废, 60:采购驳回作废) */
  subscribeStatus = undefined;
}

class SkuResponseDto {
  /** 附件链接 */
  annexUrl = "";

  /** 提交人ID */
  applyUser = undefined;

  /** 提交人备注 */
  applyUserMemo = "";

  /** 提交人名称 */
  applyUserName = "";

  /** 审批状态 -1:未提交审批 0:已驳回 1:已通过 2:审批中 */
  approvalStatus = undefined;

  /** 装箱高 */
  boxHeightCm = undefined;

  /** 装箱长 */
  boxLongCm = undefined;

  /** 装箱宽 */
  boxWidthCm = undefined;

  /** 品牌名称（CN） */
  brandNameCn = "";

  /** 品牌编号 */
  brandNo = "";

  /** BU编码 */
  buCode = undefined;

  /** BU名称 */
  buName = "";

  /** 产品认证类型 */
  certificationType = "";

  /** 海关要素NO */
  cino = "";

  /** 是否商检 */
  commodityInspectionFlag = false;

  /** 质检确认箱规-高 */
  confirmBoxHeightCm = undefined;

  /** 质检确认箱规-长 */
  confirmBoxLongCm = undefined;

  /** 质检确认箱规-宽 */
  confirmBoxWidthCm = undefined;

  /** 质检确认产品包装高（CM） */
  confirmPackHeightCm = undefined;

  /** 质检确认产品包装长（CM） */
  confirmPackLongCm = undefined;

  /** 质检确认产品包装重量（G） */
  confirmPackWeight = undefined;

  /** 质检确认产品包装宽（CM） */
  confirmPackWidthCm = undefined;

  /** 质检确认单箱体积重 */
  confirmSingleBoxVolumeWeight = undefined;

  /** 质检确认单箱毛重 */
  confirmSinglePackingWeight = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当前审批步骤 */
  currentApprovalStep = "";

  /** 海关监管条件 */
  customsControl = "";

  /** 法定海关单位 */
  customsUnit = "";

  /** 申报要素 */
  declareMemo = "";

  /** 申报名称（CN） */
  declareNameCn = "";

  /** 申报名称（EN） */
  declareNameEn = "";

  /** 是否申报型号 */
  declareTypeFlag = false;

  /** 删除标识 */
  deleted = undefined;

  /** 产品交期 */
  deliveryDay = undefined;

  /** 描述 */
  description = "";

  /** 预计下单时间 */
  expectOrderTime = "";

  /** 预计上架时间 */
  expectShelveTime = "";

  /** 产品高 */
  heightCm = undefined;

  /** HSCODE(国内) */
  hscodeCn = "";

  /** HSCODE(国外) */
  hscodeEn = "";

  /** id */
  id = undefined;

  /** 图片链接 */
  imageUrl = "";

  /** 产品初始分级 */
  initLevelNum = "";

  /** 检疫检验类别 */
  inspectionType = "";

  /** 工作流实例ID */
  instanceId = undefined;

  /** 开票单位名称 */
  invoiceUnitName = "";

  /** 开票单位 */
  invoiceUnitNo = "";

  /** 是否研发产品：false or true */
  isDevolopFlag = false;

  /** 是否需要厂检 */
  isFactoryCheck = undefined;

  /** 是否需要质检 */
  isWarehouseCheck = undefined;

  /** 产品分级 */
  levelNum = "";

  /** 版本 */
  lockVersion = undefined;

  /** 物流周期 */
  logisticsCycle = undefined;

  /** 产品长 */
  longCm = undefined;

  /** 产品材质名称（CN） */
  materialNameCn = "";

  /** 产品材质名称（EN） */
  materialNameEn = "";

  /** 每箱数量（MPQ） */
  mpq = undefined;

  /** MQ推送状态: -1 未推送 0 推送失败 1推送成功 */
  mqSendStatus = undefined;

  /** 新品类型(brand_new:全新品;spu_expand_new:spu拓展新品) */
  newProductType = "";

  /** NS消费状态：-1 未消费 0消费失败 1消费成功 */
  nsConsumeStatus = undefined;

  /** 产品包装高 */
  packHeightCm = undefined;

  /** 产品包装长 */
  packLongCm = undefined;

  /** 产品包装重量（g） */
  packWeight = undefined;

  /** 产品包装宽 */
  packWidthCm = undefined;

  /** 计划员 */
  planner = "";

  /** spu产品id */
  productKey = "";

  /** 是否产品化管理 */
  productManagementFlag = false;

  /** 产品编号 */
  productNo = "";

  /** 产品负责人 */
  productOwner = "";

  /** 产品负责人名称 */
  productOwnerName = "";

  /** 产品用途（CN） */
  productUseCn = "";

  /** 产品用途（EN） */
  productUseEn = "";

  /** 生产周期 */
  productionCycle = undefined;

  /** 项目经理用户编码 */
  projectManager = "";

  /** 采购单位名称 */
  purchaseUnitName = "";

  /** 采购单位 */
  purchaseUnitNo = "";

  /** 采购负责人 */
  purchaser = "";

  /** 数量 */
  qty = undefined;

  /** 出口退税率 */
  rebateRate = undefined;

  /** 驳回人ID */
  rejecter = undefined;

  /** 驳回人名称 */
  rejecterName = "";

  /** 备注 */
  remark = "";

  /** 产品销售链接 */
  salesLink = "";

  /** 产品销售价格 */
  salesPrice = undefined;

  /** 副产品负责人 */
  secondOwner = "";

  /** 副产品负责人名称 */
  secondOwnerName = "";

  /** 默认运输方式名称 */
  shippingMethodName = "";

  /** 默认运输方式编号 */
  shippingMethodNo = "";

  /** 单个产品计费重（g） */
  singleBillingWeight = undefined;

  /** 装箱体积（CM3） */
  singleBoxVolume = undefined;

  /** 单个产品装箱体积重(g) */
  singleBoxVolumeWeight = undefined;

  /** 单箱净重 */
  singlePackingSuttleWeight = undefined;

  /** 单个产品装箱重量(g) */
  singlePackingWeight = undefined;

  /** SKU简称 */
  skuAbbreviation = "";

  /** sku产品id */
  skuKey = "";

  /** SKU型号 */
  skuModel = "";

  /** SKU编号 */
  skuNo = "";

  /** SKU标题（CN） */
  skuTitleCn = "";

  /** SKU标题（EN） */
  skuTitleEn = "";

  /** 是否特批 */
  specialPermitFlag = false;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 计量单位名称 */
  unitName = "";

  /** 计量单位编号 */
  unitNo = "";

  /** 单位类型名称 */
  unitTypeName = "";

  /** 单位类型编号 */
  unitTypeNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 默认供应商名称 */
  vendorName = "";

  /** 默认供应商编号 */
  vendorNo = "";

  /** 体积重 */
  volumeWeight = undefined;

  /** 产品重量（g） */
  weight = undefined;

  /** 产品宽 */
  widthCm = undefined;
}

class SpuAndCorpsInfoResponseDto {
  /** 一级品类名称 */
  categoryName = "";

  /** 军团长code */
  commanderCode = "";

  /** 军团长名字 */
  commanderName = "";

  /** 军团名称 */
  corpsName = "";

  /** 财务bp编码 */
  financeBpCode = "";

  /** 财务bp名字 */
  financeBpName = "";

  /** 运营对接人编码 */
  operatorCode = "";

  /** 运营对接人名字 */
  operatorName = "";

  /** 一级类目编号 */
  primaryProductLine = "";

  /** spu编号 */
  spuNo = "";
}

class SpuCorpResponseRpcDto {
  /** 一级品类名称 */
  categoryName = "";

  /** 军团长code */
  commanderCode = "";

  /** 军团长名字 */
  commanderName = "";

  /** 军团名称 */
  corpsName = "";

  /** 财务bp编码 */
  financeBpCode = "";

  /** 财务bp名字 */
  financeBpName = "";

  /** 运营对接人编码 */
  operatorCode = "";

  /** 运营对接人名字 */
  operatorName = "";

  /** 一级类目编号 */
  primaryProductLine = "";

  /** spu编号 */
  spuNo = "";
}

class StaffPaymentInfoAddRequestDto {
  /** 银行名称 */
  bankName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 是否启用 0 否 1 是 */
  enableFlag = undefined;

  /** id */
  id = undefined;

  /** 员工工号 */
  jobNumber = "";

  /** 员工类型 */
  jobType = "";

  /** 版本 */
  lockVersion = undefined;

  /** 收款账号 */
  receiptAccount = "";

  /** 开户行 */
  receiptBank = "";

  /** 开户行城市 */
  receiptCity = "";

  /** 收款人 */
  receiptName = "";

  /** 开户行省份 */
  receiptProvince = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class StaffPaymentInfoRequestDto {
  /** 银行名称 */
  bankName = "";

  /** 是否启用 0 否 1 是 */
  enableFlag = undefined;

  /** id */
  id = undefined;

  /** 员工工号 */
  jobNumber = "";

  /** 员工类型 */
  jobType = "";

  /** 收款账号 */
  receiptAccount = "";

  /** 开户行 */
  receiptBank = "";

  /** 开户行城市 */
  receiptCity = "";

  /** 收款人 */
  receiptName = "";

  /** 开户行省份 */
  receiptProvince = "";
}

class StaffPaymentInfoRequestParamsDto {
  /** 银行名称 */
  bankName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 是否启用 0 否 1 是 */
  enableFlag = undefined;

  /** id */
  id = undefined;

  /** 员工工号 */
  jobNumber = "";

  /** 员工类型 */
  jobType = "";

  /** 版本 */
  lockVersion = undefined;

  /** 收款账号 */
  receiptAccount = "";

  /** 开户行 */
  receiptBank = "";

  /** 开户行城市 */
  receiptCity = "";

  /** 收款人 */
  receiptName = "";

  /** 开户行省份 */
  receiptProvince = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class StaffPaymentInfoResponse {
  /** 银行名称 */
  bankName = "";

  /** 是否启用 0 否 1 是 */
  enableFlag = undefined;

  /** id */
  id = undefined;

  /** 员工工号 */
  jobNumber = "";

  /** 员工类型 */
  jobType = "";

  /** 收款账号 */
  receiptAccount = "";

  /** 开户行 */
  receiptBank = "";

  /** 开户行城市 */
  receiptCity = "";

  /** 收款人 */
  receiptName = "";

  /** 开户行省份 */
  receiptProvince = "";
}

class StaffPaymentInfoResponseDto {
  /** 银行名称 */
  bankName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 是否启用 0 否 1 是 */
  enableFlag = undefined;

  /** id */
  id = undefined;

  /** 员工工号 */
  jobNumber = "";

  /** 员工类型 */
  jobType = "";

  /** 版本 */
  lockVersion = undefined;

  /** 收款账号 */
  receiptAccount = "";

  /** 开户行 */
  receiptBank = "";

  /** 开户行城市 */
  receiptCity = "";

  /** 收款人 */
  receiptName = "";

  /** 开户行省份 */
  receiptProvince = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class StateCheckRequestDto {
  /** 国家二字码 */
  secondWord = "";

  /** 省/洲名称集合 */
  stateNameCnColl = [];
}

class SysGlobalParamChangeStatusRequestDto {
  /** id（修改时提交） */
  id = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;
}

class SysGlobalParamRequestDto {
  /** 描述 */
  description = "";

  /** id（修改时提交） */
  id = undefined;

  /** 参数名称 */
  keyName = "";

  /** 参数值 */
  keyValue = "";

  /** 状态：1启用 or 0停用 */
  status = undefined;
}

class SysGlobalParamResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 描述 */
  description = "";

  /** id */
  id = undefined;

  /** 参数名称 */
  keyName = "";

  /** 参数值 */
  keyValue = "";

  /** 版本 */
  lockVersion = undefined;

  /** 状态：1启用 or 0停用 */
  status = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class TaskDto {
  /** 节点编码 */
  nodeKey = "";

  /** 节点名称 */
  nodeName = "";

  /** 任务id */
  taskId = "";
}

class TaskGetDataRequestDto {
  /** currentPage */
  currentPage = undefined;

  /** dataType */
  dataType = [];

  /** pageSize */
  pageSize = undefined;
}

class TimelinessDashboardAllotToModel {
  /** 调拨批次号 */
  abno = "";

  /** TO创建时间 */
  aoCreateTime = "";

  /** 调拨单号 */
  aono = "";

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createName = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 到FBA时间 */
  fbaTime = "";

  /** 版本 */
  lockVersion = undefined;

  /** 运输方式 */
  logisticsMode = "";

  /** 已出库数量 */
  outQty = undefined;

  /** 出库时间 */
  outTime = "";

  /** 打包装箱完成时间 */
  packboxTime = "";

  /** sku编号 */
  skuNo = "";

  /** 调拨状态 */
  status = undefined;

  /** 时效看板NO */
  tdno = "";

  /** 修改人 */
  updateBy = "";

  /** 修改人名称 */
  updateName = "";

  /** 修改时间 */
  updateTime = "";
}

class TimelinessDashboardModel {
  /** 业务标识 */
  businessFlag = "";

  /** 业务数据(首批入库数量) */
  businessInt = undefined;

  /** 业务时间 */
  businessTime = "";

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createName = "";

  /** 创建时间 */
  createTime = "";

  /** 当前流程接收时间 */
  currentAcceptTime = "";

  /** 当前流程完成时间 */
  currentCompleteTime = "";

  /** 当前流程业务单据号 */
  currentOrderNo = "";

  /** 当前任务阶段编码 */
  currentPhase = undefined;

  /** 当前任务阶段名称 */
  currentPhaseName = "";

  /** 删除标识 */
  deleted = undefined;

  /** 是否超期 */
  exceedFlag = false;

  /** 超期是否解决 */
  exceedSolvedFlag = false;

  /** 预计完成时间 */
  expectCompleteTime = "";

  /** 下个流程接收时间 */
  forwardAcceptTime = "";

  /** 下个流程完成时间 */
  forwardCompleteTime = "";

  /** 下个流程业务单据号 */
  forwardOrderNo = "";

  /** 下个任务阶段编码 */
  forwardPhase = undefined;

  /** 下个任务阶段名称 */
  forwardPhaseName = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 通知角色 */
  noticeRole = "";

  /** 通知类型：指定用户编码designated_person、指定角色designated_role */
  noticeType = "";

  /** 通知用户编码(多个用,分割) */
  noticeUserCode = "";

  /** 上个流程接收时间 */
  previousAcceptTime = "";

  /** 上个流程完成时间 */
  previousCompleteTime = "";

  /** 上个流程业务单据号 */
  previousOrderNo = "";

  /** 上个任务阶段编码 */
  previousPhase = undefined;

  /** 上个任务阶段名称 */
  previousPhaseName = "";

  /** 时效看板NO */
  tdno = "";

  /** 当前流程时效 */
  timeliness = undefined;

  /** 时效开始时间 */
  timelinessBegin = "";

  /** 时效结束时间 */
  timelinessEnd = "";

  /** 时效超期 */
  timelinessExceed = undefined;

  /** 时效剩余 */
  timelinessResidue = undefined;

  /** 时效预警时间 */
  timelinessWarn = "";

  /** 修改人 */
  updateBy = "";

  /** 修改人名称 */
  updateName = "";

  /** 修改时间 */
  updateTime = "";

  /** 是否预警 */
  warnFlag = false;

  /** 预警是否解决 */
  warnSolvedFlag = false;
}

class TimelinessDashboardProcessPhaseRequestDto {
  /** 首批入库数量(采购入库阶段) */
  inboundQty = undefined;

  /** 单据号 */
  orderNo = "";

  /** 时效阶段 */
  processPhase = "ALLOT_CREATE";

  /** 处理时间 */
  processTime = "";

  /** 运输方式code(打包装箱) */
  shippingTypeCode = undefined;

  /** sku编号 */
  skuNo = "";

  /** 入库目标仓库(采购入库阶段) */
  warehouseDirection = "FACTORY";
}

class TimelinessDashboardResponseDto {
  /** 调拨看板-物流运输看板-空运时效 */
  airLogisticsMonitor = new TimelinessDashboardModel();

  /** 调拨看板-调拨单创建时效 */
  allotCreateMonitor = new TimelinessDashboardModel();

  /** 业务状态 */
  bizStatus = "";

  /** BOM看板-BOM时效 */
  bomMonitor = new TimelinessDashboardModel();

  /** BU编码 */
  buCode = undefined;

  /** BU名称 */
  buName = "";

  /** 品类编码 */
  categoryNo = "";

  /** 品类full */
  categoryNoFull = "";

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createName = "";

  /** 立项时间 */
  createProjectTime = "";

  /** 创建时间 */
  createTime = "";

  /** 当前负责人 */
  currentProcessor = "";

  /** 当前处理人编号 */
  currentProcessorCode = "";

  /** 当前处理人类型：指定人、指定角色 */
  currentProcessorType = "";

  /** 删除标识 */
  deleted = undefined;

  /** 开发模式(review:新品评审;research:研发立项) */
  developmentMode = "";

  /** 预计上架时间 */
  expectShelveTime = "";

  /** 预计上架时间（实时更新） */
  expectShelveTimeReal = "";

  /** 预计前三月销售总量 */
  expectTotalSalesQty = undefined;

  /** 预计销售单价（CNY) */
  expectUnitPriceCny = undefined;

  /** 工厂库存 */
  factoryInventory = undefined;

  /** 采购看板-采购入库时效-入工厂仓时效 */
  factoryPurchaseInMonitor = new TimelinessDashboardModel();

  /** FBA在库库存 */
  fbaInventory = undefined;

  /** FBA在途库存 */
  fbaOnPassageInventory = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 新品类型(brand_new:全新品;spu_expand_new:spu拓展新品) */
  newProductType = "";

  /** 新品下单看板-新品下单时效 */
  orderMonitor = new TimelinessDashboardModel();

  /** 海外在库库存 */
  overseaInventory = undefined;

  /** 海外仓在途库存 */
  overseaOnPassageInventory = undefined;

  /** 样品确认看板-包装时效 */
  packageMonitor = new TimelinessDashboardModel();

  /** 调拨看板-打包装箱时效 */
  packboxMonitor = new TimelinessDashboardModel();

  /** 计划员 */
  planner = "";

  /** 计划员名称 */
  plannerName = "";

  /** 新品下单看板-pr单列表 */
  prList = [];

  /** 样品准备看板-样品准备时效 */
  prepareMonitor = new TimelinessDashboardModel();

  /** 样品确认看板-核价时效 */
  priceMonitor = new TimelinessDashboardModel();

  /** 流转状态:0=默认,20=样品准备,40=样品确认,60=BOM,80=新品下单,100=采购单创建,120=采购入库,140=调拨单创建,160=打包装箱,180=调拨发运,200=物流运输,1000=已完成 */
  processPhase = undefined;

  /** spu产品id */
  productKey = "";

  /** 产品等级code */
  productLevelCode = "";

  /** 产品名称（CN） */
  productNameCn = "";

  /** spu编号 */
  productNo = "";

  /** 产品负责人 */
  productOwner = "";

  /** 产品负责人名称 */
  productOwnerName = "";

  /** 采购看板-采购订单PO创建时效 */
  purchaseCreateMonitor = new TimelinessDashboardModel();

  /** 采购负责人 */
  purchaser = "";

  /** 采购负责人名称 */
  purchaserName = "";

  /** 采购在途库存 */
  purchaserOnPassageInventory = undefined;

  /** 样品确认看板-质检时效 */
  qualityMonitor = new TimelinessDashboardModel();

  /** 样品确认看板-测试时效 */
  researchMonitor = new TimelinessDashboardModel();

  /** SBU编码 */
  sbuCode = undefined;

  /** 调拨看板-物流运输看板-海运时效 */
  seaLogisticsMonitor = new TimelinessDashboardModel();

  /** sku审批通过时间 */
  skuApprovedTime = "";

  /** sku启用状态 */
  skuEnableFlag = false;

  /** sku产品id */
  skuKey = "";

  /** sku编号 */
  skuNo = "";

  /** sku标题（CN） */
  skuTitleCn = "";

  /** 三水库存 */
  ssInventory = undefined;

  /** 采购看板-采购入库时效-入三水仓时效 */
  ssPurchaseInMonitor = new TimelinessDashboardModel();

  /** 时效看板NO */
  tdno = "";

  /** 调拨看板-物流运输看板-to单列表 */
  toList = [];

  /** 时效设置NO */
  tsno = "";

  /** 修改人 */
  updateBy = "";

  /** 修改人名称 */
  updateName = "";

  /** 修改时间 */
  updateTime = "";

  /** 告警阶段 */
  warnPhase = undefined;

  /** 预警状态:none=未预警,warning=预警中,exceed=超期 */
  warnStatus = "";
}

class TimelinessDashboardWarnRecordResponseDto {
  /** 业务标识 */
  businessFlag = "";

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createName = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 通知角色 */
  noticeRole = "";

  /** 通知类型：指定用户编码、指定角色 */
  noticeType = "";

  /** 通知用户编码 */
  noticeUserCode = "";

  /** 业务单据号 */
  orderNo = "";

  /** 请求内容 */
  request = "";

  /** 响应内容 */
  response = "";

  /** 是否成功 */
  successFlag = false;

  /** 时效看板NO */
  tdno = "";

  /** trace_id */
  traceId = "";

  /** 修改人 */
  updateBy = "";

  /** 修改人名称 */
  updateName = "";

  /** 修改时间 */
  updateTime = "";

  /** 告警阶段 */
  warnPhase = undefined;

  /** 告警阶段名称 */
  warnPhaseName = "";

  /** 告警类型，10=预警，20=超期告警 */
  warnType = undefined;
}

class TimelinessSettingRequestDto {
  /** 调拨单创建时效 */
  allotCreateTimeliness = undefined;

  /** 打包装箱时效 */
  allotPackboxTimeliness = undefined;

  /** 调拨发运总日期（工作日） */
  allotTotalTimeliness = undefined;

  /** 处理BOM时效 */
  bomTimeliness = undefined;

  /** BOM总日期（自然日） */
  bomTotalTimeliness = undefined;

  /** 包装审批时效 */
  confirmPackageTimeliness = undefined;

  /** 成本审批时效 */
  confirmPriceTimeliness = undefined;

  /** 品控质检时效 */
  confirmQualityTimeliness = undefined;

  /** 测试审批时效 */
  confirmResearchTimeliness = undefined;

  /** 样品确定总日期（工作日） */
  confirmTotalTimeliness = undefined;

  /** 是否默认设置:true=是,false=否 */
  defaultFlag = false;

  /** 开发模式(review:新品评审;research:研发立项) */
  developmentMode = "";

  /** id */
  id = undefined;

  /** 到达FBA时效-空运 */
  logisticsFbaAirTimeliness = undefined;

  /** 到达FBA时效-海运 */
  logisticsFbaSeaTimeliness = undefined;

  /** 物流运输总时效（自然日） */
  logisticsTotalTimeliness = undefined;

  /** PR审批通过时效 */
  orderPrApprovedTimeliness = undefined;

  /** 新品下单总日期（工作日） */
  orderTotalTimeliness = undefined;

  /** 样品准备时效 */
  prepareTimeliness = undefined;

  /** 样品准备总日期（自然日） */
  prepareTotalTimeliness = undefined;

  /** 采购订单审批通过时效 */
  purchaseApprovedTimeliness = undefined;

  /** 采购总日期（工作日） */
  purchaseTotalTimeliness = undefined;

  /** SKU产品id */
  skuKey = "";

  /** SKU编号,DEFAULT=默认设置 */
  skuNo = "";

  /** 时效设置NO */
  tsno = "";
}

class TrackerIdentifiersDTO {
  /** links */
  links = [];

  /** trackingNumber */
  trackingNumber = "";

  /** transactionId */
  transactionId = "";
}

class TrackersBatchRequest {
  /** trackers */
  trackers = [];
}

class TrackersBatchResponse {
  /** errors */
  errors = [];

  /** links */
  links = [];

  /** trackerIdentifiers */
  trackerIdentifiers = [];
}

class TrackersDTO {
  /** carrier */
  carrier = "";

  /** carrierNameOther */
  carrierNameOther = "";

  /** status */
  status = "";

  /** trackingNumber */
  trackingNumber = "";

  /** transactionId */
  transactionId = "";
}

class UpdateProductOrderStatusRequestDto {
  /** 新品下单no */
  nponoList = [];

  /** 订单号(PR单号或者PO单号) */
  orderNo = "";

  /** 更新时间 */
  updateTime = "";

  /** 更新类型:pr=已下PR单,po=已下PO单 */
  updateType = "";
}

export const basics = {
  AccountQueryRequestDto,
  AccountResponseDto,
  AmazonDateRangeRulesRequestDto,
  AmazonDateRangeRulesResponseDto,
  AppAccountRequestDto,
  AppAccountRequestParamsDto,
  AppAccountResponseDto,
  AppAccountResponseRpcDto,
  ApprovalBeforeRequestDto,
  ApprovalRequestDto,
  AssigneeDto,
  AssociatedFilesDto,
  AssociatedFilesRequestDto,
  AssociatedFilesResponseDto,
  AuthorizationRecordRequestDto,
  AuthorizationRecordRequestParamsDto,
  AuthorizationRecordRequestParamsRpcDto,
  AuthorizationRecordResponseDto,
  AuthorizationRecordResponseRpcDto,
  BankAccountNumRequest,
  BankInfoRequest,
  BankInfoRequestParamsDto,
  BankInfoResponse,
  BankInfoResponseDto,
  BaseAreaRequestDto,
  BaseAreaResponseDto,
  BaseCityModel,
  BaseCityRequestDto,
  BaseCityRequestParamsDto,
  BaseCityResponseDto,
  BaseCountryModel,
  BaseCountryRequestDto,
  BaseCountryRequestParamsDto,
  BaseCountryResponseDto,
  BaseCountryTreeResponseDto,
  BaseCountryTreeResponseRpcDto,
  BaseDictionaryCreateDto,
  BaseDictionaryEditDto,
  BaseDictionaryQueryDto,
  BaseDictionaryResponseDto,
  BaseDictionaryResponseRpcDto,
  BaseStateModel,
  BaseStateRequestDto,
  BaseStateRequestParamsDto,
  BaseStateResponseDto,
  BaseStateTreeResponseRpcDto,
  BaseUnitModel,
  BaseUnitRequestDto,
  BaseUnitRequestParamsDto,
  BaseUnitResponseDto,
  BaseUnitTypeDetailsResponseDto,
  BaseUnitTypeModel,
  BaseUnitTypeRequestDto,
  BaseUnitTypeRequestParamsDto,
  BaseUnitTypeResponseDto,
  BatchAssociatedFilesRequestDto,
  BuSbuModel,
  BuSbuRequestParamsDto,
  BuSbuResponseDtoRpc,
  BusinessCustomerAccountDetailResponseDto,
  BusinessCustomerAddOrUpdateAccountRequestDto,
  BusinessCustomerAddOrUpdateReceivingAddressRequestDto,
  BusinessCustomerAddOrUpdateTransactionCompanyRequestDto,
  BusinessCustomerApprovalPageListResponseDto,
  BusinessCustomerChangeDetailResponseDto,
  BusinessCustomerDetailResponseDto,
  BusinessCustomerListResponseDto,
  BusinessCustomerListResponseDto0,
  BusinessCustomerPageListResponseDto,
  BusinessCustomerReceivingAddressDetailResponseDto,
  BusinessCustomerTransactionCompanyDetailResponseDto,
  CenterCountyMappingRequestDto,
  CenterCountyMappingRequestParamsDto,
  CenterCountyMappingResponseDto,
  CertBatteryRequestDto,
  CertBatteryResponseDto,
  CertFileRequestDto,
  CertFileResponseDto,
  CertMainInfoRequestDto,
  CertMainRequestDto,
  CertMainResponseDto,
  CertMainSkuRequestDto,
  CertMainSkuResponseDto,
  CertPictureResponseDto,
  CertPictureResponseDto0,
  CertificationDocumentAddAndModifyRequestDto,
  CertificationDocumentBatteryAddAndModifyRequestDto,
  CertificationDocumentDetailResponseDto,
  CertificationDocumentListResponseDto,
  CertificationDocumentPageResponseDto,
  CorpsInfoRequestDto,
  CorpsInfoResponseDto,
  CostCenterAddOrUpdateRequestParamsDto,
  CostCenterListResponseDto,
  CostCenterListRpcRequestDto,
  CostItemMappingRequestDto,
  CostItemMappingRequestParamsDto,
  CostItemMappingRequestRpcDto,
  CostItemMappingRequestRpcParamsDto,
  CostItemMappingResponseDto,
  CountryResponseDto,
  CurrentTaskDto,
  CustomsDetailRequestDto,
  CustomsDetailResponseDto,
  CustomsInfoRequestDto,
  CustomsInfoResponseDto,
  CustomsInfosResponseDto,
  DetailsDTO,
  EbsBankOutputParameters,
  EbsExchangeRateModel,
  EbsFeedBackRequestDto,
  EbsFeedBackResponseDto,
  EbsPageInfo,
  EbsRateRequest,
  EbsRateResponse,
  ErrorsDTO,
  ExchangeRateBodyItem,
  ExchangeRateQuery,
  ExchangeRateRequest,
  ExchangeRateResponse,
  ExchangeRateReturnBody,
  FinanceAccountDesensitizationResponseDto,
  FinanceAccountRequestDto,
  FinanceAccountRequestParamsDto,
  FinanceAccountResponseDto,
  FinanceAccountResponseRpcDto,
  FreshdeskDataReportManageImportRequestDto,
  FreshdeskDataReportManagePageListRequestDto,
  FreshdeskDataReportManagePageResponseDto,
  HolidayManagementCreateRequestParamsDto,
  HolidayManagementListResponseDto,
  HolidayManagementListRpcResponseDto,
  HolidayManagementRequestParamsDto,
  HolidayManagementRpcRequestParamsDto,
  IPage,
  InterfaceLines,
  LabelDepartmentInfoRequestDto,
  LabelDepartmentInfoRequestParamsDto,
  LabelDepartmentInfoResponseDto,
  LabelInfoQueryDto,
  LabelInfoRequestDto,
  LabelInfoRequestParamsDto,
  LabelInfoResponseDto,
  LabelInfoTreeResponseDto,
  LinksDTO,
  ListingQuoteModel,
  ListingQuoteRequestDto,
  ListingQuoteRequestParamsDto,
  ListingQuoteRpcRequestDto,
  ListingQuoteRpcResponseDto,
  ListingQuoteUpdateRequestDto,
  LogisticsAttrModel,
  LogisticsAttrRequestDto,
  LogisticsAttrRequestParamsDto,
  LogisticsAttrResponseDto,
  LogisticsAttrTypeDetailsResponseDto,
  LogisticsAttrTypeModel,
  LogisticsAttrTypeRequestDto,
  LogisticsAttrTypeRequestParamsDto,
  LogisticsAttrTypeResponseDto,
  LogisticsGroupAttrModel,
  LogisticsGroupAttrRequestDto,
  LogisticsGroupAttrRequestParamsDto,
  LogisticsGroupAttrResponseDto,
  LogisticsGroupDetailsResponseDto,
  LogisticsGroupModel,
  LogisticsGroupRequestDto,
  LogisticsGroupRequestParamsDto,
  LogisticsGroupResponseDto,
  OrderCompanyAccountResponseDto,
  OrderCompanyAccountRpcResponseDto,
  OrderCompanyAccountSaveDto,
  OrderCompanyDetailDto,
  OrderCompanyModel,
  OrderCompanyRequestParamsDto,
  OrderCompanyResponseDto,
  OrderCompanyRpcRequestDto,
  OrderCompanyRpcResponseDto,
  OrderCompanySaveDto,
  OwnershipChannelResponseDto,
  PQueryInfo,
  PdaVersionResponseDto,
  PdaVersionUpdateResponseDto,
  PlatformAppTokenRequestDto,
  PlatformRequestDto,
  PlatformResponseDto,
  PlatformShopRequestDto,
  PlatformShopResponseDto,
  PlatformShopsRequestPatamsDto,
  PlatformShopsResponseDto,
  PlatformSiteRequestDto,
  PlatformSiteResponseDto,
  PlatformSiteRpcResponseDto,
  PlatformSiteShopAndAppAccountQueryRequestDto,
  PlatformSiteShopAndAppAccountResponseDto,
  PlatformSiteShopDesensitizationResponseDto,
  PlatformSiteShopQueryRequestDto,
  PlatformSiteShopRelevanceResponseDto,
  PlatformSiteShopRequestDto,
  PlatformSiteShopRequestParamsDto,
  PlatformSiteShopResponseDto,
  PlmBomAddOutGoingRequestDto,
  PlmBomChildRequestDto,
  PlmBomCreateRequestDto,
  PlmBomListResponseDto,
  PlmBomOutCreateRequestDto,
  PlmBomOutSupplyApprovalRequestDto,
  PlmBomOutgoingDetailResponseDto,
  PlmBomOutgoingItemRequestDto,
  PlmBomOutgoingItemRequestParamsDto,
  PlmBomOutgoingItemResponseDto,
  PlmBomOutgoingListResponseDto,
  PlmBomOutgoingRequestParamsDto,
  PlmBomOutgoingSkuResponseDto,
  PlmCategoryListResponseDto,
  PlmCategoryListResponseRpcDto,
  PlmCategoryRequestParamsDto,
  PlmCategoryTreeResponseDto,
  PlmMaterialCategoryRequestParamsDto,
  PlmMaterialCategoryResponseDto,
  PlmMaterialCreateRequestDto,
  PlmNewOrderApprovalRequestDto,
  PlmNewOrderDemandCreateRequestDto,
  PlmNewOrderDemandDetailResponseDto,
  PlmPurchaseRequisitionDto,
  PlmSkuApprovalRequestDto,
  PlmSkuBillingResponseDto,
  PlmSkuBillingResponseRpcDto,
  PlmSkuBomDetailResponseDto,
  PlmSkuBomTreeResponseDto,
  PlmSkuBriefDetailDto,
  PlmSkuBriefDetailResponseRpcDto,
  PlmSkuBriefInfoDto,
  PlmSkuCostInfoRequestDto,
  PlmSkuCreateRequestDto,
  PlmSkuCustomsClearanceResponseDto,
  PlmSkuCustomsClearanceResponseRpcDto,
  PlmSkuCustomsEditRequestDto,
  PlmSkuCustomsResponseDto,
  PlmSkuCustomsResponseRpcDto,
  PlmSkuDetailInfoResponseDto,
  PlmSkuDetailInfoResponseRpcDto,
  PlmSkuEditHistoryRequestDto,
  PlmSkuEditRequestDto,
  PlmSkuForecastApprovalRequestDto,
  PlmSkuForecastCreateRequestDto,
  PlmSkuForecastDetailRequestDto,
  PlmSkuForecastDetailResponseDto,
  PlmSkuForecastInfoRequestDto,
  PlmSkuForecastInfoResponseDto,
  PlmSkuForecastResponseDto,
  PlmSkuListForecastResponseDto,
  PlmSkuListResponseDto,
  PlmSkuListResponseRpcDto,
  PlmSkuManageEditRequestDto,
  PlmSkuManageResponseDto,
  PlmSkuManageResponseRpcDto,
  PlmSkuNewOrderCreateRequestDto,
  PlmSkuNewOrderDetailResponseDto,
  PlmSkuNewOrderListResponseDto,
  PlmSkuNewOrderRequestParamsDto,
  PlmSkuPackageInfoResponseRpcDto,
  PlmSkuPackageResponseDto,
  PlmSkuPackageResponseRpcDto,
  PlmSkuProductLineAndCorpsRpcDto,
  PlmSkuRequestParamsDto,
  PlmSkuRequestParamsRpcDto,
  PlmSkuSaleEditRequestDto,
  PlmSkuSimpleResponseRpcDto,
  PlmSkuVendorResponseDto,
  PlmSkuVendorResponseRpcDto,
  PlmSkuVendorRpcRequestDto,
  PlmSkuWarehousePackageRequestDto,
  PlmSkuWarehousePackageResponseDto,
  PlmSkuWarehousePackageRootRequestDto,
  PlmSkuWarehousePackageRootResponseDto,
  PlmSkuWarehousePackageRpcRequestDto,
  PlmSkuWarehousePackageRpcResponseDto,
  PlmSpuBriefInfoResponseDto,
  PlmSpuBriefInfoResponseRpcDto,
  PlmSpuCreateRequestDto,
  PlmSpuDetailResponseDto,
  PlmSpuListResponseDto,
  PlmSpuListResponseRpcDto,
  PlmSpuRequestParamsDto,
  ProductBomApprovalRequestDto,
  ProductBomInvalidRequestDto,
  ProductBomRequestDto,
  ProductBomResponseDto,
  ProductBrandModel,
  ProductBrandRequestDto,
  ProductBrandRequestParamsDto,
  ProductBrandResponseDto,
  ProductCategroyModel,
  ProductCategroyRequestDto,
  ProductCategroyRequestParamsDto,
  ProductCategroyResponseDto,
  ProductCategroyResponseDtoRpc,
  ProductCategroyTreeResponseDto,
  ProductConfirmAcceptRequestDto,
  ProductConfirmApprovalRequestDto,
  ProductConfirmCommitRequestDto,
  ProductConfirmFileRequestDto,
  ProductConfirmFileResponseDto,
  ProductConfirmInvalidRequestDto,
  ProductConfirmRequestDto,
  ProductConfirmResponseDto,
  ProductDeclareInfoResponseDto,
  ProductDeclareInforequestDto,
  ProductMasterApprovalRequestDto,
  ProductMasterModel,
  ProductMasterRequestDto,
  ProductMasterRequestDtoRPC,
  ProductMasterRequestParamsDto,
  ProductMasterResponseDto,
  ProductMaterialModel,
  ProductMaterialRequestDto,
  ProductMaterialRequestParamsDto,
  ProductMaterialResponseDto,
  ProductOrderApprovalRequestDto,
  ProductOrderDemandDetailRequestDto,
  ProductOrderDemandDetailResponseDto,
  ProductOrderRequestDto,
  ProductOrderResponseDto,
  ProductResponseDto,
  ProductSkuApprovalRequestDto,
  ProductSkuCustomsRequestDto,
  ProductSkuCustomsRequestDto0,
  ProductSkuForecastRequestDto,
  ProductSkuForecastResponseDto,
  ProductSkuModel,
  ProductSkuRequestDto,
  ProductSkuRequestDtoRPC,
  ProductSkuRequestParamsDto,
  ProductSkuResponseDto,
  ProductSkuUpdateRequestDto,
  ProductTimelinessSettingResponseDto,
  ProductTypeModel,
  ProductTypeRequestDto,
  ProductTypeRequestParamsDto,
  ProductTypeResponseDto,
  PurchaseCustomsInfoRequestDto,
  PurchasePoOrderDto,
  PurchaseRequisitionCreateRequestDto,
  PurchaseRequisitionDto,
  PurchaseRequisitionRpcResponseDto,
  ResearchItemCreateRequestDto,
  ResearchItemUpdateRequestDto,
  Response,
  ResponseDto,
  ResultRec,
  RevenueDepartmentDetailResponseDto,
  RevenueDepartmentRequestDto,
  RevenueDepartmentRequestParamsDto,
  RevenueDepartmentResponseDto,
  SalesChannelRequestDto,
  SalesChannelResponseDto,
  SalesChannelRpcResponseDto,
  SaveFiledDto,
  ShopInfo,
  SkuCorpsInfoAndCategoryRpcResponseDto,
  SkuListAndStatusRequestDto,
  SkuListResponseDto,
  SkuNoAndNameResponseDto,
  SkuPurchaseRequisitionRpcResponseDto,
  SkuResponseDto,
  SpuAndCorpsInfoResponseDto,
  SpuCorpResponseRpcDto,
  StaffPaymentInfoAddRequestDto,
  StaffPaymentInfoRequestDto,
  StaffPaymentInfoRequestParamsDto,
  StaffPaymentInfoResponse,
  StaffPaymentInfoResponseDto,
  StateCheckRequestDto,
  SysGlobalParamChangeStatusRequestDto,
  SysGlobalParamRequestDto,
  SysGlobalParamResponseDto,
  TaskDto,
  TaskGetDataRequestDto,
  TimelinessDashboardAllotToModel,
  TimelinessDashboardModel,
  TimelinessDashboardProcessPhaseRequestDto,
  TimelinessDashboardResponseDto,
  TimelinessDashboardWarnRecordResponseDto,
  TimelinessSettingRequestDto,
  TrackerIdentifiersDTO,
  TrackersBatchRequest,
  TrackersBatchResponse,
  TrackersDTO,
  UpdateProductOrderStatusRequestDto,
};
